/* eslint-disable no-const-assign */
import React, { Component } from "react";
import ReactDOM from "react-dom";
import { Link, withRouter } from "react-router-dom";
import moment from "moment";
import _ from "lodash";
import "./../../../assets/css/requestimates.css";
import Requestimate from "./requestimate";
import RequestimateState from "./requestimateState";
import TechRequestPanel from "../technician/TechRequestPanel";
import { SelectCalendar } from "./../../partial/selectCalendar";
import DeleteOrLossModal from "./../../partial/DeleteOrLossModal";
import DepositRefundModal from "./../../partial/DepositRefundModal";
import ItemMaterialCaptureModal from "./../../partial/ItemMaterialCaptureModal";
import ServiceItemsModal from "./../../partial/ServiceItemsModal";
import StepAssignmentModal from "./../../partial/StepAssignmentModal";
import ItemCompletionGuardModal from "./../../partial/ItemCompletionGuardModal";
import VINRequiredModal from "./../../partial/VINRequiredModal";
import CarFaxDataModal from "./../../partial/CarFaxDataModal";
import ReopenJobModal from "./../../partial/ReopenJobModal";
import StripeRecoveryModal from "./../../partial/StripeRecoveryModal";
import { Modal, Button, Form, Badge } from 'react-bootstrap';
import { isMultiLocation, isAllLocations, getLocationName, getLocationBadgeColor, isMultiDealership, isAllDealerships, getDealershipBadgeColor } from "../../../util/locationUtils";
import { isTechnician } from "../../../util/permissions";
import { HTTPService } from "./../../../services/httpService";
import { getRequestsByVin, deleteDraft, getDraft } from "./../../../services/requestimatesService";
import DraftActionPanel from "../../partial/DraftActionPanel";
import { normalizeVin, isPlaceholderVin, findCompletedOtherForVin } from "./../../../util/duplicateDetection";
import { isUncollectedVin, isMarine } from "../../../util/assetType";
import { hasRealInvoice } from "../../../util/deliverGate";
import DuplicateVinModal from "./../../partial/DuplicateVinModal";
import InventoryAPI from "./../../../services/inventoryService";
import { SharedRequestPricing } from "../services/sharedPricingCalculations";
import serviceItemsService from "./../../../services/serviceItemsService";
import { convertToUTC } from "../../../util/convert_timezone";
import { parseDateOnly } from "../../../util/dateDisplayUtils";
import dateService from "../../../services/dateService";
import LocationService from "../../../services/locationService";
import FavoritesAPI from "../../../services/favoritesService";
import ScopeService from "../../../services/scopeService";
import { formatBadgeCount } from "../../../util/badgeUtils";
import { grossDownToTotal, hasExistingDeposit, isActiveDepositRow } from "../../../util/depositUtils";
import { isVoidedPaymentState } from "../../../util/paymentState";
import { canUseJobMessaging } from "../../../util/permissions";
import ReactGA from "react-ga4";
import { toast } from "react-toastify";

//import stripe from 'stripe';
const API = new HTTPService();

const isUnclaimed = (item) => {
  const locId = item.location_id || item.locationId;
  return !locId || locId === 0 || locId === '0';
};

class Requestimates extends Component {
  state = {
    requestimates: [],
    estimates: [],
    requestOffers: [],
    requestStates: [],
    requestNotes: [],
    calendarDays: [],
    excludeDays: [],
    customerId: 0,
    customerName: "",
    customemrEmail: "",
    customerPhone: "",
    selectedRequestimate: {},
    // Draft (incomplete/resumable requestimate) selection — when set, the right
    // column shows DraftActionPanel instead of the normal detail panel.
    selectedDraft: null,
    selectedDraftPayload: null,
    deletingDraft: false,
    selectedInstaller: "",
    // Viewport tracking — on mobile + installer userType we swap the long
    // RequestimateState panel for the compact TechRequestPanel. 1024 is the
    // codebase-wide DESKTOP_BREAKPOINT (calendar/vendors/purchasing use it).
    isMobileViewport: typeof window !== 'undefined' && window.innerWidth < 1024,
    invoice: {},
    activePage: 1,
    installer: {},
    selectedOffer: {},
    selectedOffers: [],
    startDate: new moment().format("YYYY-MM-DD"),
    template: "",
    materials: "",
    vin: "",
    vehicleEntered: {},
    vinGood: false,
    reviewScore: 0,
    selectedPay: "Pay Online",
    checkNumber: "",
    availableDate: {},
    selectedService: 0,
    services: [],
    prevMode: "",
    userType: this.props.userType,
    typeId: this.props.typeId,
    user: this.props.user,
    companyName: this.props.companyName,
    company: this.props.company,
    hiddenList: !!this.props.location?.state?.fromToday,
    fromToday: !!this.props.location?.state?.fromToday,
    showSwipe: false,
    showPO: false,
    paymentState: "idle",           // NEW: Track payment progress state
    paymentError: null,             // NEW: Store payment error messages
    paymentPollInterval: null,      // NEW: Store polling interval ID
    terminalState: "offline",       // Existing, but enhanced
    paymentIntentId: "",
    authenticated: 0,
    calendar: "",
    loading: false,
    rowSelected: false,
    showCalendar: false,
    showHelpVideo: false,
    showDepositModal: false,
    showDeleteOrLossModal: false,
    requestToDelete: null,
    showDepositRefundModal: false,
    depositRefundPayment: null,
    deleteConfirmResult: null,
    showRejectModal: false,
    requestToReject: null,
    vehicleImages: [],

    // CarFax Data State (from checkin/status)
    checkinOdometerReading: null,
    checkinPlate: null,
    checkinCarfaxOptOut: false,

    // CarFax Data Modal State (for handleComplete guard)
    showCarFaxDataModal: false,
    carfaxDataRequest: null,
    carfaxDataServicesArray: null,

    // Split Payment State
    isSplitPayment: false,              // Split payment mode active?
    collectedPayments: [],              // Array of collected split payment records
    splitPaymentAmount: '',             // Input: amount for current split payment
    selectedSplitMethod: null,          // 'Terminal' | 'Online' | 'Cash' | 'Check'
    splitCheckNumber: '',               // Check number for check payments
    finalInvoiceId: null,               // Stripe invoice ID for final invoice
    isProcessingSplitPayment: false,    // Loading state during split payment processing
    isConfirmingSplitPayment: false,    // Awaiting webhook settlement after a reader success
    splitPaymentError: null,            // Error message for split payments
    serverRemainingBalance: null,       // Authoritative amountRemaining from GET /invoices/:id/balance
    serverIsFullyPaid: false,           // Authoritative isFullyPaid flag from the server
    showInvoiceLinkModal: false,        // Show modal with invoice link (for online payments)
    currentInvoiceLink: null,           // Invoice URL for online split payments

    // Draft Invoice State (Invoice at Payment)
    draftPayment: null,                  // { paymentId, amount, paymentToken } when server returns draft
    offlineSettlement: null,             // { settledOffline, paymentMethod, amount, ... } when paid offline, invoice pending
    isMaterializing: false,              // Loading during materialize call

    // Materials Collection State
    categoryConfigs: {},                 // Service category configs (data_collect settings)

    // Technician Assignment State
    technicians: [],                     // List of technicians at this company
    savingInstructions: false,           // Loading state for saving instructions

    // Product Selection State
    categoryHasProducts: {},             // Map of category name -> boolean

    // Service Items State
    showServiceItemsModal: false,        // Show ServiceItemsModal
    serviceItemsModalService: null,      // Service object for ServiceItemsModal
    showStepAssignmentModal: false,      // Show StepAssignmentModal (per-step tech assignment)
    stepAssignmentService: null,         // Service object for StepAssignmentModal
    itemsByServiceId: {},                // Cache: { requestServiceId: [items] }
    showItemGuardModal: false,           // Show ItemCompletionGuardModal
    itemGuardData: null,                 // { serviceName, taskStatus, retryCallback }

    // Per-Item Material Capture State
    showItemCaptureModal: false,
    itemCaptureService: null,            // Service object for ItemMaterialCaptureModal
    itemCaptureItems: [],                // Material items for the modal
    itemCaptureRequest: null,            // Request context for finish callback
    itemCaptureJob: null,                // Job context for finish callback
    itemCaptureMode: null,               // 'single' (finish one service) | 'all' (complete whole job)

    // VIN Required Modal State (for handleCompleteEstimate)
    showVINRequiredModal: false,
    vinRequiredRequest: null,
    vinRequiredStartDate: null,

    // Refresh state
    refreshing: false,

    // Stripe Capability Validation
    stripeCapabilities: {},

    // Filter state
    listFilter: '',
    showFilterDropdown: false,

    // Favorites state
    favoriteIds: new Set(),

    // Completion Confirmation Modal State
    showCompletionConfirmModal: false,
    completionConfirmData: null,

    // Guard 1 (in-flight invoicing) + Guard 3 (duplicate-VIN at invoice) state
    submitting: false,
    showInvoiceDupModal: false,
    invoiceDupData: null,

    // Reopen Job Modal State
    showReopenModal: false,
    reopenRequest: null,

    // Assign Location Modal State (multi-location unclaimed requests)
    showAssignLocationModal: false,
    assignLocationRequest: null,
    assignLocationCallback: null,
    modalSelectedLocationId: '',

    // Dealer invoice Stripe readiness (for installer-viewing-dealer-job recovery flow)
    invoiceReadiness: null,
    readyLocations: null,
    loadingReadyLocations: false,

    // Stripe recovery modal (opened when dealer materialize fails — offers
    // transfer-to-another-location, fix Stripe, recheck readiness).
    stripeRecoveryModal: { open: false, request: null, reason: null, locationName: null, detail: null },

    // Dealer group state
    dealerships: [],
  };

  // Refresh the list data
  handleRefresh = () => {
    this.setState({ refreshing: true });
    window.location.reload();
  };

  handleViewportResize = () => {
    const next = window.innerWidth < 1024;
    if (next !== this.state.isMobileViewport) {
      this.setState({ isMobileViewport: next });
    }
  };

  async componentDidMount() {
    window.addEventListener('resize', this.handleViewportResize);
    this.setupIdleRefresh();
    const { typeId, userType } = this.state;

    // Viewer's user id — appended to list fetches so the server can compute the
    // per-user unread message badge (unread_count) on each row.
    const viewerUserId = ScopeService.getUserId();

    // Determine request endpoint based on userType
    // Fetch ALL requests regardless of location — client-side filtering applied in render()
    const installerRequest = this.buildRequestListUrl(viewerUserId);

    if (userType === "installer") {
      // PARALLEL: Fire all independent API calls at once
      const calLocParam = this.props.selectedLocationId && this.props.selectedLocationId !== 'all'
        ? `?locationId=${this.props.selectedLocationId}` : '';
      const [
        requestimatesResponse,
        installerResponse,
        dealerCalendarResponse,
        installerCalendarResponse,
        estimatesResponse,
        authResponse,
        companiesResponse,
        categoryConfigsResponse,
        techniciansResponse,
        categoryProductsResponse
      ] = await Promise.all([
        API.get(installerRequest),
        API.get(`/installerLocations/${typeId}`),
        API.get(`/dealerCalendars/${typeId}${calLocParam}`),
        API.get(`/installerCalendars/${typeId}${calLocParam}`),
        API.get(`/requestimates/getinstallerestimates/?Id=${typeId}&user_id=${viewerUserId}`),
        API.get(`/installerAuth/${typeId}`),
        API.get(`/userAccess/${this.props.user.User_id}`),
        API.get('/serviceCategoryConfig'),
        API.get(`/users?company_id=${typeId}&user_type=installer`).catch(() => ({ data: [] })),
        InventoryAPI.getProducts(typeId).catch(() => [])
      ]);

      // Process installer data — select location matching selectedLocationId
      const installerData = installerResponse.data;
      const selectedLocId = this.props.selectedLocationId;
      const installer = (selectedLocId && selectedLocId !== 'all'
        ? installerData.find(l => String(l.location_id || l.Location_id) === String(selectedLocId))
        : null) || installerData[0];

      // Process auth data
      const authData = authResponse.data[0] || {};

      // Process assignable staff (owners + technicians)
      const assignableRoles = ['owner', 'manager', 'technician'];
      const techRaw = (techniciansResponse.data || []).filter(u => assignableRoles.includes(u.role));
      const seenIds = new Set();
      const technicians = techRaw.filter(u => {
        if (seenIds.has(u.User_id)) return false;
        seenIds.add(u.User_id);
        return true;
      }).sort((a, b) => (a.user_name || '').localeCompare(b.user_name || ''));

      // Process category configs
      const categoryConfigs = {};
      if (Array.isArray(categoryConfigsResponse.data)) {
        categoryConfigsResponse.data.forEach(config => {
          categoryConfigs[config.category_name] = config;
        });
      }

      // Process category products
      const categoryHasProducts = {};
      const products = Array.isArray(categoryProductsResponse) ? categoryProductsResponse : (categoryProductsResponse?.data || []);
      products.forEach(product => {
        if (product.category_name) {
          categoryHasProducts[product.category_name] = true;
        }
      });

      // Process calendars
      const dealerCalendarDays = dealerCalendarResponse.data || [];
      const installerCalendarDays = installerCalendarResponse.data || [];
      const calendarList = dealerCalendarDays.concat(installerCalendarDays);
      const calendarDays = _.orderBy(calendarList, ["workDate"], ["asc"]);

      // Calculate booked capacity for next 60 days
      let excludeDays = [];
      if (calendarDays.length > 0) {
        const startDate = moment.utc().format("YYYY-MM-DD");
        const totalDuration = 60;

        const bookedArray = calendarDays.filter(
          (day) => moment.utc(day.workDate).diff(startDate) >= 0
        );

        const bookedData = new Array(totalDuration);
        for (let m = 0; m < totalDuration; m++) {
          bookedData[m] = {
            x: m,
            exDate: moment.utc(startDate).add(m, "days").format("YYYY-MM-DD"),
            y: 0,
          };
        }

        for (let k = 0; k < bookedData.length; k++) {
          const matchingWork = bookedArray.filter(
            (work) =>
              moment.utc(work.workDate).format("YYYY-MM-DD") === bookedData[k].exDate
          );
          bookedData[k].y = matchingWork.reduce((result, value) => result + value.capacity, 0);
        }
        excludeDays = bookedData;
      }

      // Combine requestimates and estimates
      const requestimates = requestimatesResponse.data || [];
      const estimates = estimatesResponse.data || [];
      const allRequestimates = _.orderBy(
        requestimates.concat(estimates),
        ["availableDate"],
        ["asc"]
      );

      // Single setState with all data
      this.setState({
        installer,
        authenticated: authData.authenticated,
        calendar: authData.calendar_id,
        companies: companiesResponse.data,
        technicians,
        categoryConfigs,
        categoryHasProducts,
        calendarDays,
        excludeDays,
        estimates,
        requestimates: allRequestimates
      });

      // Stripe capabilities now validated server-side at action time (decision #7)

      // Fetch operating hours for the selected location (for scheduling timestamps)
      await this.fetchOperatingHours(this.props.selectedLocationId);

      await this.clearRequestimate();

    } else if (userType === "dealer" && ScopeService.isDealerGroupUser()) {
      // DEALER GROUP: Fetch requests across all dealerships (no offers needed — read-only)
      const requestimatesResponse = await API.get(installerRequest);
      const requestimates = requestimatesResponse.data || [];

      // Load dealership list for badges/filtering
      const DealerGroupService = (await import('../../../services/dealerGroupService')).default;
      const dealerships = await DealerGroupService.getDealerships(this.props.groupId);

      this.setState({ requestimates, requestOffers: [], dealerships });
    } else {
      // DEALER: Parallel fetch requests and offers
      const [requestimatesResponse, requestOffersResponse] = await Promise.all([
        API.get(installerRequest),
        API.get(`/requestOffered/${typeId}`)
      ]);

      const requestimates = requestimatesResponse.data || [];
      const tempRequestOffers = requestOffersResponse.data || [];
      const requestOffers = tempRequestOffers.filter(
        (item) => item.currentStatus === "accepted"
      );

      this.setState({ requestimates, requestOffers });
    }

    // Load favorites for the visible request IDs
    this.loadFavorites();

    // Auto-select item if navigated from Today View (or other pages)
    const locationState = this.props.location?.state;
    const selectRequestId = locationState?.selectRequestId;
    if (selectRequestId) {
      // fromToday is already set in initial state from props
      // Use setState callback to read data AFTER it's loaded
      this.setState({}, () => {
        const allItems = this.state.requestimates || [];
        const target = allItems.find(item => item.requestId === selectRequestId);
        if (target) {
          this.handleRequestimateSelect(target);
        }
      });
      // Clear the location state to prevent re-selection on refresh
      this.props.history.replace(this.props.location.pathname, {});
    }
  }

  componentDidUpdate(prevProps) {
    // Clear selected requestimate when mode changes (requests <-> jobs <-> pickups)
    // or when filter changes (scheduled <-> inprogress)
    const prevFilter = new URLSearchParams(prevProps.location?.search || '').get('filter');
    const currentFilter = new URLSearchParams(this.props.location?.search || '').get('filter');

    if (prevProps.mode !== this.props.mode || prevFilter !== currentFilter) {
      this.setState({
        selectedRequestimate: {},
        selectedDraft: null,
        selectedDraftPayload: null,
        vehicleImages: [],
        checkinOdometerReading: null,
        checkinPlate: null,
        checkinCarfaxOptOut: false,
        listFilter: '',
        showFilterDropdown: false,
        fromToday: false,
        hiddenList: false
      });
    }

    // Handle navigation from Today View (or other pages) when component is already mounted
    const prevSelectId = prevProps.location?.state?.selectRequestId;
    const newSelectId = this.props.location?.state?.selectRequestId;
    if (newSelectId && newSelectId !== prevSelectId) {
      const isFromToday = !!this.props.location?.state?.fromToday;
      if (isFromToday) {
        this.setState({ fromToday: true, hiddenList: true });
      }
      const allItems = this.state.requestimates || [];
      const target = allItems.find(item => item.requestId === newSelectId);
      if (target) {
        this.handleRequestimateSelect(target);
      }
      this.props.history.replace(this.props.location.pathname, {});
    }
  }

  componentWillUnmount() {
  window.removeEventListener('resize', this.handleViewportResize);
  this.teardownIdleRefresh();
  if (this.availabilityTimeout) {
    clearTimeout(this.availabilityTimeout);
  }
  this.availabilityFetching = false;

  // FIX: Clean up payment polling when component unmounts
  if (this.state.paymentPollInterval) {
    console.log("Component unmounting - clearing payment polling");
    clearInterval(this.state.paymentPollInterval);
  }

  // FIX: Clear polling timeout
  if (this.pollTimeout) {
    clearTimeout(this.pollTimeout);
  }

  // FIX: Reset invoice settlement flag
  this.invoiceSettled = false;
}

  // ---------------------------------------------------------------------------
  // Idle auto-refresh — after 10 min of no user activity, re-fetch the lists so
  // any new leads / messages are on screen when the user returns. Re-arms while
  // idle (refreshes every 10 min), resets on any activity.
  // ---------------------------------------------------------------------------
  IDLE_REFRESH_MS = 10 * 60 * 1000;

  setupIdleRefresh = () => {
    this.lastActivityAt = Date.now();
    this.idleActivityEvents = ['mousemove', 'mousedown', 'keydown', 'scroll', 'touchstart'];
    this.idleActivityEvents.forEach((ev) =>
      window.addEventListener(ev, this.handleUserActivity, { passive: true })
    );
    // Check once a minute rather than re-arming a timeout on every mouse move.
    this.idleInterval = setInterval(() => {
      if (Date.now() - this.lastActivityAt >= this.IDLE_REFRESH_MS) {
        this.lastActivityAt = Date.now(); // re-arm for the next idle window
        this.refreshLists();
      }
    }, 60 * 1000);
  };

  teardownIdleRefresh = () => {
    if (this.idleActivityEvents) {
      this.idleActivityEvents.forEach((ev) =>
        window.removeEventListener(ev, this.handleUserActivity)
      );
    }
    if (this.idleInterval) clearInterval(this.idleInterval);
  };

  handleUserActivity = () => {
    this.lastActivityAt = Date.now();
  };

  // Build the request-list endpoint for the current user/scope. Shared by the
  // initial load and the idle refresh so the URL (incl. unread user_id) stays
  // in one place.
  buildRequestListUrl = (viewerUserId) => {
    const { typeId, userType } = this.state;
    if (userType === "dealer" && ScopeService.isDealerGroupUser()) {
      const groupId = this.props.groupId;
      const dealerId = isAllDealerships(this.props.selectedDealerId)
        ? null : this.props.selectedDealerId;
      return `/requestimates/getdealerrequests/?groupId=${groupId}${dealerId ? `&dealerId=${dealerId}` : ''}&user_id=${viewerUserId}`;
    }
    if (userType === "dealer") {
      // typeId follows the header dealer selection (App.js resolves it from
      // selectedDealerId for dealers), so a multi-dealership user gets the dealer
      // they picked, not the first dealership in scope.
      return `/requestimates/getdealerrequests/?Id=${typeId}&user_id=${viewerUserId}`;
    }
    return `/requestimates/getinstallerrequests/?Id=${typeId}&user_id=${viewerUserId}`;
  };

  // Carry the fresh unread_count onto the currently-selected request (if any)
  // without clobbering detail fields the list doesn't carry.
  syncSelectedUnread = (selected, list) => {
    if (!selected || !selected.requestId) return selected;
    const fresh = list.find((r) => r.requestId === selected.requestId);
    return fresh ? { ...selected, unread_count: fresh.unread_count } : selected;
  };

  // Lightweight refresh of just the requests/estimates lists (and favorites) —
  // does NOT redo calendars/auth/selection. Picks up new leads + unread counts.
  refreshLists = async () => {
    try {
      const { typeId, userType } = this.state;
      const viewerUserId = ScopeService.getUserId();
      const installerRequest = this.buildRequestListUrl(viewerUserId);

      if (userType === "installer") {
        const [requestimatesResponse, estimatesResponse] = await Promise.all([
          API.get(installerRequest),
          API.get(`/requestimates/getinstallerestimates/?Id=${typeId}&user_id=${viewerUserId}`)
        ]);
        const requestimates = requestimatesResponse.data || [];
        const estimates = estimatesResponse.data || [];
        const allRequestimates = _.orderBy(
          requestimates.concat(estimates),
          ["availableDate"],
          ["asc"]
        );
        this.setState((prev) => ({
          estimates,
          requestimates: allRequestimates,
          selectedRequestimate: this.syncSelectedUnread(prev.selectedRequestimate, allRequestimates),
        }));
      } else {
        const requestimatesResponse = await API.get(installerRequest);
        const requestimates = requestimatesResponse.data || [];
        this.setState((prev) => ({
          requestimates,
          selectedRequestimate: this.syncSelectedUnread(prev.selectedRequestimate, requestimates),
        }));
      }
      this.loadFavorites();
    } catch (e) {
      // Idle refresh — stay quiet and try again next cycle.
    }
  };

  // Database updates when needed for each of the state changes
  readInstaller = async (installerId) => {
    let installerRequest = `/installerLocations/${installerId}`;
    const { data: locations } = await API.get(installerRequest);
    // Select the location matching the current selectedLocationId, fallback to first
    const selectedLocId = this.props.selectedLocationId;
    const match = selectedLocId && selectedLocId !== 'all'
      ? locations.find(l => String(l.location_id || l.Location_id) === String(selectedLocId))
      : null;
    this.setState({ installer: match || locations[0] });
  };

  readAuth = async (installerId) => {
    let installerRequest = `/installerAuth/${installerId}`;
    const { data: installer } = await API.get(installerRequest);
    //  //console.log("Installer :", installer);
    this.setState({
      authenticated: installer[0].authenticated,
      calendar: installer[0].calendar_id,
    });
  };

  readCompanies = async (userId) => {
    let companyList = `/userAccess/${userId}`;
    const { data: installer } = await API.get(companyList);
    //    //console.log("Installer Companies:", installer);
    this.setState({ companies: installer });
  };

  // Load technicians for this company (for assignment feature)
  loadTechnicians = async () => {
    try {
      const { typeId } = this.state;
      const { data: users } = await API.get(`/users?company_id=${typeId}&user_type=installer`);
      // Filter to owners + technicians (dedupe by User_id in case API returns duplicates)
      const techRaw = (users || []).filter(u => ['owner', 'manager', 'technician'].includes(u.role));
      const seenIds = new Set();
      const technicians = techRaw.filter(u => {
        if (seenIds.has(u.User_id)) return false;
        seenIds.add(u.User_id);
        return true;
      });
      this.setState({ technicians });
    } catch (error) {
      console.error('Error loading technicians:', error);
      this.setState({ technicians: [] });
    }
  };

  // Load products and build map of which categories have products (for product selection)
  loadCategoryProducts = async () => {
    try {
      const { typeId, userType } = this.state;
      // Only load for installers
      if (userType !== 'installer') return;

      const products = await InventoryAPI.getProducts(typeId);

      // Build map of category_name -> true for categories that have products
      const categoryHasProducts = {};
      (products || []).forEach(product => {
        if (product.category_name) {
          categoryHasProducts[product.category_name] = true;
        }
      });

      this.setState({ categoryHasProducts });
    } catch (error) {
      console.error('Error loading category products:', error);
    }
  };

  // Assign a technician to a service
  handleAssignTechnician = async (requestId, serviceId, technicianId, requestServiceId) => {
    try {
      const { user } = this.props;
      const patchUrl = requestServiceId
        ? `/requestService/row/${requestServiceId}`
        : `/requestService/${requestId}/${serviceId}`;
      const { data: resp } = await API.patch(patchUrl, {
        assigned_technician_id: technicianId,
        technician_assigned_at: technicianId ? convertToUTC(new Date()).format("YYYY-MM-DD HH:mm:ss") : null,
        technician_assigned_by: technicianId ? user.User_id : null
      });

      const techAssignment = resp?.tech_assignment || null;
      const cascadeResult = resp?.cascade_result || null;

      // Update the services in state to reflect the change
      const updatedServices = this.state.services.map(s =>
        (requestServiceId ? s.id === requestServiceId : s.service_id === serviceId)
          ? {
              ...s,
              assigned_technician_id: technicianId,
              ...(techAssignment ? { tech_assignment: techAssignment } : {}),
            }
          : s
      );
      this.setState({ services: updatedServices });

      // Surface cascade outcome — make today's silent fill visible.
      if (technicianId && cascadeResult && techAssignment?.lead_technician_name) {
        const filled = cascadeResult.tasks_filled ?? 0;
        const skipped = cascadeResult.tasks_skipped ?? 0;
        const total = filled + skipped;
        const techName = techAssignment.lead_technician_name;
        if (total === 0) {
          // No tasks to cascade to — service has no steps. Stay quiet.
        } else if (skipped === 0) {
          toast.success(`Lead tech set. ${filled} of ${total} steps assigned to ${techName}.`);
        } else {
          toast.info(`Lead tech set. ${filled} of ${total} steps assigned (${skipped} kept their own tech).`);
        }
      }
    } catch (error) {
      console.error('Error assigning technician:', error);
      alert('Error assigning technician. Please try again.');
    }
  };

  // Save technician instructions for a service
  handleSaveInstructions = async (requestId, serviceId, instructions, requestServiceId) => {
    try {
      this.setState({ savingInstructions: true });
      const { user } = this.props;

      const patchUrl = requestServiceId
        ? `/requestService/row/${requestServiceId}`
        : `/requestService/${requestId}/${serviceId}`;
      await API.patch(patchUrl, {
        technician_instructions: instructions,
        instructions_added_by: user.User_id,
        instructions_added_at: convertToUTC(new Date()).format("YYYY-MM-DD HH:mm:ss")
      });

      // Update the services in state to reflect the change
      const updatedServices = this.state.services.map(s =>
        (requestServiceId ? s.id === requestServiceId : s.service_id === serviceId)
          ? { ...s, technician_instructions: instructions }
          : s
      );
      this.setState({ services: updatedServices, savingInstructions: false });

    } catch (error) {
      console.error('Error saving instructions:', error);
      alert('Error saving instructions. Please try again.');
      this.setState({ savingInstructions: false });
    }
  };

  // Open ServiceItemsModal for a service (called from cube button)
  handleSelectProduct = (serviceRow) => {
    this.setState({
      showServiceItemsModal: true,
      serviceItemsModalService: serviceRow
    });
  };

  // Open StepAssignmentModal (called from "Split between techs…" entry on the
  // service-row TechPicker, or from the multi-tech caption click).
  handleSplitAssignment = (serviceRow) => {
    this.setState({
      showStepAssignmentModal: true,
      stepAssignmentService: serviceRow,
    });
  };

  // Filter technicians to those at the current request's location.
  // Mirrors the filter applied in requestimateState.jsx so the modal sees the
  // same scoped roster as the service-row dropdown.
  getLocationTechnicians = () => {
    const { request, technicians } = this.state;
    const reqLocId = request?.location_id ?? request?.locationId;
    return (technicians || []).filter(tech => {
      if (!reqLocId || reqLocId === 0 || reqLocId === '0') return true;
      const techLocId = tech.location_id || tech.locationId;
      return !techLocId || String(techLocId) === String(reqLocId);
    });
  };

  // Bubble up tech_assignment changes from the step-assignment modal so the
  // service-row caption refreshes without a full reload. Targets whichever
  // service is currently active in either modal.
  handleTechAssignmentChanged = (techAssignment) => {
    if (!techAssignment) return;
    const targetServiceId =
      this.state.stepAssignmentService?.id ||
      this.state.serviceItemsModalService?.id;
    if (!targetServiceId) return;
    const updatedServices = this.state.services.map(s =>
      s.id === targetServiceId
        ? {
            ...s,
            tech_assignment: techAssignment,
            // overwrite mode also updates the service-level lead — sync it
            assigned_technician_id: techAssignment.lead_technician_id ?? s.assigned_technician_id,
          }
        : s
    );
    this.setState({ services: updatedServices });
  };

  // Callback when items are changed in ServiceItemsModal
  handleItemsChanged = async () => {
    const { serviceItemsModalService, services } = this.state;
    if (!serviceItemsModalService?.id) return;

    try {
      const items = await serviceItemsService.getItems(serviceItemsModalService.id);
      const materialItems = (items || []).filter(i => !i.type || i.type === 'material');

      // Update items cache
      const itemsByServiceId = { ...this.state.itemsByServiceId };
      itemsByServiceId[serviceItemsModalService.id] = materialItems;

      // Merge items onto service rows for display
      const updatedServices = services.map(s =>
        s.id === serviceItemsModalService.id
          ? { ...s, items: materialItems }
          : s
      );

      this.setState({ itemsByServiceId, services: updatedServices });
    } catch (error) {
      console.error('Error refreshing items after change:', error);
    }
  };

  // Load service items for services that have them (task_count > 0 or items exist)
  loadServiceItems = async (services) => {
    if (!services || services.length === 0) return;

    // Find services with task_count > 0 (indicates items exist)
    const servicesWithItems = services.filter(s => s.id && s.task_count > 0);
    if (servicesWithItems.length === 0) return;

    try {
      const itemsByServiceId = {};

      // Fetch items for each service in parallel (silent = no toast on errors)
      const results = await Promise.all(
        servicesWithItems.map(s =>
          serviceItemsService.getItems(s.id, { silent: true })
        )
      );

      servicesWithItems.forEach((service, i) => {
        const allItems = results[i] || [];
        const materialItems = allItems.filter(item => !item.type || item.type === 'material');
        itemsByServiceId[service.id] = materialItems;
      });

      // Merge items onto service rows for display
      const updatedServices = this.state.services.map(s => {
        if (itemsByServiceId[s.id]) {
          return { ...s, items: itemsByServiceId[s.id] };
        }
        return s;
      });

      this.setState({ itemsByServiceId, services: updatedServices });
    } catch (error) {
      console.error('Error loading service items:', error);
    }
  };

  // Load service category configs for materials tracking
  loadCategoryConfigs = async () => {
    try {
      const { data: configs } = await API.get('/serviceCategoryConfig');
      // Convert array to lookup object by category_name
      const categoryConfigs = {};
      if (Array.isArray(configs)) {
        configs.forEach(config => {
          categoryConfigs[config.category_name] = config;
        });
      }
      this.setState({ categoryConfigs });
      console.log("Loaded category configs:", categoryConfigs);
    } catch (error) {
      console.error("Error loading category configs:", error);
    }
  };

  updateInstallerLocation = async (location) => {
    let calendar = {
      installerId: this.props.typeId,
      calendarId: location,
    };
    let userLoc = `/updateLocation/${this.props.typeId}`;
    await API.put(userLoc, calendar);
  };

  // Add new handler methods (add these before the existing handlers)

  handleShowDepositModal = (request) => {
    this.setState({ showDepositModal: true });
  };

  handleHideDepositModal = () => {
    this.setState({ showDepositModal: false });
  };

handleSaveDeposit = async (request, depositAmount) => {
  try {
    const updatedRequest = { 
      ...request, 
      deposit_amount: depositAmount,  // Backend still expects snake_case
      depositAmount: depositAmount    // Frontend uses camelCase
    };
    await this.updateRequest(updatedRequest);
    
    this.setState({ 
      selectedRequestimate: updatedRequest
    });
    
    //console.log('Deposit amount updated:', depositAmount);
  } catch (error) {
    console.error('Error saving deposit amount:', error);
    throw error;
  }
};
// Resolve the Stripe tax percentage for the location this request belongs to.
// Deposit lines are taxed unconditionally at the full rate for `installer` invoices,
// so we must know the rate to gross the shop's total down to a pre-tax line.
// Throws for installer invoices when the rate can't be resolved: the server would send
// `tax_rates: [null]` and Stripe would reject it, so a clear message here beats an
// opaque creation failure.
resolveDepositTaxRate = async (installerId, invoiceType) => {
  if (invoiceType !== 'installer') return { taxRatePercentage: 0, stripeTaxRateId: null };

  const { data: installers } = await API.get(`/installerLocations/${installerId}`);
  const selectedLocId = this.props.selectedLocationId;
  const locationData = (selectedLocId && selectedLocId !== 'all'
    ? installers.find(l => String(l.location_id || l.Location_id) === String(selectedLocId))
    : null) || installers[0];

  const stripeTaxRateId = locationData && locationData.stripe_tax_rate;
  if (!stripeTaxRateId) {
    throw new Error(
      'No Stripe tax rate is configured for this location, so the deposit total ' +
      'cannot be calculated. Set the tax rate on the location before taking a deposit.'
    );
  }

  const { data: taxRate } = await API.get(`/taxes/${stripeTaxRateId}`);
  return { taxRatePercentage: parseFloat(taxRate.percentage) || 0, stripeTaxRateId };
};

// Write the installer_payments deposit row. MANDATORY and not optional cleanup:
// the server does not insert it on the deposit path, and the `invoice.created` webhook
// is an UPDATE (not an upsert), so it silently matches zero rows when this is skipped.
// Without this row there is no depositStatus, no credit on the final invoice, and the
// Start gate never opens. `invoiceAmount` must be the PRE-TAX subtotal — the final
// invoice's credit reads that column and re-applies the tax rate to the negative line,
// so a tax-inclusive value double-counts.
createDepositPaymentRow = async ({ request, installerId, invoiceId, invoiceType, subtotal, tax }) => {
  const payment = {
    requestId: request.requestId,
    installerId: parseInt(installerId),
    invoiceId,
    // installer_payments.invoice_date is NOT NULL and the POST handler has no default —
    // omitting it made every deposit row insert fail with ER_BAD_NULL_ERROR (request 7579),
    // leaving a live Stripe invoice with no local row. The invoice was created seconds ago,
    // so "now" is the correct invoice date. UTC timestamp to match how financials reads the
    // column back (convertFromUTC).
    invoiceDate: convertToUTC(new Date()).format('YYYY-MM-DD HH:mm:ss'),
    paymentType: 'deposit',
    paymentState: 'invoiced',
    invoiceAmount: subtotal,
    invoiceTaxes: tax,
    invoiceType,
    paymentMethod: 'Online',
    isPartialPayment: 0,
  };
  await API.post('/installerPayments', payment);
};

// Read the deposit rows for a request and decide whether one already exists.
// Fail CLOSED — if we can't tell, we don't create, because a false negative bills the
// customer twice on a path with no server-side duplicate protection.
depositAlreadyExists = async (request) => {
  try {
    const { data: payments } = await API.get(`/installerPaymentsRequest/${request.requestId}`);
    return hasExistingDeposit(request, payments);
  } catch (error) {
    console.error('Unable to check for an existing deposit invoice:', error);
    throw new Error(
      'Could not confirm whether a deposit invoice already exists for this job, ' +
      'so none was created. Please try again.'
    );
  }
};

handleCreateDepositInvoice = async (request) => {
  // Check if Stripe capabilities are active
  if (!this.validateStripeCapabilities()) return null;

  const depositTotal = parseFloat(request.depositAmount) || 0;
  if (depositTotal <= 0) {
    throw new Error('No deposit amount set');
  }

  // Single choke point for the duplicate guard — every caller is covered by this one
  // check, so no path can mint a second live invoice.
  if (await this.depositAlreadyExists(request)) {
    const exists = new Error('A deposit invoice already exists for this job.');
    exists.code = 'DEPOSIT_EXISTS';
    throw exists;
  }

  const installerId = request.assignedTo || this.state.typeId;
  const invoiceType = request.requestType;

  const { taxRatePercentage, stripeTaxRateId } =
    await this.resolveDepositTaxRate(installerId, invoiceType);

  // The shop types a TOTAL; the line item we send must be pre-tax. See depositUtils.js
  // for why there is deliberately no "taxable ratio" here.
  const { subtotal, tax } = grossDownToTotal(depositTotal, taxRatePercentage);

  const invoice = {
    // Bare request id on purpose. This value is the server's 30-second duplicate-creation
    // lock key (invoiceController). The old `${requestId}-deposit-${Date.now()}` form made
    // every click unique, so the lock never fired and the deposit branch — which also skips
    // checkExistingBeforeCreate — had zero duplicate protection. That is how request 2866
    // ended up with two live Stripe invoices. Lookup is unaffected: the server reads
    // metadata.request_id first.
    invoiceId: request.requestId,
    invoiceType,
    // The server aliases invoiceAmount || amount, so `amount` is read correctly.
    amount: subtotal,
    description: `Deposit for ${request.serviceRequested}`,
    // Stripe metadata values must be strings; omit the tax-rate id entirely for dealer
    // invoices rather than sending null.
    metadata: {
      payment_type: 'deposit',   // routes to the deposit path; without it this is a FINAL invoice
      request_id: String(request.requestId),
      installer_id: String(installerId),
      deposit_total: depositTotal.toFixed(2),
      tax_rate_percentage: String(taxRatePercentage),
      ...(stripeTaxRateId ? { stripe_tax_rate_id: stripeTaxRateId } : {}),
    },
  };

  // The deposit branch reports its two actionable failures as HTTP 422 —
  // `depositTotalUnreachable` (the typed total can't be built from whole-cent
  // line + tax at this rate) and `depositTaxRateMissing` (the location's Stripe
  // tax rate is unset or unloadable). A 422 makes axios THROW, so the body never
  // reaches the `data.error` branch below and every downstream alert would show
  // "Request failed with status code 422" instead of the sentence telling the
  // shop what to do. Lift the server's message here so both the modal
  // (DepositModal.jsx:98) and the booking path (:2062) inherit it.
  let data;
  try {
    ({ data } = await API.post(`/invoices/`, invoice));
  } catch (postError) {
    const body = postError.response && postError.response.data;
    if (body && body.message) {
      const err = new Error(body.message);
      // Carried so a future UI can offer the suggested amounts as a choice
      // rather than making the shop retype one.
      err.depositTotalUnreachable = !!body.depositTotalUnreachable;
      err.depositTaxRateMissing = !!body.depositTaxRateMissing;
      err.nearestBelow = body.nearestBelow;
      err.nearestAbove = body.nearestAbove;
      throw err;
    }
    throw postError;
  }

  // Legacy shape: the pre-2026-08-12 server answered 200 with `{ error: true }`.
  if (data && data.error) {
    throw new Error(data.message || 'Unable to create the deposit invoice.');
  }

  const invoiceId = typeof data === 'string' ? data : (data && (data.invoiceId || data.id));
  if (!invoiceId) {
    throw new Error('The deposit invoice was not created — no invoice id was returned.');
  }

  // Immediately, in the same user action. A live Stripe invoice with no local row is the
  // exact failure that hid ~$4,793 of collected deposits in production.
  try {
    await this.createDepositPaymentRow({
      request, installerId, invoiceId, invoiceType, subtotal, tax,
    });
  } catch (rowError) {
    console.error('Deposit payment row failed after invoice creation:', rowError);
    throw new Error(
      `The deposit invoice (${invoiceId}) was created and the customer may be billed, but ` +
      `recording it against request ${request.requestId} failed. The deposit will not be ` +
      `credited on the final invoice until this is corrected — please report this.`
    );
  }

  return { invoiceId, subtotal, tax };
};

// Resend an already-created deposit invoice's Stripe email (used when a deposit
// invoice already exists, so we must NOT create a second one). Reuses the same
// /invoices/resend/:id path as other invoice resends.
// `invoice_id` carries the Stripe id — confirmed against the server's SELECT * on
// GET /installerPaymentsRequest/:id. The old fallback chain also accepted
// `stripe_invoice`, which is the human-facing invoice NUMBER, not an id.
handleResendDepositInvoice = async (deposit) => {
  const invId = deposit?.invoice_id;
  if (!invId) {
    alert('Unable to resend — no invoice id found on the deposit payment record.');
    return;
  }
  try {
    await this.resendInvoice(invId);
    alert('Deposit invoice resent to the customer.');
  } catch (err) {
    console.error('Error resending deposit invoice:', err);
    alert('Error resending deposit invoice.');
  }
};

// The front desk's route to a deposit's Stripe invoice so they can take the
// payment at the counter. Before this there was none: the invoice was emailed to
// the customer at creation and never surfaced in the app again.
//
// Resolution order is deliberate. We ask for the hosted URL FIRST and only
// finalize when that comes back empty, rather than branching on the row's
// `payment_state`. Nothing in the client updates that row after a finalize, so
// keying off it would re-finalize on the next click — and Stripe errors when
// finalizing an already-finalized invoice. Asking the invoice itself is
// self-correcting and costs the extra round trip only on drafts.
//
// A draft means auto_advance never finalized it (observed on requests 7386 and
// 7506, see DepositModal.jsx:103) and the customer was therefore NEVER emailed.
// Finalizing is what sends that email, so this click can put mail in the
// customer's inbox — which is the point: they are standing at the counter.
handleOpenDepositInvoice = async (request) => {
  // Opened synchronously so the click's user activation still applies. Resolving
  // the URL first and calling window.open afterwards trips popup blockers, and a
  // blocked deposit link is a customer waiting at the counter.
  const tab = window.open('', '_blank');
  const fail = (message) => {
    if (tab) tab.close();
    alert(message);
  };

  try {
    const { data: payments } = await API.get(`/installerPaymentsRequest/${request.requestId}`);
    const deposit = (payments || []).find(isActiveDepositRow);
    if (!deposit) {
      // depositStatus counts voided rows, so it can offer a link that no live
      // deposit backs. Say which case this is instead of a bare failure.
      fail(
        'No live deposit invoice for this job — any deposit invoice on it has been voided. ' +
        'Use Set Deposit to issue a new one.'
      );
      return;
    }

    // `invoice_id` is the Stripe id, confirmed against the server's SELECT * on
    // GET /installerPaymentsRequest/:id. NOT `stripe_invoice` — that column is the
    // human-facing invoice NUMBER ("R000763601"), which 404s against /invoices/:id.
    const invoiceId = deposit.invoice_id;
    if (!invoiceId) {
      fail('This deposit was recorded without a Stripe invoice id, so there is no invoice to open.');
      return;
    }

    let url = await this.readDepositInvoiceUrl(invoiceId);

    if (!url) {
      // Still a draft: finalize it (which sends the customer their invoice) and
      // ask again.
      await this.finalizeInvoice(invoiceId);
      url = await this.readDepositInvoiceUrl(invoiceId);
    }

    if (!url) {
      fail(`Unable to open deposit invoice ${invoiceId}. It may still be finalizing in Stripe — try again in a moment.`);
      return;
    }

    if (tab) tab.location = url;
    else window.open(url, '_blank');
  } catch (error) {
    console.error('Error opening deposit invoice:', error);
    fail(`Unable to open the deposit invoice.\n\n${error.message}`);
  }
};

// Returns the live hosted URL, or null when Stripe has none yet (drafts have no
// hosted page). Never throws — the caller distinguishes "no URL" from "broken".
readDepositInvoiceUrl = async (invoiceId) => {
  try {
    const { data } = await API.get(`/invoices/${invoiceId}/fresh-url`);
    return (data && data.success && data.hosted_invoice_url) ? data.hosted_invoice_url : null;
  } catch (error) {
    console.warn('fresh-url lookup failed for deposit invoice', invoiceId, error);
    return null;
  }
};

handleTransferLocation = (request) => {
  this.setState({
    showAssignLocationModal: true,
    assignLocationRequest: request,
    assignLocationCallback: null,
    modalSelectedLocationId: ''
  });
};

  // --- Assign Location (multi-location unclaimed requests) ---

  handleAssignLocation = async (request, locationId) => {
    try {
      await API.patch(`/requestimates/${request.requestId}/location`, { locationId });

      // Update local state — both requestimates and estimates lists
      const updateList = (list) => list.map(r =>
        r.requestId === request.requestId ? { ...r, location_id: locationId } : r
      );
      const updatedRequestimates = updateList(this.state.requestimates);
      const updatedEstimates = updateList(this.state.estimates);

      // If viewing a specific location and assigned to a different one, clear selection
      const { selectedLocationId } = this.props;
      const transferredAway = !isAllLocations(selectedLocationId)
        && String(locationId) !== String(selectedLocationId);

      const updatedSelected = transferredAway
        ? {}
        : (this.state.selectedRequestimate?.requestId === request.requestId
          ? { ...this.state.selectedRequestimate, location_id: locationId }
          : this.state.selectedRequestimate);

      this.setState({
        requestimates: updatedRequestimates,
        estimates: updatedEstimates,
        selectedRequestimate: updatedSelected,
        hiddenList: transferredAway ? false : this.state.hiddenList
      });
    } catch (error) {
      console.error('Error assigning location:', error);
      alert('Failed to assign location. Please try again.');
    }
  };

  requireLocationAssignment = (request, callback) => {
    const { locations } = this.props;
    if (isMultiLocation(locations) && isUnclaimed(request)) {
      this.setState({
        showAssignLocationModal: true,
        assignLocationRequest: request,
        assignLocationCallback: callback,
        modalSelectedLocationId: ''
      });
      return true;
    }
    return false;
  };

  readRequestServices = async (request) => {
    let serviceRequest = `/requestService/${request}`;
    const { data: services } = await API.get(serviceRequest);
    for (let i = 0; i < services.length; i++) {
      if (services[i].custom_description) {
        services[i].Description = services[i].custom_description;
      }
    }
    this.setState({ services });
  };

  readVIN = async (vin) => {
    try {
      const vinRequest = `/vin/?Id=${vin}`;
      const { data: vehicle } = await API.get(vinRequest);
      if (vehicle?.Results?.[0]) {
        this.setState({ vehicleEntered: vehicle.Results[0] });
      }
    } catch (err) {
      console.log("VIN decode unavailable during check-in, continuing:", err);
    }
  };


  readPayment = async (request) => {
    const paymentRequest = `/installerPaymentsRequest/${request}`;
    const { data: payment } = await API.get(paymentRequest);
    //    //console.log ("readPayment : ", payment);
    this.setState({ payment });
  };

  readRequestNotes = async (request) => {
    let noteRequest = `/requestnotes/${request}`;
    const { data: notes } = await API.get(noteRequest);
    this.setState({ requestNotes: notes });
  };

  readRequestOffers = async (request) => {
    let offerRequest = `/requestoffered/request/${request}`;
    const { data: offers } = await API.get(offerRequest);
    this.setState({ requestOffers: offers });
  };

readInvoice = async (invoiceId) => {
  if (invoiceId) {
    let invoiceRequest = `/invoices/${invoiceId}`;
    const { data: invoice } = await API.get(invoiceRequest);
    //console.log("Invoice data:", invoice); // Debug: Check what's in the invoice
    //console.log("Invoice number:", invoice.number); // Debug: Check the number field
    this.setState({
      invoice,
      finalInvoiceId: invoice.id // Set finalInvoiceId for split payment feature
    });
    
    // Add the invoice number to selectedRequestimate
    if (this.state.selectedRequestimate && invoice.number) {
      //console.log("Current selectedRequestimate:", this.state.selectedRequestimate); // Debug
      const updatedRequestimate = {
        ...this.state.selectedRequestimate,
        customer_facing_invoice: invoice.number
      };
      //console.log("Updated selectedRequestimate:", updatedRequestimate); // Debug
      this.setState({ selectedRequestimate: updatedRequestimate });
    } else {
      /*console.log("Conditions not met:", {
        hasSelectedRequestimate: !!this.state.selectedRequestimate,
        hasInvoiceNumber: !!invoice.number
      });*/
    }
  } else {
    this.setState({
      invoice: {},
      finalInvoiceId: null // Clear finalInvoiceId when no invoice
    });
  }
};

  readRequestStates = async (request) => {
    let stateRequest = `/requeststate/${request.requestId}`;
    const { data: history } = await API.get(stateRequest);
    let selectHistory = history.filter(
      (item) => item.requestId === request.requestId
    );

    this.setState({ requestStates: selectHistory });
  };

  updateRequestOffered = async (offer) => {
    const apiEndpoint = `/requestOffered/${offer.requestId}`;
    await API.put(apiEndpoint, offer);
    //    //console.log('updateRequestOffered', post);
    return null;
  };
  updateRequestOfferedState = async (offer) => {
    const apiEndpoint = `/requestoffered/state/${offer.requestId}`;
    await API.put(apiEndpoint, offer);
    //    //console.log('updateRequestOffered', post);
    return null;
  };

  updateRequestServices = async (requestService) => {
    //    //console.log('updating request service');
    //    //console.log(requestService);
    const apiEndpoint = `/requestServiceState/${requestService.requestServiceId}`;
    await API.put(apiEndpoint, requestService);
    //    //console.log(post);
    return null;
  };

  updateRequestAllServices = async (requestService) => {
    //  //console.log('updating all request service');
    //  //console.log(requestService);
    const apiEndpoint = `/requestAllService/${requestService.requestId}`;
    await API.put(apiEndpoint, requestService);
    //  //console.log(post);
    return null;
  };

updateRequest = async (request) => {
  // The server's requestimate constructor is `depositAmount || deposit_amount || 0` and
  // updateById then writes EVERY column — so a save through this endpoint that omits both
  // keys silently zeroes the deposit, taking the start gate and the final-invoice credit
  // with it. Round-trip the current value when the caller didn't carry one.
  if (request.depositAmount == null && request.deposit_amount == null) {
    try {
      const { data } = await API.get(`/requestimates/requestbyID/?Id=${request.requestId}`);
      const current = Array.isArray(data) ? data[0] : data;
      const existing = current && (current.depositAmount ?? current.deposit_amount);
      if (existing != null) request.depositAmount = existing;
    } catch (error) {
      // Fail loudly rather than quietly wiping a deposit the shop is relying on.
      console.error('Could not read the current deposit amount before saving:', error);
      throw new Error(
        'Could not confirm this job\'s deposit before saving, so the save was stopped ' +
        'to avoid clearing it. Please try again.'
      );
    }
  }

  request.createdDate = convertToUTC(request.createdDate).format(
    "YYYY-MM-DD HH:mm:ss"
  );
  request.availableDate = convertToUTC(request.availableDate).format(
    "YYYY-MM-DD HH:mm:ss"
  );
  request.dueDate = convertToUTC(request.dueDate).format(
    "YYYY-MM-DD HH:mm:ss"
  );

  let apiEndpoint = `/requestimates/requestbyID/?Id=${request.requestId}`;
  await API.put(apiEndpoint, request);

  console.log('updateRequest called for:', request.requestId, 'state:', request.currentState);

  // COMPLETELY REMOVED: Automatic invoice creation when currentState === "finished"
  // This was the source of duplicate invoices when multiple paths led to completion
  
  /*
  // OLD CODE REMOVED TO PREVENT DUPLICATES:
  if (request.currentState === "finished") {
    const invoice = {
      invoiceId: request.requestId,
      invoiceType: request.requestType,
    };
    apiEndpoint = `/invoices/`;
    const { data: post } = await API.post(apiEndpoint, invoice);
    console.log("Here's the invoice created", post);
  }
  */
  
  console.log('updateRequest completed - no automatic invoice creation');
};

addRequestState = async (requestId, requeststate, requestService, reasonCode = null, reasonNotes = null) => {
  const state = {
    requestId: requestId,
    stateDate: convertToUTC(new Date()).format("YYYY-MM-DD HH:mm:ss"),
    requestStatus: requeststate,
    serviceId: requestService,
    // NEW: Add user tracking
    changedByUserId: this.state.user.User_id,
    changedByUserType: this.state.userType,
    // NEW: Add reason tracking for all state changes
    reasonCode: reasonCode,
    reasonNotes: reasonNotes,
    location_id: this.props.selectedLocationId || null
  };

  const apiEndpoint = `/requestState`;
  await API.post(apiEndpoint, state);
  return null;
};

  addAppointment = async (appointment) => {
    //   alert ("Add to the calendar");

    let readAppt = `/readAppt/${appointment}`;
    const { data: appt } = await API.get(readAppt);

       //console.log("Here's the data for the appointment :", appt);
    //     //console.log("Here's the rest of the appointment data :", this.state.selectedRequestimate);
    //    //console.log("description :", description);

    let calEntry = appt[0];

    let summary = `${calEntry.Year} ${calEntry.Make} ${calEntry.Model}`;
    let description = `Customer : ${this.state.selectedRequestimate.dealerName} ${this.state.selectedRequestimate.email} ${this.state.selectedRequestimate.phone_number}`;
    let newAppt = {
      request: appointment,
      summary: summary,
      description: description,
      calendar: calEntry.calendar_id,
      startDate: calEntry.work_date,
      duration: calEntry.request_duration,
      installerId: this.props.typeId,
    };

    let apptAdd = `/addAppt/`;
    await API.put(apptAdd, newAppt);
    return;
  };

  delAppointment = async (appointment) => {
    let readAppt = `/readAppt/${appointment}`;
    const { data: appt } = await API.get(readAppt);

    //  //console.log("Here's the data for the appointment :", appt);

    if (appt.length > 0) {
      if (appt[0].event_id) {
        let newAppt = {
          eventId: appt[0].event_id,
          installerId: this.props.typeId,
        };

        let apptDel = `/delAppt/`;
        await API.put(apptDel, newAppt);
      }
    }
  };

logPaymentFailure = async (failureType, stage, error, stripeObjectId = null) => {
  try {
    const failure = {
      request_id: this.state.selectedRequestimate?.requestId,
      failure_type: failureType,
      failure_stage: stage,
      error_message: error.message || error,
      user_id: this.state.typeId,
      user_type: this.state.userType,
      stripe_object_id: stripeObjectId
    };

    await API.post('/payment-failures', failure);
    console.log(`Payment failure logged: ${failureType} at ${stage}`);
  } catch (logError) {
    console.error('Failed to log payment failure:', logError);
    // Don't fail main operation if logging fails
  }
};

  addCustomer = async (customer) => {
    //  //console.log('Adding Customer Record');
    //  //console.log(customer);

    const apiEndpoint = `/customers`;
    const { data: customerId } = await API.post(apiEndpoint, customer);
    //  //console.log(customerId);
    this.setState({ customerId });
    return null;
  };

  updateCustomer = async (customer) => {
    //    //console.log('Updating Customer Record');
    //    //console.log(customer);
    let custRecord = {
      customerType: "Customer",
      owningInstaller: this.props.typeId,
    };
    const apiEndpoint = `/customers/${customer}`;
    await API.put(apiEndpoint, custRecord);
    //      //console.log(customerId);
    return null;
  };

  /**
   * Fetch and cache operating hours for a location.
   * Used by booking/reschedule flows to build scheduled timestamps with real business hours.
   */
  fetchOperatingHours = async (locationId) => {
    if (!locationId || locationId === 'all') return;
    try {
      const hoursData = await LocationService.getOperatingHours(locationId);
      this.setState({ operatingHours: hoursData.hours || hoursData });
    } catch (err) {
      console.log('Could not fetch operating hours, using defaults');
    }
  };

  updatePayment = async (request, paymentMethod) => {
    //      //console.log('Updating Payment Record');
    const payment = {
      requestId: request.requestId,
      paymentDate: convertToUTC(new Date()).format("YYYY-MM-DD HH:mm:ss"),
      installerId: this.props.typeId,
      paymentState: "settled",
      paymentMethod: paymentMethod || null,
    };
    const apiEndpoint = "/installerPaymentSettle/" + request.requestId;
    await API.put(apiEndpoint, payment);
  };

  updateSchedule = async (offer, startDate) => {
    //    //console.log('Updating Schedule and booking');
    //    //console.log(offer,startDate);
    let scheduleRecord = {
      installerId: this.state.typeId,
      requestId: offer.requestId,
      installerCapacity: this.state.installer.installerCapacity,
      startDate: dateService.toAPIDate(startDate),
      location_id: this.props.selectedLocationId || null,
    };
    const apiEndpoint = `/schedule/`;
    await API.put(apiEndpoint, scheduleRecord);
    //      //console.log(scheduled);
  };

  updateVehicle = async (oldVin, newVin) => {
    //     //console.log('Updating vehicle record :' + oldVin + " with " + newVin);
    const vehicleEntry = {
      vin: newVin,
    };
    const apiEndpoint = `/vehiclesVIN/${oldVin}`;
    await API.put(apiEndpoint, vehicleEntry);
    //    //console.log( "returns : ", post)
    return null;
  };

  updateInstallerCalendar = async (request, service, state, requestServiceId = null) => {
    //    //console.log('Updating calendar record :', request);
    //    //console.log('Updating calendar record :', service);
    //    //console.log('Updating calendar record :', state);

    let installerId = request.installerId;
    if (typeof installerId === "undefined") {
      installerId = this.props.typeId;
    }

    const calendarEntry = {
      requestId: request.requestId,
      installerId: installerId,
      serviceId: service,
      workStatus: state,
      location_id: request.location_id || this.props.selectedLocationId || null,
    };

    if (requestServiceId) {
      calendarEntry.requestServiceId = requestServiceId;
    }

    // Only set workDate at booking time — use the scheduled start date, not today.
    // After booking, work_date should never be overwritten by status changes.
    // Fallback chain: startDate (from offer) → scheduledStart (from server JOIN) → today
    if (state === "booked") {
      const bookDate = request.startDate || request.scheduledStart || moment().format("YYYY-MM-DD");
      calendarEntry.workDate = dateService.toScheduledDateTime(
        bookDate,
        dateService.getTimeForDate(this.state.operatingHours, bookDate, 'open')
      );
    }

    let apiEndpoint = `/installerCalendarProgress/${calendarEntry.requestId}`;
    if (state !== "booked")
      apiEndpoint = `/installerCalendars/${calendarEntry.requestId}`;

    /* const { data: post } = */ await API.put(apiEndpoint, calendarEntry);

    if (service != null) {
      var calendarToChange = this.state.calendarDays;
      // find the request & service
      var dayIndex = calendarToChange.findIndex(
        (day) =>
          day.requestId === calendarEntry.requestId &&
          day.serviceId === calendarEntry.serviceId
      );
      // Only update if calendar entry exists in local state
      if (dayIndex !== -1) {
        calendarToChange[dayIndex].workStatus = calendarEntry.workStatus;
        this.setState({ calendarDays: calendarToChange });
      }
    }
    return null;
  };

  updateInvoiceMetadata = async (invoice, PO) => {
    const apiEndpoint = `/invoices/meta/${invoice}`;
    let transfer = { invoiceId: invoice, PO: PO };
    await API.put(apiEndpoint, transfer);
    ////console.log(post);
    return null;
  };

  createTransfer = async (transfer) => {
    const apiEndpoint = "/transfer";
    await API.post(apiEndpoint, transfer);
    ////console.log(post);
    return null;
  };

  settleInvoice = async (invoice) => {
    const apiEndpoint = "/invoices/settle/" + invoice;
    await API.put(apiEndpoint);
    ////console.log(post);
    return null;
  };

  deleteInstallerCalendar = async (offer) => {
    const calendarEntry = {
      requestId: offer.requestId,
      installerId: offer.installerId,
    };
    const apiEndpoint = `/installerCalendars/${offer.requestId}`;
    /* const { data: post } = */ await API.delete(apiEndpoint, calendarEntry);
    return null;
  };

  processPayment = async (payment, location) => {
    // create a new payment intent for thje terminal reader with the invoice amount on it
    // Process and capture the payment and mark the invoice as paid
    //    const reader = await stripe.terminal.readers.processPaymentIntent(
    //     location,
    //    {payment_intent: payment}
    //);
  };

  resendInvoice = async (invoice) => {
    // //console.log('Deleting Installer Calendar');
    //   //console.log("resendInvoice : ",invoice);
    const apiEndpoint = `/invoices/resend/${invoice}`;
    await API.put(apiEndpoint);
    //   //console.log("resendInvoice returned :",post);
  };

  finalizeInvoice = async (invoice) => {
    // //console.log('Deleting Installer Calendar');
    //    //console.log("finalizeInvoice : ",invoice);
    const apiEndpoint = `/invoices/finalize/${invoice}`;
    await API.put(apiEndpoint);
    //     //console.log("finalizeInvoice returned :",post);
  };

  deleteInvoice = async (invoice) => {
    // Remove the invoice if draft, and set to void if finalized
    ////console.log(offer);
    let apiEndpoint = `/invoices/${invoice}`;
    const { data: returnedInvoice } = await API.get(apiEndpoint);
    //    //console.log("Returned Invoice : ", returnedInvoice);
    if (returnedInvoice.status === "draft")
      /*const {data:post} =*/ await API.delete(apiEndpoint);
    else {
      apiEndpoint = `/invoices/void/${invoice}`;
      /*const {data:post} =*/ await API.put(apiEndpoint);
    }

    return null;
  };

  deletePayment = async (request) => {
    const apiEndpoint = "/installerPayments/" + request;
    await API.delete(apiEndpoint);
    ////console.log(post);
    return null;
  };

  checkPaymentIntent = async () => {
    //          //console.log( "CreatePaymentIntent: This is the request ID for checking: ", this.state.selectedRequestimate.requestId);
    let paymentCheck = `/installerPaymentsRequest/${this.state.selectedRequestimate.requestId}`;
    //          //console.log ("CreatePaymentIntent : route " ,paymentCheck);
    const { data: intentData } = await API.get(paymentCheck);
    //          //console.log("Call is MADE");
    //          //console.log ("CreatePaymentIntent : Returned installer payment data:" ,intentData)
    return intentData;
  };

  updateInstallerPayment = async (request, paymentRequest) => {
    //        //console.log ("Here's the update records", request, paymentRequest);
    let newPay = {
      payment_id: paymentRequest,
    };
    let paymentUpdate = `/installerPaymentCheck/${request}`;
    await API.put(paymentUpdate, newPay);
  };

createSwipe = async (readerId = this.activeReaderId) => {
  try {
    //console.log("createSwipe: Starting payment intent creation");
    //console.log("createSwipe: Invoice:", this.state.invoice);
    if (!this.state.invoice || !this.state.invoice.id) {
      throw new Error("No invoice available for payment");
    }

    // Resolve the paired reader for the selected location when a caller invoked
    // us without one (e.g. handlePaymentChange firing on "Swipe Card" select,
    // before handleSwipeCardFlow has set this.activeReaderId). resolveActiveReader
    // hits /terminal/location/:id/setup and surfaces clear "no reader paired /
    // offline / pick a specific location" errors instead of the opaque
    // "No card reader configured" we used to throw here.
    if (!readerId) {
      readerId = await this.resolveActiveReader();
      this.activeReaderId = readerId;
    }

    // Check if payment intent already exists
    let PI = await this.checkPaymentIntent();
    //console.log("createSwipe: Existing payment intent check:", PI);
    
    if (!PI[0] || !PI[0].payment_id) {
      //console.log("createSwipe: Creating new payment intent");
      
      let newSwipe = {
        invoiceId: this.state.invoice.id,
        locationId: readerId,
        installerName: this.state.installer.name,
      };
      
      //console.log("createSwipe: Creating payment with data:", newSwipe);
      
      let paymentRequest = `/payments`;
      const { data: paymentResponse } = await API.post(paymentRequest, newSwipe);
      
      //console.log("createSwipe: Payment response:", paymentResponse);
      
      // FIXED: Handle the new response structure
      if (!paymentResponse.success) {
        throw new Error(paymentResponse.error || 'Failed to create payment intent');
      }
      
      const paymentIntentId = paymentResponse.paymentIntentId || paymentResponse.id;
      
      if (!paymentIntentId) {
        throw new Error('No payment intent ID returned');
      }
      
      //console.log("createSwipe: Payment intent created:", paymentIntentId);
      this.setState({ paymentIntentId });

      // NOTE: Previously stamped the PaymentIntent id into installer_payments
      // via PUT /installerPaymentCheck (updateInstallerPayment). Removed — that
      // call sent snake_case `payment_id` the server (camelCase) mapped to all
      // undefined, so it was a no-op, and `payment_id` is the server-derived
      // destination_payment (set by the charge.succeeded webhook), not ours to
      // write. The PaymentIntent id lives in this.state.paymentIntentId and the
      // Stripe-authoritative confirm (GET /payments/:id) settles state + IDs.
    } else {
      //console.log("createSwipe: Using existing payment intent:", PI[0].payment_id);
      this.setState({ paymentIntentId: PI[0].payment_id });
    }
    
    //console.log("createSwipe: Final payment intent ID:", this.state.paymentIntentId);
    
  } catch (error) {
    console.error("createSwipe: Error creating payment intent:", error);
    throw error;
  }
};

// NEW: Add missing checkTerminal function (if not exists)
checkTerminal = async (terminalId) => {
  try {
    //console.log("Checking terminal:", terminalId);
    
    const { data: response } = await API.get(`/terminal/${terminalId}`);
    //console.log("Terminal status response:", response);
    
    // FIXED: Validate response structure
    if (!response.success) {
      throw new Error(response.error || 'Failed to get terminal status');
    }
    
    if (response.data && response.data.status === "online") {
      this.setState({ terminalState: "Online" });
      return { status: "online", data: response.data };
    } else {
      this.setState({ terminalState: "Offline" });
      return { status: "offline", data: response.data };
    }
    
  } catch (error) {
    console.error("Terminal check error:", error);
    this.setState({ terminalState: "Offline" });
    throw new Error(`Failed to connect to card reader: ${error.message}`);
  }
};

// NEW: Add missing collectPayment function (if not exists)
collectPayment = async (readerId = this.activeReaderId) => {
  try {
    //console.log("collectPayment: Starting collection");
    //console.log("collectPayment: Payment ID:", this.state.paymentIntentId);
    //console.log("collectPayment: Terminal ID:", readerId);

    if (!this.state.paymentIntentId) {
      throw new Error("No payment ID provided");
    }

    if (!readerId) {
      throw new Error("No terminal configured");
    }

    let newPayment = {
      paymentId: this.state.paymentIntentId,
      terminalId: readerId,
    };

    //console.log("collectPayment: Sending to terminal:", newPayment);
    
    let paymentCollect = `/terminalPay/`;
    const { data: response } = await API.post(paymentCollect, newPayment);
    
    //console.log("collectPayment: Terminal response:", response);
    
    // FIXED: Validate response structure
    if (!response.success) {
      throw new Error(response.error || 'Failed to send payment to terminal');
    }
    
    return response;
    
  } catch (error) {
    console.error("collectPayment: Error:", error);
    throw error;
  }
};


  sendMessage = async (data) => {
    //console.log("Requestimates : SendMessage :", data);
    await API.post("/messages/push", data);
    return null;
  };

  // functions to handle the state changes and selections

// Updated sendEmail method for requestimates.jsx
// Replace the existing sendEmail method with this enhanced version

sendEmail = async (request) => {
 //console.log("📧 FRONTEND: Initiating booking email send for request:", request);
  console.time(`📧 Frontend Email Send - ${request}`);
  
  try {
    const response = await API.get(`/sendemailb/${request}`);
    console.timeEnd(`📧 Frontend Email Send - ${request}`);
    
   //console.log("📧 FRONTEND: Email API response:", response.data);
    
    if (response.data && response.data.success) {
     //console.log("✅ FRONTEND: Booking email sent successfully for request:", request);
      return true;
    } else if (response.status === 200 && !response.data.success) {
      // Handle legacy success response (HTTP 200 but no JSON success flag)
     //console.log("✅ FRONTEND: Booking email sent (legacy response) for request:", request);
      return true;
    } else {
      console.warn("⚠️ FRONTEND: Email may not have been sent properly:", {
        request: request,
        response: response.data,
        status: response.status
      });
      return false;
    }
  } catch (error) {
    console.timeEnd(`📧 Frontend Email Send - ${request}`);
    console.error("❌ FRONTEND: Failed to send booking email:", {
      request: request,
      error: error.message,
      status: error.response?.status,
      data: error.response?.data,
      stack: error.stack
    });
    
    // Don't throw - this shouldn't block the booking process
    // But inform the user there might be an issue
    return false;
  }
};

// ADD these methods to the Requestimates class in requestimates.jsx
// Place them after your existing database update methods (around line 500-600)

/**
 * Updates referral status when linked requests progress through workflow stages
 * Uses referral_id from state (loaded during request selection) - no additional API calls needed
 */
updateReferralStatusFromRequest = async (requestState) => {
  try {
    // Add this check in updateReferralStatusFromRequest:
console.log('Selected requestimate:', this.state.selectedRequestimate);
console.log('Referral ID:', this.state.selectedRequestimate.referral_id);
    // Check if this request has a linked referral (from state)
    if (!this.state.selectedRequestimate?.referral_id) {
      // No linked referral - silent return
      return;
    }
    
    // Map request state to referral status
    const referralStatus = this.mapRequestStateToReferralStatus(requestState);
    
    if (!referralStatus) {
      // No mapping needed for this state - silent return
      return;
    }
    
    // Update referral status silently
    // In updateReferralStatusFromRequest method, add:
console.log('Sending referral update:', {
  referral_id: this.state.selectedRequestimate.referral_id,
  status: referralStatus,
  updated_date: new Date().toISOString()
});
    
    await API.put('/referrals', {
      referral_id: this.state.selectedRequestimate.referral_id,
      status: referralStatus,
      updated_date: new Date().toISOString()
    });
    
    // Optional: Log successful update for debugging
    console.log(`Referral status updated: ${this.state.selectedRequestimate.referral_id} → ${referralStatus}`);
    
  } catch (error) {
    // Silent failure - log but don't disrupt main workflow
    console.log('Referral status update skipped:', error.message);
  }
};

/**
 * Maps request states to appropriate referral statuses
 */
mapRequestStateToReferralStatus = (requestState) => {
  const stateMapping = {
    'scheduled': 'BOOKED',
    'received': 'RECEIVED',
    'started': 'STARTED',
    'finished': 'FINISHED',
    'collected': 'COMPLETE'
  };

  return stateMapping[requestState] || null;
};

// REPLACE the handleAcceptEstimate method in requestimates.jsx

handleAcceptEstimate = async (request, startDate, appointmentStart) => {
  // Mobile bookings carry an appointmentStart (moment with time, in the
  // location's TZ). When present, override the date-only inputs so the
  // booking ends up on the exact slot the front desk picked.
  const isMobileBooking = !!appointmentStart;
  const effectiveStartDate = isMobileBooking ? appointmentStart.toDate() : startDate;
  if (!window.confirm('Book this job for ' + moment(effectiveStartDate).format('MMM D, YYYY') + '? This will reserve the time slot.')) return;
  console.log("Starting job booking process for request:", request.requestId);
  console.log("User selected start date:", effectiveStartDate, "isMobileBooking:", isMobileBooking);

  const jobDuration = parseInt(request.requestDuration) || 1;
  const calculatedEndDate = moment(effectiveStartDate).add(jobDuration - 1, 'days');

  const updatedRequestimate = request;
  const offer = {
    requestId: request.requestId,
    installerId: parseInt(this.state.typeId),
    currentStatus: "scheduled",
    startDate: isMobileBooking
      ? appointmentStart.toISOString()
      : dateService.toScheduledDateTime(
          startDate,
          dateService.getTimeForDate(this.state.operatingHours, startDate, 'open')
        ),
    endDate: isMobileBooking
      ? appointmentStart.clone().add(jobDuration, 'hours').toISOString()
      : dateService.toScheduledDateTime(
          calculatedEndDate,
          dateService.getTimeForDate(this.state.operatingHours, calculatedEndDate, 'close')
        ),
    // Server's mobile scheduler uses this to populate installer_calendar
    // start_time/end_time and request_offered start_date/end_date with
    // proper UTC, then extracts location-TZ components on storage.
    appointment_start: isMobileBooking ? appointmentStart.toISOString() : null,
    dateUpdated: convertToUTC(new Date()).format("YYYY-MM-DD HH:mm:ss"),
    location_id: request.location_id || this.props.selectedLocationId || 0,
  };

  updatedRequestimate.currentState = "scheduled";
  // availableDate/dueDate are the customer's original requested dates — don't overwrite
  // Scheduled work dates live on request_offered (startDate/endDate)

  let depositInvoiceCreated = false;

  try {
    // Core job booking (always succeeds)
    await this.updateRequest(updatedRequestimate);
    await this.updateRequestOffered(offer);
    await this.updateInstallerCalendar(offer, null, "booked");
    await this.addRequestState(request.requestId, offer.currentStatus, null);

    // Update referral status if this came from a referral
    await this.updateReferralStatusFromRequest('scheduled');

    // Handle deposit invoice creation. Read either casing — the request object carries
    // depositAmount from list reads and deposit_amount from the deposit save.
    const bookingDeposit = parseFloat(
      updatedRequestimate.depositAmount || updatedRequestimate.deposit_amount
    ) || 0;
    if (bookingDeposit > 0) {
      try {
        await this.handleCreateDepositInvoice({
          ...updatedRequestimate,
          depositAmount: bookingDeposit,
        });
        depositInvoiceCreated = true;
      } catch (depositError) {
        if (depositError.code === 'DEPOSIT_EXISTS') {
          // Benign — a deposit invoice was already raised for this job (e.g. re-booking
          // an existing request). Nothing to tell the shop.
          console.log('Booking: deposit invoice already exists, not creating another.');
        } else {
          // Do NOT swallow. Silently discarding this is how requests 5811 and 5838 ended
          // up with a deposit_amount set and no invoice ever created — the shop believed
          // the customer had been billed.
          console.error('Deposit invoice error:', depositError);
          alert(
            `The job was booked, but the deposit invoice was not created:\n\n` +
            `${depositError.message}\n\n` +
            `The customer has NOT been billed for the deposit. Use "Set Deposit" on the ` +
            `job to try again.`
          );
        }
      }
    }

    // Calendar sync - try to update existing event first, fall back to create
    if (this.state.authenticated === 1) {
      try {
        // Check if this was a reschedule by looking for existing calendar entry with event_id
        let readAppt = `/readAppt/${request.requestId}`;
        const { data: apptData } = await API.get(readAppt);

        const hasExistingEvent = apptData && apptData.length > 0 && apptData[0].event_id;

        if (hasExistingEvent) {
          // Update existing calendar event (reschedule flow)
          console.log('Updating existing calendar event for reschedule');
          await this.updateAppointment(request.requestId, startDate, calculatedEndDate);
          console.log('Calendar event updated successfully');
        } else {
          // Create new calendar event (first-time booking)
          console.log('Creating new calendar event for first booking');
          await this.addAppointmentSilently(request.requestId);
          console.log('Calendar event created successfully');
        }
      } catch (calendarError) {
        console.error('Calendar sync error:', calendarError);
        // Show warning but don't block the booking
        alert('Job booked successfully, but calendar sync had an issue. You may need to manually update your Google Calendar.');
      }
    }

    await this.clearRequestimate();
    
    ReactGA.event({
      category: "Installer",
      action: "Booked Estimate",
      label: "prod",
    });
    
    let successMessage = "Job booked successfully!";
    // Only claim the invoice exists when it actually does — a failure already alerted above.
    if (depositInvoiceCreated) {
      successMessage += ` Deposit invoice for $${bookingDeposit.toFixed(2)} created.`;
    }
    
    alert(successMessage);

    // Send booking email (requires VIN for server query - skip for chatbot/incomplete estimates)
    if (request.vin) {
      try {
        await this.sendEmail(request.requestId);
      } catch (emailError) {
        console.log('Email notification skipped');
      }
    }

    window.location = "/jobs?filter=scheduled";
    
  } catch (error) {
    console.error('Error booking job:', error);
    alert('Error booking job. Please try again.');
  }
};

// Quote/Estimate handlers
handleSendQuote = async (request) => {
  try {
    // Handle both camelCase and snake_case field names from API
    const quoteSentAt = request.quoteSentAt || request.quote_sent_at;
    const isResend = quoteSentAt ? true : false;

    if (isResend) {
      const confirmResend = window.confirm(
        `Estimate was already sent on ${moment(quoteSentAt).format("MMM D, YYYY")}. Send again with current pricing?`
      );
      if (!confirmResend) return;
    }

    await API.post(`/requests/${request.requestId}/send-quote`);

    // Add request state record for estimate sent/resent
    await this.addRequestState(
      request.requestId,
      isResend ? "estimate_resent" : "estimate_sent",
      null
    );

    alert(isResend ? "Estimate resent to customer!" : "Estimate sent to customer!");

    ReactGA.event({
      category: "Installer",
      action: isResend ? "Resent Estimate" : "Sent Estimate",
      label: "prod",
    });

    // Refresh to show updated quote status
    window.location.reload();

  } catch (error) {
    console.error('Error sending estimate:', error);
    alert('Error sending estimate. Please try again.');
  }
};

handleDownloadQuotePdf = async (request) => {
  try {
    const { data } = await API.get(`/requests/${request.requestId}/quote-pdf`);

    if (data.url) {
      window.open(data.url, '_blank');
    } else {
      alert('PDF not available at this time.');
    }
  } catch (error) {
    console.error('Error downloading estimate PDF:', error);
    alert('PDF not available at this time.');
  }
};

// 5. ADD: Helper method to create invoices explicitly when needed
// Returns { draft: true, paymentId, amount } for drafts, or invoiceId string for real invoices
createInvoiceExplicitly = async (requestId, requestType, context = 'manual') => {
  try {
    console.log(`EXPLICIT: Creating invoice for ${context} - request:`, requestId);

    const invoice = {
      invoiceId: requestId,
      invoiceType: requestType,
    };

    const apiEndpoint = `/invoices/`;
    const { data } = await API.post(apiEndpoint, invoice);

    // Server rejects invoice creation for deleted/cancelled/void requests
    if (data.error) {
      throw new Error(data.message || 'Unable to create invoice for this request.');
    }

    if (data.draft === true) {
      console.log(`EXPLICIT: Draft returned for ${context}, paymentId:`, data.paymentId);
      return { draft: true, paymentId: data.paymentId, amount: data.amount };
    }

    const invoiceId = data.invoiceId;
    console.log(`EXPLICIT: Invoice created successfully for ${context}:`, invoiceId);

    return invoiceId;

  } catch (invoiceError) {
    console.error(`EXPLICIT: Invoice creation failed for ${context}:`, invoiceError);
    throw invoiceError;
  }
};

// Draft invoice materialization — converts a draft into a real Stripe invoice
// with the installer's chosen payment method. Server handles fee waiver logic.
materializeInvoice = async (paymentMethod) => {
  const { draftPayment, selectedRequestimate, checkNumber } = this.state;
  if (!draftPayment) {
    console.error('materializeInvoice: No draft payment in state');
    return { success: false, reason: 'no_draft' };
  }

  this.setState({ isMaterializing: true });
  try {
    console.log('MATERIALIZE: Converting draft', draftPayment.paymentId, 'with method:', paymentMethod);
    const body = {
      paymentMethod,
      paymentToken: draftPayment.paymentToken,
    };
    if (paymentMethod === 'check' && checkNumber) body.checkNumber = checkNumber;
    const { data } = await API.post(`/invoices/${draftPayment.paymentId}/materialize`, body);

    // Server returns structured error when invoice creation fails
    if (data.success === false) {
      console.error('MATERIALIZE failed:', {
        reason: data.reason,
        message: data.message,
        paymentId: draftPayment.paymentId,
        amount: draftPayment.amount,
        paymentMethod,
        requestId: selectedRequestimate && selectedRequestimate.requestId,
        installerId: selectedRequestimate && selectedRequestimate.assignedTo,
        locationId: selectedRequestimate && selectedRequestimate.location_id,
        full: data,
      });
      return { success: false, reason: data.reason, message: data.message };
    }

    if (!data.invoiceId) {
      return { success: false, reason: 'missing_invoice_id' };
    }

    console.log('MATERIALIZE: Invoice created:', data.invoiceId);

    // Store invoiceId on the request record
    const updatedRequest = { ...selectedRequestimate, invoiceId: data.invoiceId };
    await this.updateRequest(updatedRequest);

    // Load the real invoice into state
    await this.readInvoice(data.invoiceId);

    this.setState({
      draftPayment: null,
      selectedRequestimate: updatedRequest,
    });

    return { success: true, invoiceId: data.invoiceId };
  } catch (error) {
    console.error('MATERIALIZE: Failed:', error);
    return { success: false, reason: 'network_error' };
  } finally {
    this.setState({ isMaterializing: false });
  }
};

// 6. SAFETY CHECK: Add invoice creation validation
validateInvoiceCreation = (request) => {
  if (!request || !request.requestId) {
    throw new Error('Invalid request - missing requestId');
  }
  
  if (!request.requestType) {
    throw new Error('Invalid request - missing requestType');
  }
  
  if (request.currentState !== 'finished') {
    console.warn(`Creating invoice for request in state: ${request.currentState}`);
  }
  
  return true;
};

// Stripe capability validation is authoritative on the server. The server returns
// { stripeNotReady, reason } when an invoice can't be created, and the client's
// recovery flow (transfer-and-create via StripeRecoveryModal) handles it.
// This client-side hook is a pass-through and should not be turned into a
// pre-flight gate — that would re-introduce the legacy bypass problem.
validateStripeCapabilities = () => true;

// Dealer invoice Stripe readiness — recovery flow for installer-viewing-dealer-job
// when POST /invoices/ returned stripeNotReady or was never called.
fetchInvoiceReadiness = async (requestId) => {
  try {
    const { data } = await API.get(`/invoices/readiness/${requestId}`);
    this.setState({ invoiceReadiness: data });
  } catch (e) {
    console.error('Invoice readiness check failed', e);
    this.setState({ invoiceReadiness: null });
  }
};

fetchReadyLocations = async () => {
  if (this.state.loadingReadyLocations || this.state.readyLocations) return;
  this.setState({ loadingReadyLocations: true });
  try {
    const { data } = await API.get(`/stripe/invoice-ready-locations/${this.state.typeId}`);
    this.setState({ readyLocations: data?.locations || [] });
  } catch (e) {
    console.error('Ready locations fetch failed', e);
    this.setState({ readyLocations: [] });
  } finally {
    this.setState({ loadingReadyLocations: false });
  }
};

handleRecheckReadiness = (requestId) => {
  if (requestId) this.fetchInvoiceReadiness(requestId);
};

openStripeRecoveryModal = ({ request, reason, locationName, detail }) => {
  this.setState({
    stripeRecoveryModal: {
      open: true,
      request: request || null,
      reason: reason || null,
      locationName: locationName || null,
      detail: detail || null,
    },
  });
  if (!this.state.readyLocations) {
    this.fetchReadyLocations();
  }
};

closeStripeRecoveryModal = () => {
  this.setState({
    stripeRecoveryModal: { open: false, request: null, reason: null, locationName: null, detail: null },
  });
};

handleTransferAndInvoice = async (request, targetLocationId) => {
  // Two-step flow: PATCH the request location, then POST /invoices so it
  // resolves to the new location's Stripe account.
  try {
    await API.patch(`/requestimates/${request.requestId}/location`, {
      locationId: targetLocationId,
    });
  } catch (err) {
    console.error('Transfer location failed', err);
    alert('Unable to transfer the job to the selected location. Please try again.');
    return;
  }

  try {
    const result = await this.createInvoiceExplicitly(
      request.requestId,
      request.requestType,
      'transfer-and-invoice'
    );

    // Handle draft response
    if (result && typeof result === 'object' && result.draft) {
      this.setState({ draftPayment: { paymentId: result.paymentId, amount: result.amount, paymentToken: result.paymentToken } });
      const updated = { ...request, location_id: targetLocationId };
      this.setState({ selectedRequestimate: updated });
      return;
    }

    if (result) {
      const updated = { ...request, invoiceId: result, location_id: targetLocationId };
      await this.updateRequest(updated);
      await this.loadRequestimate(updated);
      this.fetchRequestimates && this.fetchRequestimates();
    }
  } catch (err) {
    const notReady = err?.response?.data?.stripeNotReady;
    if (notReady) {
      // Target location's status changed between listing and use — refresh readiness.
      this.setState({
        invoiceReadiness: {
          ready: false,
          reason: err.response.data.reason,
        },
        readyLocations: null,
      });
      alert(
        err.response.data.message ||
          "That location can't create invoices right now. Please pick another."
      );
    } else {
      console.error('Invoice creation after transfer failed', err);
      alert('Job was transferred but invoice creation failed. Please try again.');
    }
  }
};

handleOpenStripeDashboard = async (requestId) => {
  try {
    const locId =
      this.state.invoiceReadiness?.locationId ||
      this.state.selectedRequestimate?.location_id ||
      this.state.selectedRequestimate?.locationId;
    const qs = locId ? `?locationId=${locId}` : '';
    const { data } = await API.get(`/stripe/dashboard/${this.state.typeId}${qs}`);
    if (data?.url) {
      window.open(data.url, '_blank');
      // Re-check readiness once the installer returns to this tab.
      const onFocus = () => {
        window.removeEventListener('focus', onFocus);
        if (requestId) this.fetchInvoiceReadiness(requestId);
      };
      window.addEventListener('focus', onFocus);
    } else {
      alert('Unable to access Stripe dashboard. Please contact support.');
    }
  } catch (error) {
    console.error('Error accessing Stripe dashboard:', error);
    if (error.response && error.response.status === 404) {
      alert('No payment account found. Please set up your payment account first.');
    } else {
      alert('Unable to access Stripe dashboard. Please try again later.');
    }
  }
};

// ADD: Silent calendar sync method
addAppointmentSilently = async (requestId) => {
    try {
        let readAppt = `/readAppt/${requestId}`;
        const { data: appt } = await API.get(readAppt);

        let newAppt = {
            request: requestId,
            summary: `${appt[0].Year} ${appt[0].Make} ${appt[0].Model}`,
            description: `Customer: ${this.state.selectedRequestimate.dealerName}`,
            calendar: appt[0].calendar_id,
            startDate: dateService.toAPIDate(appt[0].work_date),
            duration: appt[0].request_duration,
            installerId: this.props.typeId,
            timezone: dateService.getUserTimezone(),
        };

        let apptAdd = `/addAppt/`;
        const response = await API.put(apptAdd, newAppt);
        return response.data;

    } catch (error) {
        // Silent failure - just log
       //console.log('Calendar sync failed silently:', error.message);
        return null;
    }
};

// NEW: Update appointment in Google Calendar (proper reschedule)
updateAppointment = async (requestId, startDate, endDate) => {
    try {
        const payload = {
            requestId: requestId,
            installerId: this.props.typeId,
            startDate: dateService.toAPIDate(startDate),
            endDate: endDate ? dateService.toAPIDate(endDate) : null,
            timezone: dateService.getUserTimezone(),
        };

        let apptUpdate = `/updAppt/`;
        const response = await API.post(apptUpdate, payload);
        return response.data;

    } catch (error) {
        console.error('Calendar update failed:', error);
        throw error; // Re-throw so caller can handle
    }
};

  handlePageChange = async (pageNumber) => {
    //  //console.log(`active page is ${pageNumber}`);
    //  //console.log('selected service :', this.state.selectedService);
    this.setState({ activePage: pageNumber });
  };

handlePaymentChange = async (e) => {
  let selectedPay = e.currentTarget.value;
  //console.log("Selected Pay method is:", selectedPay);

  // Clear check number when switching away from Check payment
  if (selectedPay !== "Check") {
    this.setState({ checkNumber: "" });
  }

  // FIX: Properly await payment intent creation for swipe cards
  if (selectedPay === "Swipe Card") {
    //console.log("Creating payment intent...");
    try {
      await this.createSwipe(); // ✅ Now properly awaited
      //console.log("Payment intent created:", this.state.paymentIntentId);
    } catch (error) {
      console.error("Failed to create payment intent:", error);
      alert("Failed to set up card payment. Please try again.");
      return; // Don't set the payment method if creation failed
    }
  }
  this.setState({ selectedPay });
};

handleCheckNumberChange = (e) => {
  this.setState({ checkNumber: e.currentTarget.value });
};

  handleReviewChange = async (reviewScore) => {
    this.setState({ reviewScore });
  };

  handleTerminal = async (mode) => {
    this.setState({ terminalState: mode });
  };

  // REPLACE the existing handlePickStartDate method in requestimates.jsx

handlePickStartDate = async (startDate) => {
 //console.log("🔥 User selected date:", startDate);
  
  // Prevent unnecessary updates if date hasn't actually changed
  const currentDateStr = moment(this.state.startDate).format("YYYY-MM-DD");
  const newDateStr = moment(startDate).format("YYYY-MM-DD");
  
  if (currentDateStr === newDateStr) {
   //console.log("🔥 Date unchanged, skipping update");
    return;
  }
  
  // SIMPLE: Always use what the user selected
  this.setState({ startDate });
  
  // Optional: Refresh availability info for display purposes only
  // This updates the AvailabilityAlert but doesn't override user choice
  if (this.state.selectedRequestimate && this.state.selectedRequestimate.requestId) {
   //console.log("🔥 Refreshing availability info for context");
    
    // Use a debounced approach to prevent rapid API calls
    if (this.availabilityTimeout) {
      clearTimeout(this.availabilityTimeout);
    }
    
    this.availabilityTimeout = setTimeout(async () => {
      try {
        await this.fetchAvailabilityForRequest(
          this.state.selectedRequestimate.requestId, 
          startDate
        );
      } catch (error) {
       //console.log('Availability refresh failed:', error.message);
      }
    }, 300); // 300ms debounce
  }
  
 //console.log("🔥 Date selection complete:", startDate);
};

// REPLACE the existing fetchAvailabilityForRequest method in requestimates.jsx

fetchAvailabilityForRequest = async (requestId, checkDate) => {
  try {
   //console.log("Fetching availability for request:", requestId, "on date:", checkDate);
    
    // Prevent fetching if already in progress
    if (this.availabilityFetching) {
     //console.log("Availability fetch already in progress, skipping");
      return;
    }
    
    this.availabilityFetching = true;
    
    const dateParam = moment(checkDate).format('YYYY-MM-DD');
    // Use the request's own location, not the nav selector
    const reqLocId = this.state.selectedRequestimate?.location_id || this.state.selectedRequestimate?.locationId;
    const availLocParam = reqLocId && reqLocId !== 0 && reqLocId !== '0'
      ? `&locationId=${reqLocId}` : '';
    const { data: availability } = await API.get(
      `/availability/${this.state.typeId}/${requestId}?checkDate=${dateParam}${availLocParam}`
    );
    
   //console.log("Updated availability for date:", availability);
    
    // Only update state if the request is still the selected one
    if (this.state.selectedRequestimate?.requestId === requestId) {
      this.setState({ availability });
    } else {
     //console.log("Request changed during availability fetch, discarding result");
    }
    
  } catch (error) {
    console.error('Failed to fetch availability for date:', error);
    // Optionally show user feedback
   //console.log('Using fallback availability calculation');
  } finally {
    this.availabilityFetching = false;
  }
};
  handleCloseSwipe = async () => {
  // FIX: Clear polling interval
  if (this.state.paymentPollInterval) {
    console.log("Closing swipe modal - clearing polling interval");
    clearInterval(this.state.paymentPollInterval);
  }

  // FIX: Clear polling timeout
  if (this.pollTimeout) {
    clearTimeout(this.pollTimeout);
  }

  // FIX: Reset invoice settlement flag
  this.invoiceSettled = false;

  this.setState({
    showSwipe: false,
    paymentState: "idle",
    paymentError: null,
    paymentPollInterval: null,
    showCalendar: false  // Keep existing functionality
  });
};
// NEW: Add retry handler
handleRetryPayment = async () => {
  //console.log("Retrying payment...");
  await this.handleSwipeCardFlow();
};

// Cancel terminal payment (stops reader, keeps PaymentIntent for retry)
handleCancelTerminal = async () => {
  try {
    // Cancel the terminal reader action on the reader actually in use.
    const readerId = this.activeReaderId || this.state.installer?.stripe_location;
    if (readerId) {
      await API.post(`/terminal/${readerId}/cancel`);
    }
  } catch (err) {
    console.error("Cancel terminal failed:", err);
    // Continue to close modal even if cancel fails
  }

  // Close the modal
  this.handleCloseSwipe();
};

  handleClosePO = async () => {
    this.setState({ showPO: false });
  };

  handleShowHelpVideo = () => {
    this.setState({ showHelpVideo: true });
  };

  handleCloseHelpVideo = () => {
    this.setState({ showHelpVideo: false });
  };

  handleVINChange = async (e) => {
    const newVin = e.currentTarget.value;
    let vin = newVin.trim().toUpperCase();
    let vinGood = false;
    //    //console.log('VIN Length :', vin.length);
    let good = vin.match(/[A-HJ-NPR-Z0-9|a-hj-npr-z0-9]{17}/);
    if (vin.length === 17 && good !== null) {
      // for a dealer car, the numbers just have to match
      // because we have already hit the NHSTA database to create the work
      //   if(this.state.selectedRequestimate.requestType === "dealer") {
      //     if(this.state.selectedRequestimate.vin === vin){
      //       vinGood = true
      //     }
      //   } else {
      // for a installer car, hit the NHSTA database to retrieve the car information
      vinGood = true;
      await this.readVIN(vin);
      /*        VINread.then( () => {
          //console.log("NHTSA record :",this.state.vehicleEntered.ModelYear,);      
          //console.log("NHTSA record :",this.state.vehicleEntered.Make,);      
          //console.log("NHTSA record :",this.state.vehicleEntered.Model,);      
          //console.log("Vehicle on file :", this.state.selectedRequestimate.vehicleYear);
          //console.log("Vehicle on file :", this.state.selectedRequestimate.vehicleMake);
          //console.log("Vehicle on file :", this.state.selectedRequestimate.vehicleModel);
        })*/
      // need to handle the case where this isn't available
      //   }
    }
    this.setState({ vin, vinGood });
  };

  handleMaterialsChange = async (e) => {
    const materials = e.currentTarget.value;
    this.setState({ materials });
  };

  handleTemplateChange = async (e) => {
    const template = e.currentTarget.value;
    this.setState({ template });
  };

  handleNameChange = async (e) => {
    const customerName = e.currentTarget.value;
    this.setState({ customerName });
  };

  handleEmailChange = async (e) => {
    const customerEmail = e.currentTarget.value;
    this.setState({ customerEmail });
  };

  handlePhoneChange = async (e) => {
    const customerPhone = e.currentTarget.value;
    this.setState({ customerPhone });
  };

  handleDelete = async (request) => {
    // Show modal to determine if this is a simple delete or a business loss
    this.setState({
      showDeleteOrLossModal: true,
      requestToDelete: request
    });
  };

  handleDeleteConfirm = async (result) => {
    // Close modal
    this.setState({ showDeleteOrLossModal: false });

    const request = this.state.requestToDelete;

    if (!result.confirmed || !request) {
      this.setState({ requestToDelete: null });
      return;
    }

    // Check if this request has a paid deposit
    if (request.depositAmount > 0 && request.depositIsPaid === 1) {
      try {
        const paymentsRes = await API.get(`/installerPaymentsRequest/${request.requestId}`);
        const payments = paymentsRes.data;
        const depositPayment = payments.find(p =>
          p.payment_type === 'deposit' && p.payment_status === 'paid' && p.payment_intent_id
        );

        if (depositPayment) {
          // Show refund modal, store the delete result for after refund decision
          this.setState({
            showDepositRefundModal: true,
            depositRefundPayment: depositPayment,
            deleteConfirmResult: result
          });
          return;
        }
      } catch (err) {
        console.error('Could not fetch deposit payments, proceeding with delete:', err);
        // Graceful degradation — proceed without refund modal
      }
    }

    // No deposit or couldn't fetch — proceed directly
    this.executeDelete(request, result);
  };

  handleRefundDecision = async (refundDecision) => {
    const { depositRefundPayment, deleteConfirmResult, requestToDelete } = this.state;

    // Close refund modal
    this.setState({
      showDepositRefundModal: false,
      depositRefundPayment: null
    });

    // Process refund if requested
    if (!refundDecision.skipRefund && depositRefundPayment) {
      try {
        await API.post('/refunds/deposit', {
          requestId: requestToDelete.requestId,
          paymentIntentId: depositRefundPayment.payment_intent_id,
          refundAmount: refundDecision.refundAmount,
          refundType: refundDecision.refundType,
          reason: 'requested_by_customer'
        });
      } catch (err) {
        const errorMsg = err.response?.data?.error || 'Refund processing failed';
        const proceed = window.confirm(
          `Refund failed: ${errorMsg}\n\nDo you want to proceed with cancellation without a refund?`
        );
        if (!proceed) {
          // Abort entire deletion
          this.setState({ deleteConfirmResult: null, requestToDelete: null });
          return;
        }
      }
    }

    // Continue with deletion
    this.executeDelete(requestToDelete, deleteConfirmResult);
    this.setState({ deleteConfirmResult: null });
  };

  handleRefundCancel = () => {
    // Abort entire deletion
    this.setState({
      showDepositRefundModal: false,
      depositRefundPayment: null,
      deleteConfirmResult: null,
      requestToDelete: null
    });
  };

  executeDelete = async (request, result) => {
    // Determine redirect path
    let redirect = "reqs";
    if (request.currentState === "scheduled") {
      redirect = "jobs";
    }

    // Determine the status to record based on user's choice
    const requestStatus = result.isLoss ? "LOSS" : "deleted";

    const offer = {
      requestId: request.requestId,
      installerId: parseInt(this.state.typeId),
      currentStatus: requestStatus,
      startDate: convertToUTC(new Date()).format("YYYY-MM-DD HH:mm:ss"),
      dateUpdated: convertToUTC(new Date()).format("YYYY-MM-DD HH:mm:ss"),
    };

    // Update the database
    const updatedRequestimate = request;
    updatedRequestimate.currentState = requestStatus;
    try {
      await this.updateRequest(updatedRequestimate);
    } catch (updateError) {
      // Server returns 409 when payments/invoices prevent deletion
      if (updateError?.response?.status === 409) {
        const msg = updateError.response.data?.message || 'This request has an active invoice or payment and cannot be deleted. Void the invoice first.';
        alert(msg);
        return;
      }
      // Surface invoice-creation-for-deleted-request errors clearly
      if (updateError?.response?.data?.message) {
        alert(updateError.response.data.message);
        return;
      }
      throw updateError;
    }

    // Delete the installer calendar entries if already created
    if (this.state.authenticated === 1) {
      try {
        await this.delAppointmentSilently(request.requestId);
        console.log('Calendar event deleted successfully');
      } catch (calendarError) {
        console.error('Failed to delete calendar event:', calendarError);
        // Continue with deletion but note the issue
      }
    }
    await this.deleteInstallerCalendar(offer);

    this.deletePayment(request.requestId);

    // If installer deletes then remove the invoice from Stripe
    if (request.invoiceId) {
      this.deleteInvoice(request.invoiceId);
    }
    await this.updateRequestOffered(offer);

    // Add an audit record to the table WITH REASON
    await this.addRequestState(
      request.requestId,
      requestStatus,
      null,
      result.reasonCode,
      result.reasonNotes
    );

    await this.clearRequestimate();

    if (this.state.userType === "dealer") {
      ReactGA.event({
        category: "Dealer",
        action: result.isLoss ? "Lost Request" : "Deleted Request",
        label: "prod",
      });
      if (result.isLoss) {
        alert("Loss has been recorded for analysis. Installers will be notified that this job is no longer available.");
      } else {
        alert("We'll let the installers who were offered the job that it is no longer available");
      }
    } else {
      if (request.requestType === "installer") {
        ReactGA.event({
          category: "Installer",
          action: result.isLoss ? "Lost Estimate" : "Deleted Estimate",
          label: "prod",
        });
        alert("We've removed the work from your calendar");
      } else {
        ReactGA.event({
          category: "Installer",
          action: "Dealer Incorrect Delivery",
          label: "prod",
        });
        alert("Contact the dealer to let them know they have sent the wrong car");
      }
    }

    // Clear the request to delete
    this.setState({ requestToDelete: null });

    if (redirect === "reqs") {
      window.location = "/requestimates";
    } else {
      window.location = "/jobs?filter=scheduled";
    }
  };

delAppointmentSilently = async (requestId) => {
    try {
        // Use the new request-based approach which handles multi-day events better
        let newAppt = {
            requestId: requestId,
            installerId: this.props.typeId,
        };

        let apptDel = `/delAppt/`;
        const response = await API.put(apptDel, newAppt);
       //console.log('Calendar cleanup completed as bonus');
        return response.data;
        
    } catch (error) {
        // Silent failure - just log
       //console.log('Calendar cleanup failed silently:', error.message);
        return null;
    }
};


  iconState = (state, type) => {
    if (state === "new" && type === "installer") {
      return <i className="fa-sharp fa-solid fa-credit-card"></i>;
    } else {
      switch (state) {
        case "draft":
          return <i className="fa-sharp fa-solid fa-file-pen"></i>;
        case "new":
          return <i className="fa-sharp fa-solid fa-comment"></i>;
        case "answered":
          return <i className="fa-sharp fa-solid fa-bell"></i>;
        case "scheduled":
          return <i className="fa-sharp fa-solid fa-calendar"></i>;
        case "received":
          return <i className="fa-sharp fa-solid fa-battery-empty"></i>;
        case "started":
          return <i className="fa-sharp fa-solid fa-battery-half"></i>;
        case "finished":
          return type === "dealer" ? <i className="fa-sharp fa-solid fa-car"></i> : <i className="fa-sharp fa-solid fa-dollar-sign"></i>;
        case "paid":
          return <i className="fa-sharp fa-solid fa-car"></i>;
        case "collected":
          return <i className="fa-sharp fa-regular fa-star"></i>;
        default:
          break;
      }
    }
  };

  // Get the appropriate date to display in the list based on mode
  // - Estimates (requests): show original availableDate (customer's requested date)
  // - Jobs: show scheduledStart from request_offered (actual booked date)
  // - Pickups: show scheduledEnd from request_offered (expected completion date)
  getDisplayDate = (item, mode) => {
    // These are date-only fields — parse without timezone math (parseDateOnly),
    // otherwise a midnight-stored value shifts across the day boundary.
    // For estimates, show original requested date
    if (mode === "requests") {
      return parseDateOnly(item.availableDate);
    }

    // For pickups (finished jobs), show the scheduled end date
    if (mode === "pickups" || item.currentState === "finished") {
      return item.scheduledEnd ? parseDateOnly(item.scheduledEnd) : parseDateOnly(item.dueDate);
    }

    // For jobs, show the scheduled start date
    return item.scheduledStart ? parseDateOnly(item.scheduledStart) : parseDateOnly(item.availableDate);
  };

  // Sort a list of requests by their scheduled date (from request_offered)
  sortByCalendarDate = (requestList) => {
    return requestList.sort((a, b) => {
      const dateA = a.scheduledStart ? parseDateOnly(a.scheduledStart) : parseDateOnly(a.availableDate);
      const dateB = b.scheduledStart ? parseDateOnly(b.scheduledStart) : parseDateOnly(b.availableDate);

      // Records with a missing/invalid date sort to the end rather than crashing.
      if (!dateA && !dateB) return 0;
      if (!dateA) return 1;
      if (!dateB) return -1;

      return dateA.diff(dateB);
    });
  };

  handleCancel = async () => {
    if (this.state.fromToday) {
      this.props.history.push('/today');
      return;
    }
    this.setState({ selectedService: 0, hiddenList: false, selectedDraft: null, selectedDraftPayload: null });
    await this.clearRequestimate();
  };

  // --- Draft (incomplete requestimate) actions ---------------------------------
  // Resume editing: reopen the wizard rehydrated from the saved draft payload.
  // Pass the snapshot we already loaded for the panel so the resume screen doesn't
  // have to re-fetch it (and works even if GET /draft/:id is flaky).
  handleContinueDraft = (draft) => {
    this.props.history.push({
      pathname: '/requestimate/draft/' + draft.requestId,
      state: { payload: this.state.selectedDraftPayload }
    });
  };

  // Hard-delete a draft, then refresh the list and clear the panel.
  handleDeleteDraft = async (draft) => {
    if (!window.confirm('Delete this draft? This cannot be undone.')) return;
    this.setState({ deletingDraft: true });
    try {
      await deleteDraft(draft.requestId);
      this.setState({ deletingDraft: false, selectedDraft: null, selectedDraftPayload: null });
      await this.refreshLists();
    } catch (e) {
      this.setState({ deletingDraft: false });
      alert('Could not delete the draft.');
    }
  };

  // Zero the unread message chip for a request locally (tile + list row) after
  // the ConversationDrawer marks it read — no refetch. The authoritative count
  // self-corrects on the next list fetch. requestimateList is derived from
  // state.requestimates, so the source array is what we mutate.
  handleConversationRead = (requestId) => {
    this.setState((prev) => ({
      requestimates: (prev.requestimates || []).map((r) =>
        r.requestId === requestId ? { ...r, unread_count: 0 } : r
      ),
      selectedRequestimate:
        prev.selectedRequestimate && prev.selectedRequestimate.requestId === requestId
          ? { ...prev.selectedRequestimate, unread_count: 0 }
          : prev.selectedRequestimate,
    }));
  };

  acceptCard = async () => {
    this.setState({ showSwipe: true });
  };

  handlePurchaseOrder = async () => {
    this.setState({ showPO: true });
  };

  handleSwipe = async () => {
    this.setState({ showSwipe: false });
  };

  isDiscoveryJob = (request) => {
  return request.assignedTo === 0;
  }


// ALSO REPLACE the handleDiscoveryAutoAssign method in requestimates.jsx

handleDiscoveryAutoAssign = async (request, startDate) => {
 //console.log("CLAIM clicked - startDate parameter:", startDate);
 //console.log("CLAIM clicked - this.state.startDate:", this.state.startDate);
 //console.log("CLAIM clicked - date picker should show:", moment(startDate).format("YYYY-MM-DD"));
  
  try {
    // CALCULATE END DATE BASED ON NEW START DATE
    const jobDuration = parseInt(request.requestDuration) || 1;
    const calculatedEndDate = moment(startDate).add(jobDuration - 1, 'days');
    
   //console.log("Discovery job duration:", jobDuration, "days");
   //console.log("Discovery calculated end date:", calculatedEndDate.format("YYYY-MM-DD"));
    
    const claimData = {
      installerId: this.state.typeId,
      startDate: convertToUTC(startDate).format("YYYY-MM-DD HH:mm:ss"),
      endDate: convertToUTC(calculatedEndDate).format("YYYY-MM-DD HH:mm:ss"),
      location_id: this.props.selectedLocationId || null
    };
    
    await API.post(`/dashboard/claim/${request.requestId}`, claimData);

    alert("Discovery job claimed and booked successfully!");
    await this.clearRequestimate();
    window.location = "/jobs?filter=scheduled"; // Now scheduled work
    
  } catch (error) {
    if (error.response?.status === 409) {
      alert("This job has already been claimed by another specialist.");
    } else {
      alert("Failed to claim job. Please try again.");
    }
  }
}

handleAccept = async (request, startDate) => {
  if (!window.confirm('Claim this job? The dealer will be notified.')) return;
  // Guard: multi-location installer must assign location before claiming
  if (this.requireLocationAssignment(request, () => this.handleAccept(request, startDate))) return;

  if (this.isDiscoveryJob(request)) {
    return this.handleDiscoveryAutoAssign(request, startDate);
  }
  // Fallback for any edge cases
    const updatedRequestimate = request;
    // update the request_offer
    const offer = {
      requestId: request.requestId,
      installerId: parseInt(this.state.typeId),
      currentStatus: "accepted",
      startDate: convertToUTC(startDate).format("YYYY-MM-DD HH:mm:ss"),
      dateUpdated: convertToUTC(new Date()).format("YYYY-MM-DD HH:mm:ss"),
    };
    updatedRequestimate.currentState = "answered";
    // update the request to "answered"
    let urequest = await this.updateRequest(updatedRequestimate);

    // if the date has changed, then we need to reschedule the calendar appointments

    if (
      moment(this.state.selectedOffers[0].startDate).format("YYYY-MM-DD") ===
      moment(startDate).format("YYYY-MM-DD")
    ) {
      // update the offer
      await this.updateRequestOffered(offer);

      // update the installer Calendar - All Services for the request
      await this.updateInstallerCalendar(offer, null, "pending");

      // if the user is google authenticated, add the services to their google calendar
    } else {
      // remove the original calendar entries
      await this.deleteInstallerCalendar(offer);
      // call the reschedule module
      await this.updateSchedule(offer, startDate);
    }

    // add an audit record to the table
    let astate = await this.addRequestState(
      request.requestId,
      offer.currentStatus,
      null
    );
    Promise.all([urequest, astate]).then(() => {
      // For dealer jobs, notify the dealer contact person
      const contactId = request.dealerContact || request.dealer_contact || request.requestor;
      let data = {
        messageType: "User",
        messagePlatform: "SMS",
        userType: "dealer",
        id: contactId,
        text: `${this.props.companyName} has responded to your request`,
      };
      this.sendMessage(data);

      ReactGA.event({
        category: "Installer",
        action: "Answered Request",
        label: "prod",
      });
      this.clearRequestimate();
      alert("We'll let them know you are interested");
    });
    window.location = "/requestimates";
  };

handleCompleteEstimate = async (request, startDate) => {
  // Guard 1: block re-entrant invoicing (rapid double-click).
  if (this._invoiceInFlight) return;
  this._invoiceInFlight = true;
  this.setState({ submitting: true });
  try {
  if (!window.confirm('Mark this job as completed? The customer will be notified that their job is complete.')) return;
  console.log("Handle Complete Estimate", request, startDate);

  // Check if installer has Stripe account set up
  if (!this.state.installer.stripe_account_id || !this.state.installer.onboarding_complete) {
    alert(
      "⚠️ Payment Account Required\n\n" +
      "You must complete your payment account setup before you can complete jobs.\n\n" +
      "Please click on 'Profile' in the navigation menu (look for the ⚠️ warning icon) to set up your payment account.\n\n" +
      "This is a one-time setup that takes about 3-5 minutes."
    );
    return;
  }

  // Check if Stripe capabilities are active
  if (!this.validateStripeCapabilities()) return;

  // Check for missing/placeholder VIN (installer only)
  if (this.state.userType === 'installer' && !request._vinCheckSkipped) {
    // Marine assets are exempt: a boat has no VIN by design — its identifier is
    // a HIN, captured at check-in. Prompting for a VIN here would be nonsense.
    const vinMissing = isPlaceholderVin(request.vin) && !isMarine(request.vin);

    if (vinMissing) {
      this.setState({
        showVINRequiredModal: true,
        vinRequiredRequest: request,
        vinRequiredStartDate: startDate
      });
      return;
    }
  }

  // Guard 3: warn if another request for this VIN is already completed/invoiced.
  if (!request._dupInvoiceAck) {
    const gVin = normalizeVin(request.vin);
    if (!isPlaceholderVin(gVin)) {
      try {
        const rows = await getRequestsByVin(request.assignedTo || this.state.typeId, gVin);
        const others = findCompletedOtherForVin(rows, request.requestId);
        if (others.length) {
          this.setState({ showInvoiceDupModal: true, invoiceDupData: { mode: 'estimate', request, startDate, matches: others } });
          return;
        }
      } catch (dupErr) {
        console.warn("VIN invoice-duplicate check failed, proceeding:", dupErr);
      }
    }
  }

  const updatedRequestimate = request;
  const offer = {
    requestId: request.requestId,
    installerId: parseInt(this.state.typeId),
    currentStatus: "finished",
    startDate: convertToUTC(startDate).format("YYYY-MM-DD HH:mm:ss"),
    dateUpdated: convertToUTC(new Date()).format("YYYY-MM-DD HH:mm:ss"),
  };
  
  updatedRequestimate.currentState = "finished";
  updatedRequestimate.availableDate = offer.startDate;

  // Remove automatic invoice creation from updateRequest
  await this.updateRequest(updatedRequestimate);

  if (
    moment(this.state.selectedOffers[0].startDate).format("YYYY-MM-DD") ===
    moment(startDate).format("YYYY-MM-DD")
  ) {
    await this.updateRequestOffered(offer);
    await this.updateInstallerCalendar(offer, null, "finished");
  } else {
    await this.deleteInstallerCalendar(offer);
    await this.updateSchedule(offer, startDate);
  }

  await this.addRequestState(
    request.requestId,
    offer.currentStatus,
    null
  );

  // UPDATED: Enhanced invoice creation with failure logging
  try {
    console.log("EXPLICIT: Creating invoice for completed estimate:", request.requestId);
    const invoice = {
      invoiceId: request.requestId,
      invoiceType: request.requestType,
    };
    
    const apiEndpoint = `/invoices/`;
    const { data } = await API.post(apiEndpoint, invoice);
    const invoiceId = data.invoiceId;
    console.log("EXPLICIT: Invoice created successfully:", invoiceId);

    if (invoiceId) {
      updatedRequestimate.invoiceId = invoiceId;
      await this.updateRequest(updatedRequestimate);
    }

  } catch (invoiceError) {
    console.error("EXPLICIT: Invoice creation failed for request", request.requestId, ":", invoiceError);

    // NEW: Log the failure for debugging
    await this.logPaymentFailure('invoice_creation', 'handleCompleteEstimate', invoiceError);
    
    alert("Estimate completed successfully, but there was an issue creating the invoice. Please check the invoices section or contact support.");
  }

  await this.clearRequestimate();

  ReactGA.event({
    category: "Installer",
    action: "Completed Work",
    label: "prod",
  });
  alert("Invoice Generated");
  window.location = "/pickups";
  } finally {
    this._invoiceInFlight = false;
    this.setState({ submitting: false });
  }
};



  handleReschedule = async (request) => {
    console.log("Starting reschedule process for request:", request.requestId);

    const updatedRequestimate = request;
    // Used for a request and an estimate by an installer
    const offer = {
      requestId: request.requestId,
      installerId: parseInt(this.state.typeId),
      currentStatus: "offered",
      startDate: convertToUTC(new Date()).format("YYYY-MM-DD HH:mm:ss"),
      dateUpdated: convertToUTC(new Date()).format("YYYY-MM-DD HH:mm:ss"),
      location_id: request.location_id || this.props.selectedLocationId || 0,
    };

    try {
      // Update the database - mark as offered
      await this.updateRequestOfferedState(offer);

      // Reset the request to new state (user will pick new date)
      updatedRequestimate.currentState = "new";
      await this.updateRequest(updatedRequestimate);

      // NOTE: We no longer delete the calendar event here!
      // The calendar event will be UPDATED (not deleted) when user picks new date
      // This preserves the event_id so we can properly update it later

      // Update installer calendar to draft status
      await this.updateInstallerCalendar(offer, null, "draft");

      // Track the reschedule in request state
      await this.addRequestState(
        request.requestId,
        "rescheduled",
        null
      );

      ReactGA.event({
        category: "Installer",
        action: "Initiated Reschedule",
        label: "prod",
      });

      alert("Job is reset to estimate for rescheduling. The calendar event will be updated when you select a new date.");
      window.location = "/requestimates";

    } catch (error) {
      console.error('Error during reschedule:', error);
      alert('Error initiating reschedule. Please try again.');
    }
  };

  // DEALER RESCHEDULE FEATURE - Validation method
  canDealerReschedule = (request) => {
    // Only dealers can use this feature
    if (this.state.userType !== 'dealer') {
      return { canReschedule: false, reason: 'Only dealers can reschedule' };
    }

    // Check if job is in an allowed state
    const allowedStates = ['new', 'scheduled', 'received'];
    if (!allowedStates.includes(request.currentState)) {
      return { canReschedule: false, reason: `Cannot reschedule jobs in ${request.currentState} state` };
    }

    // Check if job is starting today (can't reschedule same-day jobs)
    const today = moment().startOf('day');
    const jobStartDate = moment(request.availableDate).startOf('day');

    if (jobStartDate.isSame(today)) {
      return { canReschedule: false, reason: 'Cannot reschedule jobs starting today' };
    }

    return { canReschedule: true };
  };

  // DEALER RESCHEDULE FEATURE - Main handler
  handleDealerReschedule = async (request, newAvailableDate, newDueDate) => {
    console.log("Dealer reschedule: Starting for request:", request.requestId);
    console.log("Dealer reschedule: New available date:", newAvailableDate);
    console.log("Dealer reschedule: New due date:", newDueDate);

    // Validate reschedule is allowed
    const validation = this.canDealerReschedule(request);
    if (!validation.canReschedule) {
      alert(validation.reason);
      return;
    }

    try {
      const updatedRequest = { ...request };

      // Update both dates
      updatedRequest.availableDate = dateService.toAPIDate(newAvailableDate);
      updatedRequest.dueDate = dateService.toAPIDate(newDueDate);

      // For NEW requests - simple due date update
      if (request.currentState === 'new') {
        await this.updateRequest(updatedRequest);

        await this.addRequestState(
          request.requestId,
          "dealer_reschedule_minor",
          null,
          "DEADLINE_CHANGE",
          `Schedule updated: Available ${moment(newAvailableDate).format("MM/DD/YYYY")}, Due ${moment(newDueDate).format("MM/DD/YYYY")}. Job not yet claimed.`
        );

        ReactGA.event({
          category: "Dealer",
          action: "Reschedule Unclaimed Job",
          label: "prod",
        });

        alert("Due date updated. Specialists will see the new timeline when claiming jobs.");
        window.location.reload();
        return;
      }

      // For SCHEDULED/RECEIVED jobs - check if existing schedule fits
      const calendarEntries = this.state.calendarDays.filter(
        entry => entry.requestId === request.requestId &&
                 ['booked', 'pending', 'started'].includes(entry.workStatus)
      );

      if (calendarEntries.length === 0) {
        // No schedule found, just update due date
        await this.updateRequest(updatedRequest);

        await this.addRequestState(
          request.requestId,
          "dealer_reschedule_minor",
          null,
          "DEADLINE_CHANGE",
          `Schedule updated: Available ${moment(newAvailableDate).format("MM/DD/YYYY")}, Due ${moment(newDueDate).format("MM/DD/YYYY")}. No active schedule found.`
        );

        alert("Schedule updated successfully.");
        window.location.reload();
        return;
      }

      // Check if current schedule fits within new deadline
      const sortedEntries = _.orderBy(calendarEntries, 'workDate', 'asc');
      const currentScheduledStart = moment(sortedEntries[0].workDate);
      const currentScheduledEnd = moment(sortedEntries[sortedEntries.length - 1].workDate);

      // Calculate original window
      const originalAvailableDate = moment(request.availableDate);
      const newDueDateMoment = moment(newDueDate);

      // Check if schedule fits in new window
      const scheduleFitsInNewWindow =
        currentScheduledStart.isSameOrAfter(originalAvailableDate) &&
        currentScheduledEnd.isSameOrBefore(newDueDateMoment);

      if (scheduleFitsInNewWindow) {
        // Schedule unchanged - minor reschedule
        await this.updateRequest(updatedRequest);

        await this.addRequestState(
          request.requestId,
          "dealer_reschedule_minor",
          null,
          "DEADLINE_CHANGE",
          `Schedule updated: Available ${moment(newAvailableDate).format("MM/DD/YYYY")}, Due ${moment(newDueDate).format("MM/DD/YYYY")}. Existing schedule (${currentScheduledStart.format("MM/DD")} - ${currentScheduledEnd.format("MM/DD")}) unchanged.`
        );

        // TODO: Send SMS notification to specialist about new deadline
        console.log("TODO: Send SMS to specialist about deadline change");

        ReactGA.event({
          category: "Dealer",
          action: "Reschedule Minor (Schedule Unchanged)",
          label: "prod",
        });

        alert("Schedule updated. Specialist's work dates remain unchanged and they've been notified of the new timeline.");
        window.location.reload();
      } else {
        // Schedule conflicts - major reschedule (specialist must re-book)
        await this.updateRequest(updatedRequest);

        // Clear the calendar entries (specialist must re-book)
        const offer = {
          requestId: request.requestId,
          installerId: request.assignedTo,
          currentStatus: "rescheduled",
          startDate: convertToUTC(new Date()).format("YYYY-MM-DD HH:mm:ss"),
          dateUpdated: convertToUTC(new Date()).format("YYYY-MM-DD HH:mm:ss"),
        };

        await this.deleteInstallerCalendar(offer);

        // Update request_offered status back to "offered" so installer can re-book
        const updatedOffer = {
          requestId: request.requestId,
          installerId: request.assignedTo,
          currentStatus: "offered",
          dateUpdated: convertToUTC(new Date()).format("YYYY-MM-DD HH:mm:ss"),
        };
        await this.updateRequestOffered(updatedOffer);

        // Delete Google Calendar event if exists
        if (this.state.authenticated === 1) {
          try {
            await this.delAppointmentSilently(request.requestId);
          } catch (calendarError) {
            console.error('Failed to delete calendar event:', calendarError);
          }
        }

        // Update request state to 'new' so specialist can re-book
        updatedRequest.currentState = 'new';
        await this.updateRequest(updatedRequest);

        await this.addRequestState(
          request.requestId,
          "dealer_reschedule_major",
          null,
          "SCHEDULE_CONFLICT",
          `Schedule updated: Available ${moment(newAvailableDate).format("MM/DD/YYYY")}, Due ${moment(newDueDate).format("MM/DD/YYYY")}. Previous schedule (${currentScheduledStart.format("MM/DD")} - ${currentScheduledEnd.format("MM/DD")}) cleared. Specialist must re-book.`
        );

        // TODO: Send SMS notification to specialist that they must re-book
        console.log("TODO: Send SMS to specialist - must re-book");

        ReactGA.event({
          category: "Dealer",
          action: "Reschedule Major (Requires Re-booking)",
          label: "prod",
        });

        alert("Schedule updated. The new timeline conflicts with the existing schedule, so it has been cleared. The specialist will need to re-book their work.");
        window.location.reload();
      }

    } catch (error) {
      console.error('Error during dealer reschedule:', error);
      alert('Error rescheduling job. Please try again.');
    }
  };

  handleReject = async (request) => {
    // Show modal for confirmation and reason collection
    this.setState({
      showRejectModal: true,
      requestToReject: request
    });
  };

  handleRejectConfirm = async (result) => {
    // Close modal
    this.setState({ showRejectModal: false });

    const request = this.state.requestToReject;

    if (!result.confirmed || !request) {
      this.setState({ requestToReject: null });
      return;
    }

    // This is for operational tracking (wrong vehicle, installer unavailable, etc.)
    // NOT for business loss tracking - that's handled in handleDelete

    const offer = {
      requestId: request.requestId,
      installerId: parseInt(this.state.typeId),
      currentStatus: "rejected",
      startDate: convertToUTC(new Date()).format("YYYY-MM-DD HH:mm:ss"),
      dateUpdated: convertToUTC(new Date()).format("YYYY-MM-DD HH:mm:ss"),
    };

    // update the database
    let offered = await this.updateRequestOfferedState(offer);

    // Add request_state tracking for rejections with user-provided reason
    let astate = await this.addRequestState(
      request.requestId,
      "rejected",
      null,
      result.reasonCode,
      result.reasonNotes
    );

    // delete the draft calendar entries
    if (this.state.authenticated === 1) {
      try {
        await this.delAppointmentSilently(request.requestId);
      } catch (calendarError) {
        // Completely silent - no user notification
      }
    }
    // update the installer Calendar
    let calendar = await this.deleteInstallerCalendar(offer);

    Promise.all([offered, calendar, astate]).then(() => {
      if (request.requestType === "dealer") {
        ReactGA.event({
          category: "Installer",
          action: "Rejected Request",
          label: "prod",
        });
        alert("We'll let them know you aren't available");
      } else {
        ReactGA.event({
          category: "Installer",
          action: "Estimate Rejected",
          label: "prod",
        });
        alert("Rejection recorded. The dealer will be notified.");
      }

      // Clear the request to reject
      this.setState({ requestToReject: null });

      this.clearRequestimate();
      window.location = "/requestimates";
    });
  };

  handleSelect = (row) => {
    this.setState({ selectedInstaller: row });
  };

  handleSelectService = (row) => {
    //  //console.log("Selected Service is :", row)
    this.setState({ selectedService: row, rowSelected: true });
  };

  handleSelectInstaller = (row) => {
    //  //console.log("Request : Here's the passed Installer : ", row)
    this.setState({ selectedInstaller: row, rowSelected: true });
  };

  handleAssign = async (request, installer) => {
    // Only used for a request by a dealer
    // set up the rquest

    //  //console.log("Assigning job to installer : ", installer);
    const updatedRequestimate = request;
    updatedRequestimate.currentState = "scheduled";
    updatedRequestimate.assignedTo = this.state.selectedInstaller.installerId;
    // set up the offer
    const offer = {
      requestId: updatedRequestimate.requestId,
      installerId: this.state.selectedInstaller.installerId,
      currentStatus: updatedRequestimate.currentState,
      dateUpdated: convertToUTC(new Date()).format("YYYY-MM-DD HH:mm:ss"),
      startDate: convertToUTC(installer.startDate).format(
        "YYYY-MM-DD HH:mm:ss"
      ),
    };
    // update the request
    let urequest = await this.updateRequest(updatedRequestimate);
    //update the request offer
    let uoffered = await this.updateRequestOffered(offer);
    // update the installer Calendar for the specific service
    let ucalendar = await this.updateInstallerCalendar(offer, null, "booked");
    // add an audit record to the table
    let astate = await this.addRequestState(
      request.requestId,
      updatedRequestimate.currentState,
      null
    );
    this.setState({ selectedOffer: {} });
    await this.clearRequestimate();
    Promise.all([urequest, uoffered, ucalendar, astate]).then(() => {
      //    //console.log ("Handle Assign : request : ", request);

      let data = {
        messageType: "User",
        messagePlatform: "SMS",
        userType: "installer",
        id: updatedRequestimate.assignedTo,
        text: `${this.props.companyName} has assigned you a job. https://jobvious.app`,
      };
      this.sendMessage(data);

      ReactGA.event({
        category: "Dealer",
        action: "Assigned Work",
        label: "prod",
      });
      alert("We'll schedule the work with your installer immediately");
      window.location = "/jobs?filter=scheduled";
    });
  };

  handleReceive = async (request, vin) => {
    // Only used for a request by a dealer
    // set up the rquest

    // update the vehicle record for the request VIN
    // if its a duplicate, then drop the NV record
    const updatedRequestimate = request;
    updatedRequestimate.currentState = "received";

    if (vin.length > 0) {
      await this.updateVehicle(request.vin, vin);
      updatedRequestimate.vin = vin;
    }

    // update the request
    let urequest = await this.updateRequest(updatedRequestimate);
    const offer = {
      requestId: updatedRequestimate.requestId,
      installerId: parseInt(this.state.typeId),
      currentStatus: updatedRequestimate.currentState,
      dateUpdated: convertToUTC(new Date()).format("YYYY-MM-DD HH:mm:ss"),
    };
    let uoffered = await this.updateRequestOfferedState(offer);

    // Mark customer as owned by installer when vehicle received (WIN moment)
    if (request.requestType === "installer") {
      // Transfer customer ownership from prospect to customer owned by this installer
      await this.updateCustomer(request.requestor);
    }

    // add an audit record to the table - Mark as WIN when vehicle received
    let astate = await this.addRequestState(
      request.requestId,
      updatedRequestimate.currentState,
      null,
      "WIN",  // reasonCode: This is a business win!
      "Vehicle received - customer committed to service"  // reasonNotes
    );
    this.setState({ selectedOffer: {} });
    Promise.all([urequest, uoffered, astate]).then(() => {
      if (updatedRequestimate.requestType === "dealer") {
        // For dealer jobs, notify the dealer contact person
        const contactId = request.dealerContact || request.dealer_contact || request.requestor;
        let data = {
          messageType: "User",
          messagePlatform: "SMS",
          userType: "dealer",
          id: contactId,
          text: `${this.props.companyName} has received your vehicle`,
        };

        this.sendMessage(data);
      }
      window.location = "/jobs?filter=inprogress";
    });
  };

  handleStart = async (request, thisJob, serviceObj) => {
    if (!window.confirm('Start this service? The customer will be notified.')) return;
    // Only used for a job by an installer
    // serviceObj is now the full service object from services_ (not just service_id)
    const serviceId = serviceObj.service_id;
    console.log("Handle Start", request, thisJob, serviceObj, "serviceId:", serviceId);

    const requestService = {
      requestServiceId: serviceObj.id,
      requestId: request.requestId,
      serviceId: serviceId,
      serviceState: "started",
      serviceDate: convertToUTC(new Date()).format("YYYY-MM-DD HH:mm:ss"),
      materials: this.state.materials,
      template: this.state.template,
    };
    // NOTE: Customer ownership is now transferred when vehicle is RECEIVED (WIN moment)
    // not when work starts. See handleReceive() for customer ownership transfer.

    // update the service
    const calendar = {
      requestId: request.requestId,
      installerId: parseInt(this.state.typeId),
    };
    // update the services on the original request
    //
    // This is the first server write of the start sequence, and the deposit gate lives on
    // it. Catching here matters: the calls below (calendar, audit state, request update)
    // are not transactional, so letting a 409 escape mid-sequence would leave the job
    // half-started.
    try {
      await this.updateRequestServices(requestService);
    } catch (error) {
      if (error.response?.status === 409 && error.response?.data?.code === 'DEPOSIT_UNPAID') {
        alert(error.response.data.message ||
          'The deposit must be paid before work can start on this job.');
        return;
      }
      console.error('Error starting service:', error);
      alert('Unable to start this service. Please try again.');
      return;
    }

    // update the appointments in the installer's calendar
    await this.updateInstallerCalendar(
      calendar,
      requestService.serviceId,
      "started",
      serviceObj.id
    );

    // log the change on the request in the audit log
    await this.addRequestState(
      requestService.requestId,
      "start",
      serviceId
    );

    // if it's the first service on the job, update the request
    // all the services in thisJob will be "booked"

    if (request.currentState === "received") {
      const updatedRequestimate = request;
      updatedRequestimate.currentState = "started";
      // update the request
      await this.updateRequest(updatedRequestimate);
      // update the offer
      const offer = {
        requestId: updatedRequestimate.requestId,
        installerId: parseInt(this.state.typeId),
        currentStatus: updatedRequestimate.currentState,
        dateUpdated: convertToUTC(new Date()).format("YYYY-MM-DD HH:mm:ss"),
      };
      await this.updateRequestOfferedState(offer);

      // add an audit record to the table
      await this.addRequestState(
        requestService.requestId,
        updatedRequestimate.currentState,
        null
      );
      this.setState({ selectedRequestimate: updatedRequestimate });
      //console.log("Handle Start : request : ", request);
      await this.updateReferralStatusFromRequest('started');

      if (request.requestType === "dealer") {
        // For dealer jobs, notify the dealer contact person
        const contactId = request.dealerContact || request.dealer_contact || request.requestor;
        let data = {
          messageType: "User",
          messagePlatform: "SMS",
          userType: "dealer",
          id: contactId,
          text: `${this.props.companyName} has started work on your vehicle`,
        };
        this.sendMessage(data);
      } else {
        // For retail/customer jobs, notify the customer on record
        let data = {
          messageType: "Customer",
          messagePlatform: "SMS",
          userType: "customer",
          id: request.requestor,
          text: `${this.props.companyName} has started work on your vehicle`,
        };
        this.sendMessage(data);
      }
      ReactGA.event({
        category: "Installer",
        action: "Started Job",
        label: "prod",
      });
      alert("We'll let them know you've started the work");
      window.location = "/jobs?filter=inprogress";
    }

    ReactGA.event({ category: "Installer", action: "Started Service" });
    await this.clearRequestimate();

    window.location = "/jobs?filter=inprogress";
  };

  handleFinish = async (request, thisJob, serviceObj) => {
    // serviceObj is now the full service object from services_ (not just service_id)

    // For dealers or if no category configs loaded, skip materials collection
    if (this.state.userType !== 'installer') {
      await this.completeServiceFinish(request, thisJob, serviceObj);
      return;
    }

    if (Object.keys(this.state.categoryConfigs).length === 0) {
      await this.completeServiceFinish(request, thisJob, serviceObj);
      return;
    }

    // Check shop-level materials tracking setting
    const materialsTrackingEnabled = this.props.company?.materials_tracking_enabled !== false;

    // Check if material tasks are already completed (e.g., by technician)
    const tasks = this.state.itemsByServiceId[serviceObj.id] || (serviceObj.items || []);
    const materialTasks = tasks.filter(t => t.type === 'material');
    const allMaterialsDone = materialTasks.length > 0 &&
      materialTasks.every(t => t.status === 'completed' || t.status === 'skipped');

    // Gate on having incomplete MATERIAL tasks (not on category data_collect), so a bundled
    // product on a non-data-collect service still captures/deducts at handover.
    if (materialsTrackingEnabled && !allMaterialsDone && materialTasks.length > 0) {
      // Show per-item capture for incomplete material tasks
      const incompleteTasks = materialTasks.filter(t => t.status !== 'completed' && t.status !== 'skipped');
      this.setState({
        showItemCaptureModal: true,
        itemCaptureService: serviceObj,
        itemCaptureItems: incompleteTasks,
        itemCaptureRequest: request,
        itemCaptureJob: thisJob,
        itemCaptureMode: 'single'
      });
    } else {
      // No data collection needed (no material tasks, or all already done)
      await this.completeServiceFinish(request, thisJob, serviceObj);
    }
  };

  // Handle per-item material capture completion (from ItemMaterialCaptureModal)
  handleItemCaptureComplete = async () => {
    const { itemCaptureRequest, itemCaptureJob, itemCaptureService, itemCaptureMode } = this.state;
    this.setState({
      showItemCaptureModal: false,
      itemCaptureService: null,
      itemCaptureItems: [],
      itemCaptureRequest: null,
      itemCaptureJob: null,
      itemCaptureMode: null
    });
    if (!itemCaptureService) return;

    // Discriminate on the explicit mode set when the modal was opened — NOT on
    // Array.isArray(itemCaptureJob). Both the single-finish path (thisJob) and the
    // complete-all path (servicesArray) pass an array as itemCaptureJob, so the old
    // array check always took the complete-all branch and finishing one service
    // closed the entire job.
    if (itemCaptureMode === 'all') {
      await this.completeAllServicesFinish(itemCaptureRequest, itemCaptureJob);
    } else {
      await this.completeServiceFinish(itemCaptureRequest, itemCaptureJob, itemCaptureService);
    }
  };

  // VIN verified from VINRequiredModal — resume handleCompleteEstimate
  handleVINVerifiedForComplete = (vin) => {
    const { vinRequiredRequest, vinRequiredStartDate } = this.state;
    vinRequiredRequest.vin = vin;
    this.setState({
      showVINRequiredModal: false,
      vinRequiredRequest: null,
      vinRequiredStartDate: null
    }, () => {
      this.handleCompleteEstimate(vinRequiredRequest, vinRequiredStartDate);
    });
  };

  // User chose to skip VIN entry — proceed with completion as-is
  handleVINSkipForComplete = () => {
    const { vinRequiredRequest, vinRequiredStartDate } = this.state;
    vinRequiredRequest._vinCheckSkipped = true;
    this.setState({
      showVINRequiredModal: false,
      vinRequiredRequest: null,
      vinRequiredStartDate: null
    }, () => {
      this.handleCompleteEstimate(vinRequiredRequest, vinRequiredStartDate);
    });
  };

  // Complete a single service finish (called after materials collection or directly)
  // serviceObj is the full service row object (has .id for row PK and .service_id for master service FK)
  completeServiceFinish = async (request, thisJob, serviceObj, forceComplete = false) => {
    const serviceId = serviceObj.service_id || serviceObj;
    const requestServiceId = serviceObj.id || null;

    const requestService = {
      requestServiceId: requestServiceId,
      requestId: request.requestId,
      serviceId: serviceId,
      serviceState: "finished",
      serviceDate: convertToUTC(new Date()).format("YYYY-MM-DD HH:mm:ss")
    };

    if (forceComplete) {
      requestService.force_complete = true;
    }

    try {
      await this.updateRequestServices(requestService);
    } catch (error) {
      // Check for task completion guard (400 with task_status)
      if (error.response && error.response.status === 400 && error.response.data?.task_status) {
        const taskStatus = error.response.data.task_status;
        this.setState({
          showItemGuardModal: true,
          itemGuardData: {
            serviceName: (serviceObj?.service_category ? `${serviceObj.service_category} - ` : '') + (serviceObj?.description || serviceObj?.custom_description || 'Unknown Service'),
            taskStatus,
            retryCallback: () => {
              this.setState({ showItemGuardModal: false, itemGuardData: null });
              this.completeServiceFinish(request, thisJob, serviceObj, true);
            }
          }
        });
        return;
      }
      throw error;
    }

    // Audit and calendar updates only after successful state change
    await this.addRequestState(
      request.requestId,
      "finish",
      serviceId
    );

    await this.updateInstallerCalendar(
      request,
      serviceId,
      "finished",
      requestServiceId
    );

    ReactGA.event({
      category: "Installer",
      action: "Finished Service",
      label: "prod",
    });

    await this.clearRequestimate();
    window.location = "/jobs?filter=inprogress";
  };

handleComplete = async (request, servicesArray) => {
  // Check if installer has Stripe account set up
  if (!this.state.installer.stripe_account_id || !this.state.installer.onboarding_complete) {
    alert(
      "⚠️ Payment Account Required\n\n" +
      "You must complete your payment account setup before you can complete jobs.\n\n" +
      "Please click on 'Profile' in the navigation menu (look for the ⚠️ warning icon) to set up your payment account.\n\n" +
      "This is a one-time setup that takes about 3-5 minutes."
    );
    return;
  }

  // Check if Stripe capabilities are active
  if (!this.validateStripeCapabilities()) return;

  // CarFax data guard: For retail (installer-sourced) jobs where CarFax is not opted out,
  // require odometer reading and plate state before completion
  if (request.requestType === 'installer' && !this.state.checkinCarfaxOptOut) {
    const hasOdometer = this.state.checkinOdometerReading && String(this.state.checkinOdometerReading).trim() !== '';
    const hasPlate = this.state.checkinPlate && String(this.state.checkinPlate).trim() !== '';
    if (!hasOdometer || !hasPlate) {
      this.setState({
        showCarFaxDataModal: true,
        carfaxDataRequest: request,
        carfaxDataServicesArray: servicesArray
      });
      return;
    }
  }

  // Check for unfinished services — show confirmation modal if any exist
  const unfinishedServices = servicesArray.filter(s => s.service_state !== 'finished');
  if (unfinishedServices.length > 0) {
    this.setState({
      showCompletionConfirmModal: true,
      completionConfirmData: { request, servicesArray, unfinishedServices }
    });
    return;
  }

  // All services finished — proceed directly
  await this.handleCompleteAfterConfirmation(request, servicesArray);
};

handleCompleteAfterConfirmation = async (request, servicesArray) => {
  // Guard 1: block re-entrant invoicing.
  if (this._invoiceInFlight) return;

  // Guard 3: warn if another request for this VIN is already completed/invoiced.
  // Placed here (the common downstream of both the direct and confirm-modal
  // resume paths) so it fires regardless of how completion was reached.
  if (!request._dupInvoiceAck) {
    const gVin = normalizeVin(request.vin);
    if (!isPlaceholderVin(gVin)) {
      try {
        const rows = await getRequestsByVin(request.assignedTo || this.state.typeId, gVin);
        const others = findCompletedOtherForVin(rows, request.requestId);
        if (others.length) {
          this.setState({ showInvoiceDupModal: true, invoiceDupData: { mode: 'complete', request, servicesArray, matches: others } });
          return;
        }
      } catch (dupErr) {
        console.warn("VIN invoice-duplicate check failed, proceeding:", dupErr);
      }
    }
  }

  // For dealers or if no category configs loaded, skip materials collection
  if (this.state.userType !== 'installer' || Object.keys(this.state.categoryConfigs).length === 0) {
    await this.completeAllServicesFinish(request, servicesArray);
    return;
  }

  // Shop-level materials tracking toggle (mirrors handleFinish).
  const materialsTrackingEnabled = this.props.company?.materials_tracking_enabled !== false;

  // Find services with incomplete material tasks. Gate on having incomplete
  // MATERIAL tasks (not on category data_collect), so a bundled product on a
  // non-data-collect service still captures/deducts at handover — same rule as
  // the per-service handleFinish path.
  const servicesWithIncompleteTasks = [];
  if (materialsTrackingEnabled) {
    servicesArray.forEach(service => {
      const tasks = this.state.itemsByServiceId[service.id] || (service.items || []);
      const materialTasks = tasks.filter(t => t.type === 'material');
      const incompleteTasks = materialTasks.filter(t => t.status !== 'completed' && t.status !== 'skipped');

      if (incompleteTasks.length > 0) {
        servicesWithIncompleteTasks.push({ service, incompleteTasks });
      }
    });
  }

  if (servicesWithIncompleteTasks.length > 0) {
    // Show per-item capture for the first service with incomplete tasks
    const first = servicesWithIncompleteTasks[0];
    this.setState({
      showItemCaptureModal: true,
      itemCaptureService: first.service,
      itemCaptureItems: first.incompleteTasks,
      itemCaptureRequest: request,
      itemCaptureJob: servicesArray,
      itemCaptureMode: 'all'
    });
  } else {
    // No services need data collection
    await this.completeAllServicesFinish(request, servicesArray);
  }
};

// Handler for CarFax opt-out (from warning banner or modal)
handleCarfaxOptOut = async (requestId) => {
  try {
    await API.patch(`/requests/${requestId}/checkin/data`, { carfax_opt_out: true });
    const { carfaxDataRequest, carfaxDataServicesArray } = this.state;
    this.setState({
      checkinCarfaxOptOut: true,
      showCarFaxDataModal: false,
      carfaxDataRequest: null,
      carfaxDataServicesArray: null
    }, () => {
      // If opt-out was triggered from the completion guard modal, resume completion
      if (carfaxDataRequest && carfaxDataServicesArray) {
        this.handleComplete(carfaxDataRequest, carfaxDataServicesArray);
      }
    });
  } catch (error) {
    console.error('Error opting out of CarFax:', error);
    alert('Failed to update CarFax setting. Please try again.');
  }
};

// Handler for when CarFax data is collected via the modal
handleCarFaxDataComplete = (odometerReading, plate) => {
  const { carfaxDataRequest, carfaxDataServicesArray } = this.state;
  this.setState({
    showCarFaxDataModal: false,
    carfaxDataRequest: null,
    carfaxDataServicesArray: null,
    checkinOdometerReading: odometerReading,
    checkinPlate: plate
  }, () => {
    // Resume the completion flow now that data is captured
    if (carfaxDataRequest && carfaxDataServicesArray) {
      this.handleComplete(carfaxDataRequest, carfaxDataServicesArray);
    }
  });
};

// Completion Confirmation Modal handlers
handleCompletionConfirmed = async () => {
  const { request, servicesArray } = this.state.completionConfirmData;
  this.setState({ showCompletionConfirmModal: false, completionConfirmData: null });
  await this.handleCompleteAfterConfirmation(request, servicesArray);
};

handleCompletionCancelled = () => {
  this.setState({ showCompletionConfirmModal: false, completionConfirmData: null });
};

// Reopen Job Modal handlers
handleShowReopenModal = (request) => {
  this.setState({ showReopenModal: true, reopenRequest: request });
};

handleHideReopenModal = () => {
  this.setState({ showReopenModal: false, reopenRequest: null });
};

handleReopenJob = async ({ reasonCode, reasonNotes }) => {
  const request = this.state.reopenRequest;
  if (!request) return;

  try {
    // 1. Delete the draft invoice (also cleans up DB records)
    await this.deleteInvoice(request.invoiceId);

    // 2. Reverse inventory deductions
    try {
      await InventoryAPI.reverseDeductions(request.requestId, this.state.user.User_id);
    } catch (invErr) {
      console.error('Inventory reversal failed (non-blocking):', invErr);
    }

    // 3. Reset all services to started
    const requestService = {
      requestId: request.requestId,
      serviceState: "started",
      serviceDate: convertToUTC(new Date()).format("YYYY-MM-DD HH:mm:ss"),
    };
    await this.updateRequestAllServices(requestService);

    // 4. Update request state to started
    const updatedRequest = { ...request, currentState: "started" };
    await this.updateRequest(updatedRequest);

    // 5. Update request_offered state to started
    const offer = {
      requestId: request.requestId,
      installerId: parseInt(this.state.typeId),
      currentStatus: "started",
      dateUpdated: convertToUTC(new Date()).format("YYYY-MM-DD HH:mm:ss"),
    };
    await this.updateRequestOfferedState(offer);

    // 6. Update calendar entries back to booked
    const services = this.state.services || [];
    for (const svc of services) {
      try {
        await this.updateInstallerCalendar(request, svc.serviceId || svc.service_id, "booked", svc.id || null);
      } catch (calErr) {
        console.error('Failed to update calendar for service:', svc.serviceId || svc.service_id, calErr);
      }
    }

    // 7. Add reopen state history
    await this.addRequestState(request.requestId, "reopen", null, reasonCode, reasonNotes);

    // 8. Clear and redirect
    await this.clearRequestimate();
    this.setState({ showReopenModal: false, reopenRequest: null });
    window.location = "/jobs";
  } catch (error) {
    console.error('Error reopening job:', error);
    alert('Failed to reopen job. Please try again.');
  }
};

// Complete all services finish - actual completion logic
completeAllServicesFinish = async (request, thisJob) => {
  // Guard 1: block re-entrant invoicing. This is the single choke point for the
  // whole-job invoice, so the flag here protects every path that reaches it.
  if (this._invoiceInFlight) return;
  this._invoiceInFlight = true;
  this.setState({ submitting: true });
  try {
  const requestService = {
    requestId: request.requestId,
    serviceState: "finished",
    serviceDate: convertToUTC(new Date()).format("YYYY-MM-DD HH:mm:ss"),
  };

  await this.addRequestState(
    request.requestId,
    "finish",
    null
  );

  try {
    await this.updateRequestAllServices(requestService);
  } catch (error) {
    // Check for task completion guard (400 with task_status)
    if (error.response && error.response.status === 400 && error.response.data?.task_status) {
      const taskStatus = error.response.data.task_status;
      this.setState({
        showItemGuardModal: true,
        itemGuardData: {
          serviceName: 'All Services',
          taskStatus,
          retryCallback: () => {
            this.setState({ showItemGuardModal: false, itemGuardData: null });
            // Retry with force_complete
            const forceService = { ...requestService, force_complete: true };
            this.updateRequestAllServices(forceService).then(() => {
              window.location = "/jobs?filter=inprogress";
            });
          }
        }
      });
      return;
    }
    throw error;
  }

  ReactGA.event({
    category: "Installer",
    action: "Finished Job",
    label: "prod",
  });

  const updatedRequestimate = request;
  updatedRequestimate.currentState = "finished";

  // Remove automatic invoice creation from updateRequest
  await this.updateRequest(updatedRequestimate);

  const offer = {
    requestId: updatedRequestimate.requestId,
    installerId: parseInt(this.state.typeId),
    currentStatus: updatedRequestimate.currentState,
    dateUpdated: convertToUTC(new Date()).format("YYYY-MM-DD HH:mm:ss"),
  };
  await this.updateRequestOfferedState(offer);

  await this.addRequestState(
    request.requestId,
    updatedRequestimate.currentState,
    null
  );

  // Update installer calendar for each service to "finished"
  if (Array.isArray(thisJob)) {
    for (const svc of thisJob) {
      try {
        await this.updateInstallerCalendar(request, svc.serviceId || svc.service_id, "finished", svc.id || null);
      } catch (calErr) {
        console.error('Failed to update calendar for service:', svc.serviceId || svc.service_id, calErr);
      }
    }
  }

  await this.updateReferralStatusFromRequest('finished');

  // Invoice draft creation at completion — both installer and dealer.
  // Server creates the deferred draft + sends the appropriate pickup email
  // (retail vs dealer template).
  try {
    console.log("DRAFT: Creating invoice draft for completed job:", request.requestId);
    const invoice = {
      invoiceId: request.requestId,
      invoiceType: request.requestType,
    };

    const { data } = await API.post('/invoices/', invoice);

    if (data.error) {
      console.error("DRAFT: Server rejected invoice creation:", data.message);
      alert(data.message || "Unable to create invoice for this request.");
      await this.clearRequestimate();
      window.location = "/pickups";
      return;
    }

    if (data.draft === true) {
      console.log("DRAFT: Invoice draft created, paymentId:", data.paymentId);
    } else {
      const invoiceId = data.invoiceId;
      console.log("EXPLICIT: Invoice created successfully:", invoiceId);
      if (invoiceId) {
        updatedRequestimate.invoiceId = invoiceId;
        await this.updateRequest(updatedRequestimate);
      }
    }

  } catch (invoiceError) {
    const notReady = invoiceError?.response?.data?.stripeNotReady;
    if (notReady) {
      console.warn(
        'Invoice not created: Stripe not ready -',
        invoiceError.response.data.reason,
        'for request',
        request.requestId
      );
    } else {
      console.error("DRAFT: Invoice creation failed for request", request.requestId, ":", invoiceError);
      await this.logPaymentFailure('invoice_creation', 'handleComplete', invoiceError);
      alert("Job completed successfully, but there was an issue creating the invoice. Please check the invoices section or contact support.");
    }
  }

  await this.clearRequestimate();

  console.log("Handle Complete : request : ", request);

  ReactGA.event({
    category: "Installer",
    action: "Finished Job",
    label: "prod",
  });
  alert("Job completed successfully");
  window.location = "/pickups";
  } finally {
    this._invoiceInFlight = false;
    this.setState({ submitting: false });
  }
};

// Guard 3 modal handlers — resume the acknowledged invoice action.
handleInvoiceDupConfirm = () => {
  const data = this.state.invoiceDupData;
  this.setState({ showInvoiceDupModal: false, invoiceDupData: null });
  if (!data || !data.request) return;
  data.request._dupInvoiceAck = true;
  if (data.mode === 'estimate') {
    this.handleCompleteEstimate(data.request, data.startDate);
  } else {
    this.handleCompleteAfterConfirmation(data.request, data.servicesArray);
  }
};

handleInvoiceDupCancel = () => {
  this.setState({ showInvoiceDupModal: false, invoiceDupData: null });
};

handleSettle = async (request, invoice, paymentMethod, checkNumber) => {
  // Only used for a job by an installer
//  //console.log("Mark as paid");
//  //console.log("Settle Request", request);
  if (request){
  await this.settleInvoice(invoice);

  await this.updatePayment(request, paymentMethod);
    // if there is a check number then update the installer payment table with the check number in the payment_id field
    if (checkNumber)
      await this.updateInstallerPayment(request.requestId, checkNumber);

  }
  await this.addRequestState(request.requestId, "paid", null);
   ReactGA.event({category: 'Installer', action: 'Paid for Service', label: 'dev'});
   alert("We've marked the invoice as closed with payment collected");
   window.location = "/pickups";
};

  // Offline settlement — records cash/check payment directly in DB when Stripe is unavailable
  settleOffline = async (paymentMethod) => {
    const { draftPayment, selectedRequestimate } = this.state;
    if (!draftPayment) {
      alert('No payment record found. Please try again.');
      return;
    }

    try {
      const body = { paymentMethod: paymentMethod === 'Check' ? 'check' : 'cash' };
      if (paymentMethod === 'Check') {
        body.checkNumber = this.state.checkNumber.trim();
      }

      await API.post(`/invoices/${draftPayment.paymentId}/settle-offline`, body);

      await this.addRequestState(selectedRequestimate.requestId, "paid", null);
      ReactGA.event({ category: 'Installer', action: 'Paid for Service (Offline)', label: 'prod' });
      alert("Payment recorded successfully.");
      window.location = "/pickups";
    } catch (err) {
      console.error('SETTLE-OFFLINE: Failed:', err);
      alert('Unable to record payment. Please try again.');
    }
  };

  // DEAD as of the Check Out / Deliver split — no caller. See tasks/deliver-flow-spec.md §8.
  handleResend = async (invoice) => {
    // Only used for a job by an installer
    this.resendInvoice(invoice);
    alert("A copy of the invoice has been sent");
    window.location = "/pickups";
  };

  handleResendDraftEmail = async () => {
    // Re-send the work-complete email (with pay link) to the customer
    // Server: PUT /invoices/resend/:requestId (numeric = draft resend)
    try {
      const request = this.state.selectedRequestimate;
      await this.resendInvoice(request.requestId);
      alert("Work-complete email has been resent to the customer.");
    } catch (error) {
      alert("Failed to resend email. Please try again.");
    }
  };

  // DEAD as of the Check Out / Deliver split — no caller. See tasks/deliver-flow-spec.md §8.
  // Send Invoice — materialize the invoice if one doesn't exist yet, then send it.
  // Fixes the process hole where "Send/Resend Invoice" only ever resent an
  // already-materialized invoice. If a real Stripe invoice exists, (re)send it.
  // Otherwise create a draft (if needed) and materialize via 'send' to produce an
  // open/unpaid Stripe invoice and email the customer the pay link. The customer
  // self-serve "pay ahead" email (sent at finish) is unaffected by this path.
  handleSendInvoice = async () => {
    const request = this.state.selectedRequestimate;
    if (!request) return;

    // A real Stripe invoice already exists — just (re)send it.
    if (this.state.invoice && this.state.invoice.id) {
      try {
        await this.resendInvoice(this.state.invoice.id);
        alert("A copy of the invoice has been sent to the customer.");
      } catch (err) {
        console.error('SEND INVOICE: resend failed', err);
        alert("Failed to send the invoice. Please try again.");
      }
      return;
    }

    // No invoice yet — materialize one. Step 1: ensure a draft exists in state
    // (POST /invoices/ is idempotent — returns the existing draft if there is one).
    if (!this.state.draftPayment) {
      try {
        const { data } = await API.post('/invoices/', {
          invoiceId: request.requestId,
          invoiceType: request.requestType,
        });
        if (data.error) {
          alert(data.message || 'Unable to create the invoice. Please try again.');
          return;
        }
        if (data.draft === true) {
          await new Promise(resolve => this.setState({
            draftPayment: { paymentId: data.paymentId, amount: data.amount, paymentToken: data.paymentToken },
          }, resolve));
        } else if (data.invoiceId) {
          // Server returned a real invoice directly — load it and record it.
          await this.readInvoice(data.invoiceId);
          const updatedRequest = { ...request, invoiceId: data.invoiceId };
          await this.updateRequest(updatedRequest);
          this.setState({ selectedRequestimate: updatedRequest });
          alert("Invoice created and sent to the customer.");
          return;
        } else {
          alert('Unable to create the invoice. Please try again or contact support.');
          return;
        }
      } catch (err) {
        console.error('SEND INVOICE: failed to create draft', err);
        alert('Unable to create the invoice. Please try again or contact support.');
        return;
      }
    }

    // Step 2: materialize the draft via 'send' — creates the open/unpaid Stripe
    // invoice and emails the customer. materializeInvoice loads the invoice into
    // state and stores invoiceId on the request on success.
    if (this.state.draftPayment) {
      const result = await this.materializeInvoice('send');
      if (!result.success) {
        this.openStripeRecoveryModal({
          request,
          reason: result.reason,
          locationName: result.locationName,
          detail: result.message,
        });
        return;
      }
      alert("Invoice created and sent to the customer.");
    }
  };

  handleVoidAndEdit = async (request) => {
    // Delete/void any existing invoice, delete DB draft, then open edit page.
    // On save, editJob redirects back to Pickups. On record open, no draft/invoice is found,
    // so we auto-create a fresh one with the updated amounts.
    try {
      // Delete/void the Stripe invoice if one exists
      if (this.state.invoice && this.state.invoice.id) {
        // Finalized invoices trigger a cancellation email — confirm with the user
        const invoiceStatus = this.state.invoice.status;
        if (invoiceStatus === 'open' || invoiceStatus === 'paid') {
          const confirmed = window.confirm(
            'This invoice has been sent to the customer. Voiding it will send them a cancellation notice. Continue?'
          );
          if (!confirmed) return;
        }
        await this.deleteInvoice(this.state.invoice.id);
      }

      // Delete the DB draft payment so a fresh one is created on return
      if (this.state.draftPayment && this.state.draftPayment.paymentId) {
        await this.deletePayment(this.state.draftPayment.paymentId);
      }

      // Clear invoiceId on the request so auto-recreate fires on return
      if (request.invoiceId) {
        const updatedRequest = { ...request, invoiceId: null };
        await this.updateRequest(updatedRequest);
      }

      // Navigate to edit page — same as handleEdit
      window.location = "/editJob/" + request.requestId;
    } catch (err) {
      console.error('Failed to void invoice:', err);
      alert('Unable to void invoice. Please try again.');
    }
  };

  handleFinalize = async (invoice) => {
    // Only used for a job by an installer
    //  //console.log("Finalizing invoice");
    await this.finalizeInvoice(invoice);
    alert("A copy of the invoice has been sent");
    window.location = "/pickups";
  };

  // Check Out → "Send invoice" for a dealer job. Materializes the draft into an
  // open/unpaid Stripe invoice and emails the dealer the hosted URL.
  //
  // This is the MONEY half of checkout and it does NOT release the vehicle.
  // Deliver is a separate custody action on the panel, unlocked by canDeliver()
  // once a real invoice exists. Returns true on success so the drawer can close.
  handleSendDealerInvoice = async () => {
    const request = this.state.selectedRequestimate;
    if (!request) return false;

    // Already materialized — nothing to do.
    if (hasRealInvoice(this.state.invoice)) return true;

    // Step 1: ensure a draft exists (server is idempotent — returns the existing
    // draft if there already is one).
    if (!this.state.draftPayment) {
      try {
        const { data } = await API.post('/invoices/', {
          invoiceId: request.requestId,
          invoiceType: request.requestType,
        });
        if (data.draft === true) {
          await new Promise(resolve => this.setState({
            draftPayment: { paymentId: data.paymentId, amount: data.amount, paymentToken: data.paymentToken },
          }, resolve));
        } else if (data.invoiceId) {
          // Server returned a real invoice directly. Load it into state AND persist
          // it onto the request — the deliver gate reads state.invoice, but the
          // Pickups filter reads request.invoiceId, and a dealer row with a null
          // invoiceId never leaves the list once collected.
          await this.readInvoice(data.invoiceId);
          const updatedRequest = { ...request, invoiceId: data.invoiceId };
          await this.updateRequest(updatedRequest);
          this.setState({ selectedRequestimate: updatedRequest });
          return true;
        } else {
          alert('Unable to create the dealer invoice. Please try again or contact support.');
          return false;
        }
      } catch (err) {
        console.error('SEND DEALER INVOICE: failed to create draft:', err);
        alert('Unable to create the dealer invoice. Please try again or contact support.');
        return false;
      }
    }

    // Step 2: materialize via 'send' — creates the open/unpaid Stripe invoice and
    // emails the dealer. materializeInvoice already calls readInvoice and updates
    // selectedRequestimate.invoiceId, so the panel unlocks with no extra fetch.
    const result = await this.materializeInvoice('send');
    if (!result.success) {
      this.openStripeRecoveryModal({
        request,
        reason: result.reason,
        locationName: result.locationName,
        detail: result.message,
      });
      return false;
    }

    console.log('SEND DEALER INVOICE: materialized', result.invoiceId);
    return true;
  };

  // Deliver — a PURE custody transition. The vehicle leaves the shop.
  //
  // Money is settled beforehand in Check Out (handleSendDealerInvoice for dealers,
  // the tender flow for retail), so this handler creates no invoices. The panel
  // only offers it once canDeliver() is satisfied — see src/util/deliverGate.js.
  //
  // The state change itself is server-authoritative: POST /requests/:id/collect
  // does a compare-and-swap and writes its own audit row with actor derived from
  // the JWT. We send only locationId (+ deliverOnAccount for dealers).
  handleDeliver = async (request) => {
    const locId = this.props.selectedLocationId;
    const collectBody = (locId && locId !== 'all') ? { locationId: locId } : {};

    // Dealer jobs release against an OPEN invoice — the shop bills the dealer and
    // carries the receivable, so this is a deliberate extension of credit. Sent
    // unconditionally for dealers because the client cannot see charge_model; the
    // server decides whether the flag is load-bearing and keeps its voided /
    // uncollectible protection either way. See tasks/deliver-flow-spec.md §7.2.
    if (request.requestType === 'dealer') collectBody.deliverOnAccount = true;

    try {
      await API.post(`/requests/${request.requestId}/collect`, collectBody);
    } catch (err) {
      await this.handleCollectError(err, request);
      return;
    }

    // Keep the offer row in sync — the collect endpoint does not touch
    // request_offered. Guarded: the collect already succeeded, so a failure here
    // must not reject out of this handler and strand the panel.
    try {
      await this.updateRequestOfferedState({
        requestId: request.requestId,
        installerId: parseInt(this.state.typeId),
        currentStatus: "collected",
        dateUpdated: convertToUTC(new Date()).format("YYYY-MM-DD HH:mm:ss"),
      });
    } catch (offerErr) {
      console.error('DELIVER: offer state sync failed (non-blocking):', offerErr);
    }

    // Reads selectedRequestimate.referral_id — must run before clearRequestimate.
    await this.updateReferralStatusFromRequest('collected');

    // Drop the row from the list. selectedRequestimate is ALWAYS a spread copy
    // (processParallelResults), so mutating it can never reach state.requestimates —
    // that was the bug. Patch currentState AND invoiceId: a collected dealer row with
    // a null invoiceId still matches the Pickups recovery clause, so both fields are
    // needed for the row to actually go. refreshLists then makes it authoritative.
    const deliveredInvoiceId = (this.state.invoice && this.state.invoice.id)
      || (this.state.selectedRequestimate && this.state.selectedRequestimate.invoiceId)
      || null;
    this.setState((prev) => ({
      requestimates: (prev.requestimates || []).map((r) =>
        r.requestId === request.requestId
          ? { ...r, currentState: 'collected', invoiceId: r.invoiceId || deliveredInvoiceId }
          : r
      ),
    }));
    await this.refreshLists();
    await this.clearRequestimate();

    ReactGA.event({
      category: "Installer",
      action: "Collected Vehicle",
      label: "prod",
    });
  };

  // Surface a failed/blocked collect to the user. The server returns HTTP 409 with a
  // machine-readable `code` (plus a human `error` string, and `paymentState`/
  // `currentState` on the relevant blocks). Anything else (404/400/500/network) gets
  // a generic retry message. Previously these rejections were swallowed entirely.
  handleCollectError = async (err, request) => {
    const res = err && err.response;
    const status = res && res.status;
    const data = (res && res.data) || {};

    if (status === 409) {
      switch (data.code) {
        case 'payment_unreconciled':
          if (data.paymentState === 'voided') {
            alert('Invoice was voided — regenerate or write off before collecting.');
          } else if (request.requestType === 'installer') {
            // 'invoiced' (owed) on a RETAIL job — payment must be settled first.
            // Dealers collect on account (deliver-on-account), so the server never
            // blocks them for an owed balance; this branch is retail-only and the
            // requestType guard keeps the "still owed" wording from ever reaching a
            // dealer even if the server's behavior changes.
            alert('Invoice still owed — record payment or void it before collecting.');
          } else {
            alert(data.error || 'Unable to collect this job. Please try again.');
          }
          return;
        case 'illegal_transition':
          alert(`This job can't be collected yet (it's '${data.currentState || 'unknown'}').`);
          // Server state disagrees with the drawer — reload to show the truth.
          window.location.reload();
          return;
        case 'stale_state':
          alert('This job was updated elsewhere — refreshing.');
          window.location.reload();
          return;
        default:
          alert(data.error || 'Unable to collect this job. Please try again.');
          return;
      }
    }

    console.error('COLLECT failed:', status, data, err);
    // The server's state UPDATE and its audit INSERT are not transactional, so a
    // 500 can land on a job that DID collect (a retry then returns 200
    // alreadyCollected). Reconcile against the server before reporting failure,
    // or the row sits on Pickups until the idle refresh.
    await this.refreshLists();
    alert('Unable to collect this job. Please try again.');
  };

  handleReview = async (request) => {
    if (!window.confirm('Submit this review? Ratings cannot be changed after submission.')) return;
    // Only used for a job by a dealer
    const updatedRequestimate = request;
    updatedRequestimate.currentState = "reviewed";
    updatedRequestimate.reviewScore = this.state.reviewScore;
    // update the request
    let urequest = await this.updateRequest(updatedRequestimate);
    const offer = {
      requestId: updatedRequestimate.requestId,
      installerId: updatedRequestimate.assignedTo,
      currentStatus: updatedRequestimate.currentState,
      dateUpdated: convertToUTC(new Date()).format("YYYY-MM-DD HH:mm:ss"),
    };
    let uoffered = await this.updateRequestOfferedState(offer);

    // add an audit record to the table
    let astate = await this.addRequestState(
      request.requestId,
      updatedRequestimate.currentState,
      null
    );
    this.setState({ reviewScore: 0 });
    await this.clearRequestimate();
    Promise.all([urequest, uoffered, astate]).then(() => {
      ReactGA.event({
        category: "Dealer",
        action: "Reviewed Job",
        label: "prod",
      });
      alert(
        "Thank you for the review. Reviews are critical to maintaining an installers reputation"
      );
      window.location = "/pickups";
    });
  };

/**
 * Unified collect handler for TenderTiles (FINISHED-state collect path).
 * `amount == null` → collect the full remaining balance via the existing
 * handlePayment path; a numeric amount → a partial via handleCollectSplitPayment.
 * Reuses the proven container handlers; the canonical method maps onto the
 * legacy selectedPay / selectedSplitMethod vocabulary each expects.
 */
handleCollect = async ({ method, amount, checkNumber }) => {
  if (amount == null) {
    const fullLabel = { terminal: 'Swipe Card', card: 'Pay Online', cash: 'Cash', check: 'Check' }[method] || 'Cash';
    this.setState(
      { selectedPay: fullLabel, checkNumber: checkNumber || '' },
      () => this.handlePayment()
    );
    return;
  }

  // Partial / split — split is just another way to START a payment, so if the
  // invoice hasn't materialized yet (materialize-last), materialize it now into
  // an OPEN, full-balance invoice that record-partial can target. Use 'card'
  // (same as Pay Online → open/unpaid, NO auto-email; the link send is a
  // separate step) — NOT 'split', which the server never treats as a create
  // method and which yields a $0-balance invoice.
  if (!this.state.finalInvoiceId && this.state.draftPayment) {
    const result = await this.materializeInvoice('card');
    if (!result || !result.success) {
      const request = this.state.selectedRequestimate;
      if (result && result.reason && request) {
        this.openStripeRecoveryModal({ request, reason: result.reason, locationName: result.locationName, detail: result.message });
      } else {
        alert('Unable to start the split payment. Please try again.');
      }
      return;
    }
    await new Promise((res) => this.setState({ finalInvoiceId: result.invoiceId }, res));
  }

  const splitLabel = { terminal: 'Terminal', card: 'Online', cash: 'Cash', check: 'Check' }[method] || 'Cash';
  this.setState(
    { selectedSplitMethod: splitLabel, splitPaymentAmount: String(amount), splitCheckNumber: checkNumber || '' },
    () => this.handleCollectSplitPayment()
  );
};

/**
 * Add a retail product to an open (unmaterialized) job as a billable line.
 * Reuses the existing /requestService/custom path, refreshes the service lines,
 * then recomputes the request totals with the canonical SharedRequestPricing calc
 * (effective tax rate derived from the current request) so the displayed total +
 * collected amount include the product. The authoritative charge is built at
 * materialize-time from current request_services, so the upsell bills correctly.
 * NOTE: inventory deduction deferred — ad-hoc bulk-product deduction path TBD
 * (see tasks/server-requirements-checkout-product-sales.md).
 */
handleAddProductLine = async (product, quantity = 1) => {
  const req = this.state.selectedRequestimate;
  const installerId = this.props.typeId;
  const productId = product.product_id || product.id;
  const baseName = product.product_name || product.name || 'Product';
  const name = product.brand ? `${product.brand} - ${baseName}` : baseName;
  const price = parseFloat(product.retail_price) || 0;
  const qty = parseInt(quantity, 10) || 1;

  this.setState({ addingProductId: productId });
  try {
    // Derive the effective tax rate from the current request before mutating.
    const oldServices = this.state.services || [];
    const oldTaxable = SharedRequestPricing.calculateTaxableAmount(oldServices);
    const taxRate = oldTaxable > 0 ? ((parseFloat(req.requestTaxes) || 0) / oldTaxable) * 100 : 0;

    await API.post('/requestService/custom', {
      description: name,
      price,
      quantity: qty,
      saveToCatalog: false,
      installerId,
      requestId: req.requestId,
      product_id: productId,
    });

    await this.readRequestServices(req.requestId);

    const jobType = req.requestType === 'dealer' ? 'dealer' : 'retail';
    const b = SharedRequestPricing.getCompletePricingBreakdown(this.state.services || [], { jobType, taxRate });
    this.setState({
      selectedRequestimate: {
        ...this.state.selectedRequestimate,
        requestTotal: b.originalTotal,
        requestDiscount: b.totalDiscount,
        requestTaxes: b.taxes,
      },
    });
  } catch (err) {
    console.error('Failed to add product line', err);
    alert('Could not add the product. Please try again.');
  } finally {
    this.setState({ addingProductId: null });
  }
};

// Recompute request totals from the current service lines (canonical calc),
// deriving the effective tax rate from the request before the mutation.
recomputeRequestTotals = (taxRate) => {
  const req = this.state.selectedRequestimate;
  const jobType = req.requestType === 'dealer' ? 'dealer' : 'retail';
  const b = SharedRequestPricing.getCompletePricingBreakdown(this.state.services || [], { jobType, taxRate });
  this.setState({
    selectedRequestimate: {
      ...this.state.selectedRequestimate,
      requestTotal: b.originalTotal,
      requestDiscount: b.totalDiscount,
      requestTaxes: b.taxes,
    },
  });
};

// Remove an upsold product line (request_services row with product_id) at checkout.
handleRemoveProductLine = async (service) => {
  const id = service.requestServiceId || service.request_service_id || service.id;
  if (!id) return;
  const req = this.state.selectedRequestimate;
  const oldTaxable = SharedRequestPricing.calculateTaxableAmount(this.state.services || []);
  const taxRate = oldTaxable > 0 ? ((parseFloat(req.requestTaxes) || 0) / oldTaxable) * 100 : 0;
  this.setState({ addingProductId: service.product_id });
  try {
    await API.delete(`/requestService/row/${id}`);
    await this.readRequestServices(req.requestId);
    this.recomputeRequestTotals(taxRate);
  } catch (err) {
    console.error('Failed to remove product line', err);
    alert('Could not remove the product. Please try again.');
  } finally {
    this.setState({ addingProductId: null });
  }
};

// Change the quantity of an upsold product line at checkout (0 → remove).
handleUpdateProductQty = async (service, newQty) => {
  const id = service.requestServiceId || service.request_service_id || service.id;
  if (!id) return;
  const qty = parseInt(newQty, 10) || 1;
  if (qty < 1) return this.handleRemoveProductLine(service);
  const req = this.state.selectedRequestimate;
  const oldTaxable = SharedRequestPricing.calculateTaxableAmount(this.state.services || []);
  const taxRate = oldTaxable > 0 ? ((parseFloat(req.requestTaxes) || 0) / oldTaxable) * 100 : 0;
  this.setState({ addingProductId: service.product_id });
  try {
    await API.patch(`/requestService/row/${id}`, { quantity: qty });
    await this.readRequestServices(req.requestId);
    this.recomputeRequestTotals(taxRate);
  } catch (err) {
    console.error('Failed to update product quantity', err);
    alert('Could not update the quantity. Please try again.');
  } finally {
    this.setState({ addingProductId: null });
  }
};

handlePayment = async (invoice) => {
  const selectedPay = this.state.selectedPay;
  const isCashOrCheck = ['Cash', 'Check', 'Settle', 'Check/Cash'].includes(selectedPay);

  // Validate check number early
  if (selectedPay === "Check" && !this.state.checkNumber.trim()) {
    alert("Please enter a check number");
    return;
  }

  // Draft invoice flow — materialize first, with offline fallback for cash/check
  if (this.state.draftPayment) {
    const methodMap = {
      'Cash': 'cash',
      'Check': 'check',
      'Pay Online': 'card',
      'Swipe Card': 'terminal',
      'Split Payment': 'split',
      'Settle': 'cash',
      'Check/Cash': 'cash',
    };
    const payMethod = methodMap[selectedPay] || 'cash';

    const result = await this.materializeInvoice(payMethod);

    if (!result.success) {
      if (isCashOrCheck) {
        // Stripe failed but cash/check doesn't need it — settle offline
        console.log('FALLBACK: Settling offline for', selectedPay);
        await this.settleOffline(selectedPay);
        return;
      }
      // Dealer card/terminal failure — open the recovery modal (transfer to another
      // location, fix Stripe, recheck readiness).
      const request = this.state.selectedRequestimate;
      if (request && request.requestType === 'dealer') {
        this.openStripeRecoveryModal({
          request,
          reason: result.reason,
          locationName: result.locationName,
          detail: result.message,
        });
        return;
      }
      // Retail card/online/split — keep the cash/check fallback prompt.
      const detail = result.message || result.reason || 'unknown error';
      const fallback = window.confirm(
        `Unable to process this payment method.\n\nReason: ${detail}\n\nWould you like to collect Cash or Check instead?`
      );
      if (fallback) {
        return;
      }
      return;
    }
    // Invoice is now real and in state — fall through to normal payment handling
  }

  // Normal payment handling (invoice exists in Stripe)
  if (selectedPay === "Check") {
    await this.handleSettle(this.state.selectedRequestimate, this.state.invoice.id, "Check", this.state.checkNumber);
  }

  if (selectedPay === "Cash") {
    await this.handleSettle(this.state.selectedRequestimate, this.state.invoice.id, "Cash");
  }

  if (selectedPay === "Settle") {
    await this.handleSettle(this.state.selectedRequestimate, this.state.invoice.id);
  }

  // Legacy support for old "Check/Cash" option if it still exists
  if (selectedPay === "Check/Cash") {
    await this.handleSettle(this.state.selectedRequestimate, this.state.invoice.id);
  }

  if (selectedPay === "Pay Online") {
    // Fetch fresh invoice URL from Stripe (stored URLs expire after 30-120 days)
    try {
      const { data } = await API.get(`/invoices/${this.state.invoice.id}/fresh-url`);
      if (data.success && data.hosted_invoice_url) {
        window.open(data.hosted_invoice_url);
      } else {
        console.error("Failed to get fresh invoice URL");
        alert("Unable to open invoice. Please try again.");
      }
    } catch (error) {
      console.error("Error fetching fresh invoice URL:", error);
      alert("Unable to open invoice. Please try again.");
    }
  }

  if (selectedPay === "Swipe Card") {
    await this.handleSwipeCardFlow();
  }
};

// Resolve the live, online card reader for the SELECTED shop location.
// The operator collects on whichever reader is physically in front of them,
// regardless of which location the invoice belongs to — it's the same
// connected account either way. Resolving live (rather than trusting the
// legacy installer.stripe_location field, which the per-location pairing
// flow no longer maintains) keeps every location self-correcting.
// Returns the Stripe reader id (tmr_...). Throws a user-facing error otherwise.
resolveActiveReader = async () => {
  const locationId = this.props.selectedLocationId;
  if (!locationId || locationId === 'all') {
    throw new Error("Select a specific shop location in the header selector before collecting a card payment.");
  }

  const { data } = await API.get(`/terminal/location/${locationId}/setup`);
  const readers = (data && data.readers) || [];
  const onlineReader = readers.find(r => r.status === 'online');

  if (!onlineReader) {
    if (readers.length === 0) {
      throw new Error("No card reader is paired at this location. Pair one under Profile → POS Terminal.");
    }
    throw new Error("The card reader at this location is offline. Make sure it's powered on and connected to Wi-Fi.");
  }

  return onlineReader.id;
};

handleSwipeCardFlow = async () => {
  // FIX: Reset invoice settlement flag for new payment attempt
  this.invoiceSettled = false;

  this.setState({
    showSwipe: true,
    paymentState: "initializing",
    paymentError: null
  });

  try {
    // Step 1: Brief initialization pause for UX
    await this.sleep(800);

    // Step 2: Resolve the live reader for the SELECTED location FIRST, so a
    // missing/offline reader shows a clear error instead of silently stalling
    // after the PaymentIntent is created.
    this.setState({ paymentState: "checking_terminal" });
    let readerId;
    try {
      readerId = await this.resolveActiveReader();
    } catch (resolveErr) {
      // "error" is rendered by PaymentProgressModal with the message + Try Again/Cancel
      this.setState({
        paymentState: "error",
        paymentError: resolveErr.message
      });
      return;
    }
    this.activeReaderId = readerId;

    // Step 3: Create/verify payment intent
    this.setState({ paymentState: "creating_intent" });
    if (!this.state.paymentIntentId) {
      await this.createSwipe(readerId);
    }
    await this.sleep(500);

    // Step 4: Confirm the reader is reachable right before charging
    this.setState({ paymentState: "checking_terminal" });
    const terminalStatus = await this.checkTerminal(readerId);
    await this.sleep(500);

    if (terminalStatus.status !== "online") {
      this.setState({
        paymentState: "terminal_offline",
        paymentError: "Card reader is offline. Please check connection."
      });
      return;
    }

    // Step 5: Send payment to terminal
    this.setState({ paymentState: "sending_to_reader" });
    await this.collectPayment(readerId);
    await this.sleep(500);

    // Step 6: Wait for customer interaction
    this.setState({ paymentState: "waiting_for_customer" });

    // Step 7: Start auto-polling for completion
    this.startPaymentPolling();

  } catch (error) {
    console.error("Swipe card flow error:", error);
    this.setState({
      paymentState: "error",
      paymentError: error.message || "Payment setup failed. Please try again."
    });
  }
};
// NEW: Add helper function for timing
sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));

checkSwipe = async () => {
  try {
    //console.log("checkSwipe: Checking payment status");

    if (!this.state.paymentIntentId) {
      console.error("No payment ID for status check");
      return;
    }

    const { data: response } = await API.get(`/payments/${this.state.paymentIntentId}`);
    //console.log("checkSwipe: Payment status response:", response);

    // FIXED: Handle new response structure
    if (!response.success) {
      console.error("Payment status check failed:", response.error);
      return { status: "error" };
    }

    const paymentData = response;

    // Settlement is server-authoritative: GET /payments/:id retrieves the
    // PaymentIntent from Stripe and idempotently marks the row paid (the webhook
    // is now only a reconciliation backstop). The client just reads the
    // normalized `status` here — no client-side settlement. `response.status` is
    // NORMALIZED (succeeded|processing|payment_failed|canceled); the raw Stripe
    // enum is available as `response.stripe_status` if ever needed.

    return paymentData;
  } catch (error) {
    console.error("checkSwipe: Error:", error);
    return { status: "error" };
  }
};

// NEW: Add enhanced polling with better state management
startPaymentPolling = () => {
  // FIX: Clear any existing polling interval first to prevent multiple loops
  if (this.state.paymentPollInterval) {
    console.log("Clearing existing polling interval before starting new one");
    clearInterval(this.state.paymentPollInterval);
  }

  // FIX: Clear any existing timeout
  if (this.pollTimeout) {
    clearTimeout(this.pollTimeout);
  }

  const pollInterval = setInterval(async () => {
    try {
      // FIX: Expanded state check to stop polling in more cases
      if (this.state.paymentState !== "waiting_for_customer" &&
          this.state.paymentState !== "processing") {
        clearInterval(pollInterval);
        return;
      }

      const result = await this.checkSwipe();

      if (result && result.status === "processing") {
        this.setState({ paymentState: "processing" });
      } else if (result && result.status === "succeeded") {
        clearInterval(pollInterval);
        this.setState({ paymentState: "success" });

        // Auto-close after showing success
        setTimeout(() => {
          this.setState({ showSwipe: false, paymentState: "idle" });
          alert("Payment processed successfully!");
          window.location = "/pickups";
        }, 3000);

      } else if (result && result.status === "payment_failed") {
        clearInterval(pollInterval);
        this.setState({
          paymentState: "declined",
          paymentError: "The card was declined. Please try a different card."
        });
      } else if (result && result.status === "canceled") {
        // Normalized status: reader action / PaymentIntent canceled. Terminal —
        // stop polling and surface a retryable state (reuses the "declined" UI).
        clearInterval(pollInterval);
        this.setState({
          paymentState: "declined",
          paymentError: "The payment was canceled. Please try again."
        });
      } else if (result && result.status === "error") {
        clearInterval(pollInterval);
        this.setState({
          paymentState: "error",
          paymentError: "Payment status check failed. Please try again."
        });
      }
    } catch (error) {
      console.error("Payment polling error:", error);
      // FIX: Stop polling on critical errors
      clearInterval(pollInterval);
      this.setState({
        paymentState: "error",
        paymentError: "Connection error. Please check your network."
      });
    }
  }, 2000);

  this.setState({ paymentPollInterval: pollInterval });

  // FIX: Store timeout reference so we can clear it later
  this.pollTimeout = setTimeout(() => {
    clearInterval(pollInterval);
    if (this.state.paymentState === "waiting_for_customer" ||
        this.state.paymentState === "processing") {
      this.setState({
        paymentState: "timeout",
        paymentError: "Payment timed out. Please try again."
      });
    }
  }, 300000);
};

// ============================================================================
// SPLIT PAYMENT HANDLERS
// ============================================================================

/**
 * Determine if payment data should be loaded for split payments
 * Only load when: non-dealer, work finished, invoice exists
 */
shouldLoadPaymentData = () => {
  const { selectedRequestimate, finalInvoiceId } = this.state;

  if (!selectedRequestimate || !selectedRequestimate.requestId) {
    return false;
  }

  // Dealers cannot use split payments
  if (selectedRequestimate.requestType === 'dealer') {
    return false;
  }

  // Must have completed work
  if (selectedRequestimate.currentState !== 'finished' && selectedRequestimate.currentState !== 'collected') {
    return false;
  }

  // Must have final invoice created
  if (!finalInvoiceId) {
    return false;
  }

  return true;
};

/**
 * Load payment history for the selected request
 * Only called when split payments are eligible
 */
loadPaymentHistory = async () => {
  const { selectedRequestimate } = this.state;

  if (!this.shouldLoadPaymentData()) {
    return { collectedPayments: [], finalInvoiceId: null };
  }

  try {
    const { data } = await API.get(`/payments/by-request/${selectedRequestimate.requestId}`);

    // Find final invoice parent record
    const finalParent = data.payments.find(p =>
      p.payment_type === 'final' || p.payment_type === 'final_parent'
    );

    // Find split payments (children)
    // Note: Server may return truncated payment_type 'final_spli' instead of 'final_split'
    // Cash payments may not have parent_invoice_id set - use is_partial_payment as fallback
    // Voided rows (declined/canceled terminal attempts the server auto-voided) are
    // excluded so they never count as collected or inflate the payment count.
    const finalSplits = data.payments.filter(p => {
      const isSplitType = p.payment_type === 'final_split' || p.payment_type === 'final_spli';
      const isPartial = p.is_partial_payment === 1;
      const hasMatchingParent = p.parent_invoice_id === finalParent?.invoice_id ||
                                 p.parent_invoice_id === this.state.finalInvoiceId;
      // Both spellings — the server voids to 'voided', and testing only for
      // 'void' let cancelled terminal attempts count as money collected.
      const isVoid = isVoidedPaymentState(p.payment_state);

      // Include if: NOT void AND (split type OR partial payment) AND (has matching parent OR is partial with no parent set)
      return !isVoid && (isSplitType || isPartial) && (hasMatchingParent || (isPartial && !p.parent_invoice_id));
    });

    // Determine if already in split payment mode
    const isSplit = finalSplits.length > 0 || finalSplits.some(p => p.is_partial_payment === 1);

    const newFinalInvoiceId = finalParent?.invoice_id || this.state.finalInvoiceId;

    // The server is the source of truth for balance / fully-paid state. Fetch the
    // authoritative balance so remaining and isFullyPaid never rely on local arithmetic.
    const balance = await this.fetchInvoiceBalance(newFinalInvoiceId);
    // Normalize: only trust a finite number. A missing/unparseable amountRemaining
    // (undefined field, "$865.50", null) must fall back to local arithmetic rather
    // than surface "$NaN" or poison the fully-paid check.
    const parsedRemaining = balance ? parseFloat(balance.amountRemaining) : NaN;
    const serverRemainingBalance = Number.isFinite(parsedRemaining) ? parsedRemaining : null;
    const serverIsFullyPaid = balance ? !!balance.isFullyPaid : false;

    this.setState({
      collectedPayments: finalSplits,
      isSplitPayment: isSplit,
      finalInvoiceId: newFinalInvoiceId,
      serverRemainingBalance,
      serverIsFullyPaid
    });

    // Return the data for immediate use (avoids setState async issue)
    return { collectedPayments: finalSplits, finalInvoiceId: newFinalInvoiceId, serverRemainingBalance, serverIsFullyPaid };

  } catch (error) {
    console.error('Error loading payment history:', error);
    return { collectedPayments: [], finalInvoiceId: null, serverRemainingBalance: null, serverIsFullyPaid: false };
  }
};

/**
 * GET /invoices/:invoiceId/balance — authoritative balance/state for the final
 * invoice: { totalDue, totalPaid, amountRemaining, paymentCount, nextSequence,
 * isFullyPaid }. Returns null when there's no invoice yet or the call fails, so
 * callers fall back to local arithmetic (calculateRemainingBalance).
 */
fetchInvoiceBalance = async (invoiceId) => {
  if (!invoiceId) return null;
  try {
    const { data } = await API.get(`/invoices/${invoiceId}/balance`);
    return data;
  } catch (error) {
    console.error('Error fetching invoice balance:', error);
    return null;
  }
};

/**
 * Remaining balance for the split UI. Prefers the server's authoritative
 * amountRemaining (paid rows only, voids excluded); falls back to local
 * arithmetic before any invoice balance has been loaded.
 */
getRemainingBalance = () => {
  const { serverRemainingBalance } = this.state;
  if (serverRemainingBalance != null && !isNaN(serverRemainingBalance)) {
    return Math.max(0, serverRemainingBalance);
  }
  return this.calculateRemainingBalance();
};

/**
 * Calculate remaining balance for split payments
 * Formula: (Job Total - Discount + Sales Tax) - Deposit - Collected Splits
 * @param {Array} paymentsOverride - Optional array of payments to use instead of state
 */
calculateRemainingBalance = (paymentsOverride = null) => {
  const { selectedRequestimate, collectedPayments } = this.state;

  // Use provided payments or fall back to state
  const payments = paymentsOverride || collectedPayments;

  if (!selectedRequestimate) return 0;

  // Calculate customer total (what customer actually owes)
  const requestTotal = parseFloat(selectedRequestimate.requestTotal) || 0;
  const requestDiscount = parseFloat(selectedRequestimate.requestDiscount) || 0;
  const requestTaxes = parseFloat(selectedRequestimate.requestTaxes) || 0;

  // Customer pays: (total - discount) + taxes
  const finalAmount = requestTotal - requestDiscount;
  const customerTotal = finalAmount + requestTaxes;

  // Deposit already paid (credited to final invoice)
  const depositAmount = parseFloat(selectedRequestimate.depositAmount) || 0;

  // Sum of paid split payments
  // Note: Cash payments may return as 'pending' from server - treat them as paid
  const splitsPaid = payments
    .filter(p => p.payment_state === 'paid' ||
      (p.payment_state === 'pending' && (p.payment_method?.toLowerCase() === 'cash')))
    .reduce((sum, p) => sum + (parseFloat(p.payment_amount) || parseFloat(p.amount) || parseFloat(p.invoice_amount) || 0), 0);

  // Remaining = Customer Total - Deposit - Splits
  const remaining = customerTotal - depositAmount - splitsPaid;

  return Math.max(0, remaining);
};

/**
 * Handle split payment checkbox toggle
 */
handleToggleSplitPayment = async (e) => {
  const checked = e.target.checked;

  if (checked) {
    const confirmed = window.confirm(
      "Split Payment Mode\n\n" +
      "Collect multiple payments for this invoice.\n\n" +
      "⚠️ Important:\n" +
      "• Customer must complete ALL payments before leaving\n" +
      "• Each payment will be processed separately\n" +
      "• You can mix Terminal, Online, Cash, and Check payments\n\n" +
      "Continue?"
    );

    if (!confirmed) {
      return;
    }

    // Reload payment history in case of existing splits
    await this.loadPaymentHistory();

    this.setState({ isSplitPayment: true });

  } else {
    // Can only exit split mode if no payments collected
    if (this.state.collectedPayments.length === 0) {
      this.setState({ isSplitPayment: false });
    } else {
      alert(
        'Cannot exit split payment mode.\n\n' +
        'Payments have already been collected. ' +
        'You must complete the remaining balance.'
      );
    }
  }
};

/**
 * Validate split payment before processing
 */
validateSplitPayment = () => {
  const { selectedSplitMethod, splitCheckNumber, splitPaymentAmount } = this.state;

  // Must select payment method
  if (!selectedSplitMethod) {
    return {
      valid: false,
      error: 'Please select a payment method (Terminal, Online, Cash, or Check)'
    };
  }

  // Check requires check number
  if (selectedSplitMethod === 'Check' && !splitCheckNumber.trim()) {
    return {
      valid: false,
      error: 'Please enter the check number'
    };
  }

  // Validate amount — cap against the server's authoritative remaining balance
  const remainingBalance = this.getRemainingBalance();
  const amountInDollars = splitPaymentAmount
    ? parseFloat(splitPaymentAmount)
    : remainingBalance;

  if (isNaN(amountInDollars) || amountInDollars <= 0) {
    return {
      valid: false,
      error: 'Payment amount must be greater than zero'
    };
  }

  if (amountInDollars > remainingBalance) {
    return {
      valid: false,
      error: `Payment amount ($${amountInDollars.toFixed(2)}) cannot exceed remaining balance ($${remainingBalance.toFixed(2)})`
    };
  }

  return { valid: true };
};

/**
 * Main handler for collecting a split payment
 */
handleCollectSplitPayment = async () => {
  const {
    finalInvoiceId,
    selectedRequestimate,
    typeId,
    splitPaymentAmount,
    selectedSplitMethod,
    splitCheckNumber
  } = this.state;

  // Validate payment
  const validation = this.validateSplitPayment();
  if (!validation.valid) {
    alert(validation.error);
    return;
  }

  // Get amount (use input or full remaining) — remaining is server-authoritative
  const remainingBalance = this.getRemainingBalance();
  const amountInDollars = splitPaymentAmount
    ? parseFloat(splitPaymentAmount)
    : remainingBalance;

  this.setState({
    isProcessingSplitPayment: true,
    splitPaymentError: null
  });

  try {
    // HANDLE ONLINE CARD PAYMENT (creates invoice like deposits)
    if (selectedSplitMethod === 'Online') {
      await this.handleCollectOnlineSplitPayment(amountInDollars);
      return; // Online flow handles its own completion
    }

    // HANDLE OTHER PAYMENT METHODS (Terminal, Cash, Check)
    // NOTE: payment_sequence is SERVER-ASSIGNED (max over all invoice rows + 1).
    // The client no longer computes or sends a sequence — doing so caused the
    // "split payment for sequence N already exists" collisions.
    const requestBody = {
      invoiceId: finalInvoiceId,
      requestId: selectedRequestimate.requestId,
      installerId: typeId,
      amount: amountInDollars,
      paymentMethod: selectedSplitMethod
    };

    // Add check number if paying by check
    if (selectedSplitMethod === 'Check') {
      requestBody.checkNumber = splitCheckNumber.trim();
    }

    // Call backend API to record payment
    const { data: response } = await API.post('/invoices/record-partial', requestBody);

    if (!response.success) {
      throw new Error(response.error || 'Failed to record payment');
    }

    // If terminal payment, process on card reader. A Terminal split MUST run on
    // the reader — if the server didn't return a payment_intent_id, no card was
    // charged, so fail loudly instead of falsely reporting "collected" (which
    // would record uncharged money against the invoice).
    if (selectedSplitMethod === 'Terminal') {
      if (!response.payment_intent_id) {
        throw new Error('The card reader charge could not be started (no payment intent returned). No card was charged.');
      }
      // Reader success is NOT settlement — the server flips the pending split to
      // 'paid' via webhook. Show a "confirming…" state while we poll the server,
      // and never optimistically mark it paid locally.
      this.setState({ isConfirmingSplitPayment: true });
      await this.processTerminalSplitPayment(response.payment_intent_id);
      this.setState({ isConfirmingSplitPayment: false });
    }

    // For Cash and Check, backend marks as paid immediately.

    // Refresh from the server — loadPaymentHistory pulls the authoritative
    // balance / isFullyPaid (paid rows only, voids excluded).
    const { serverRemainingBalance, serverIsFullyPaid, collectedPayments: updatedPayments } =
      await this.loadPaymentHistory();

    const newRemaining = serverRemainingBalance != null
      ? Math.max(0, serverRemainingBalance)
      : this.calculateRemainingBalance(updatedPayments);
    const fullyPaid = serverRemainingBalance != null ? serverIsFullyPaid : newRemaining === 0;

    if (fullyPaid) {
      // Re-read the invoice so state.invoice.paid reflects the completed tender.
      // Without this the drawer's auto-close never fires and the panel still shows
      // Check Out on a fully-paid job — an invitation to collect twice.
      if (this.state.finalInvoiceId) {
        await this.readInvoice(this.state.finalInvoiceId);
      }
      alert(
        'Payment collected successfully!\n\n' +
        '✓ All payments complete\n' +
        '✓ Invoice is fully paid\n\n' +
        'You can now close this screen.'
      );
      this.setState({ isSplitPayment: false });
    } else {
      alert(
        `Payment ${updatedPayments.length} collected!\n\n` +
        `Remaining balance: $${newRemaining.toFixed(2)}`
      );
    }

    // Reset form
    this.setState({
      splitPaymentAmount: '',
      selectedSplitMethod: null,
      splitCheckNumber: ''
    });

  } catch (error) {
    console.error('Error collecting split payment:', error);

    const errorMsg = error.response?.data?.error || error.message || 'Unknown error';

    // A declined/canceled Terminal split is auto-voided on the server. Refresh so
    // the stuck "pending" tile drops and the next attempt starts clean — it gets a
    // fresh server-assigned sequence, so no "sequence already exists" error.
    try {
      await this.loadPaymentHistory();
    } catch (reloadErr) {
      console.warn('Failed to refresh payment history after split error:', reloadErr);
    }

    this.setState({ splitPaymentError: errorMsg });

    alert(`Error collecting payment:\n\n${errorMsg}`);

  } finally {
    this.setState({ isProcessingSplitPayment: false, isConfirmingSplitPayment: false });
  }
};

/**
 * Handle online card split payment (creates partial invoice)
 */
handleCollectOnlineSplitPayment = async (amountInDollars) => {
  // Check if Stripe capabilities are active
  if (!this.validateStripeCapabilities()) return;

  const { selectedRequestimate, collectedPayments, finalInvoiceId } = this.state;

  try {
    // Create partial invoice (same pattern as deposits)
    const invoice = {
      invoiceId: `${selectedRequestimate.requestId}-split${collectedPayments.length + 1}-${Date.now()}`,
      invoiceType: selectedRequestimate.requestType,
      amount: amountInDollars,
      metadata: {
        payment_type: 'final_split',
        parent_invoice_id: finalInvoiceId,
        payment_sequence: collectedPayments.length + 1,
        is_partial_payment: 'true',
        request_id: selectedRequestimate.requestId
      }
    };

    const { data: response } = await API.post('/invoices/', invoice);

    // Auto-send the invoice to customer
    if (response.invoiceId) {
      await this.resendInvoice(response.invoiceId);
    }

    // Reload payment history to get updated state (server-authoritative balance)
    const { serverRemainingBalance, serverIsFullyPaid, collectedPayments: updatedPayments } =
      await this.loadPaymentHistory();

    // Check if fully paid — driven by the server, not local arithmetic
    const newRemaining = serverRemainingBalance != null
      ? Math.max(0, serverRemainingBalance)
      : this.calculateRemainingBalance(updatedPayments);
    const fullyPaid = serverRemainingBalance != null ? serverIsFullyPaid : newRemaining === 0;

    this.setState({ isProcessingSplitPayment: false });

    if (fullyPaid) {
      // Fully paid - close modal and refresh
      alert(
        `Invoice sent to customer!\n\n` +
        `Amount: $${amountInDollars.toFixed(2)}\n\n` +
        `✓ All payments complete - invoice is fully paid.`
      );
      this.setState({ isSplitPayment: false });
      // Refresh to update the UI
      window.location.reload();
    } else {
      // More payments needed
      alert(
        `Invoice sent to customer!\n\n` +
        `Amount: $${amountInDollars.toFixed(2)}\n` +
        `Remaining balance: $${newRemaining.toFixed(2)}`
      );
      // Reset form for next payment
      this.setState({
        splitPaymentAmount: '',
        selectedSplitMethod: null
      });
    }

  } catch (error) {
    console.error('Error creating online split invoice:', error);
    this.setState({ isProcessingSplitPayment: false });
    throw error;
  }
};

/**
 * Process a split payment on the terminal reader.
 * Confirmation is Stripe-authoritative and per-PaymentIntent — the SAME path the
 * full-balance swipe flow uses (GET /payments/:paymentIntentId via
 * confirmPaymentIntent) — rather than scanning the by-request table and waiting
 * on the webhook. The webhook stays as the reconciliation backstop.
 */
processTerminalSplitPayment = async (paymentIntentId) => {
  try {
    // Resolve the live reader for the selected location (same source of truth
    // as the main swipe flow) rather than the legacy installer.stripe_location.
    const readerId = this.activeReaderId || await this.resolveActiveReader();
    const payment = {
      paymentId: paymentIntentId,
      terminalId: readerId
    };

    const { data: response } = await API.post('/terminalPay/', payment);

    if (!response.success) {
      throw new Error(response.error || 'Terminal payment failed');
    }

    // Ask Stripe (via the server) for the authoritative outcome of THIS intent.
    const confirmation = await this.confirmPaymentIntent(paymentIntentId);
    if (!confirmation.settled) {
      // Declined / canceled / abandoned tap. The server voids the pending split;
      // the caller refreshes state and the next attempt gets a fresh sequence.
      throw new Error('The card payment was declined or canceled. Please try again.');
    }

  } catch (error) {
    console.error('Terminal split payment error:', error);
    throw error;
  }
};

/**
 * Stripe-authoritative confirmation for ONE PaymentIntent, shared by the
 * full-balance swipe flow and split payments. Polls GET /payments/:paymentIntentId
 * — which the server backs by stripe.paymentIntents.retrieve (+ capture if needed
 * + idempotent settle of the matching row) — until the intent reaches a terminal
 * state. This is the in-the-moment source of truth so the customer isn't held
 * hostage to webhook delivery; the webhook remains a reconciliation backstop.
 *
 * Returns { settled: true, status } on success, { settled: false, status } on a
 * definitive decline/cancel, and throws on timeout.
 */
confirmPaymentIntent = async (paymentIntentId, { maxAttempts = 30, intervalMs = 2000 } = {}) => {
  for (let i = 0; i < maxAttempts; i++) {
    // Wait between attempts — the customer is still tapping/inserting.
    await this.sleep(intervalMs);

    let result;
    try {
      const { data } = await API.get(`/payments/${paymentIntentId}`);
      result = data;
    } catch (error) {
      // Transient network error — non-terminal, keep polling.
      console.warn(`confirmPaymentIntent attempt ${i + 1} failed:`, error);
      continue;
    }

    const status = result && result.status;

    if (status === 'succeeded') {
      return { settled: true, status };
    }

    // Definitive negative outcomes — stop and surface a retryable result.
    if (status === 'payment_failed' || status === 'canceled') {
      return { settled: false, status };
    }

    // 'processing' / 'requires_capture' / 'requires_action' / 'requires_payment_method'
    // are all still-in-flight — keep waiting.
  }

  // Timeout — Stripe never reached a terminal state in the allotted window.
  throw new Error(
    'Payment confirmation timeout. ' +
    'Please refresh the page to check payment status.'
  );
};

/**
 * Close invoice link modal and refresh payment data
 */
handleCloseInvoiceLinkModal = async () => {
  this.setState({
    showInvoiceLinkModal: false,
    currentInvoiceLink: null,
    splitPaymentAmount: '',
    selectedSplitMethod: null
  });

  // Reload payment history to show pending invoice
  await this.loadPaymentHistory();
};

// ============================================================================
// END SPLIT PAYMENT HANDLERS
// ============================================================================

  handleAddPO = async (PO) => {
    const hasInvoice = this.state.invoice && this.state.invoice.id;

    if (hasInvoice) {
      // Invoice exists — update Stripe metadata directly (existing flow)
      await this.updateInvoiceMetadata(this.state.invoice.id, PO);
    }

    // Always store PO on the request record so it's available for future invoice creation
    const updatedRequest = { ...this.state.selectedRequestimate, poNumber: PO };
    await this.updateRequest(updatedRequest);

    this.setState({ showPO: false });
    window.location = "/pickups";
  };

  handleSelectCalendar = async (calendar) => {
    /*console.log(
      "This is what we are updating in the DB for Calendar",
      calendar
    );*/
    let calId = "primary";
    if (calendar.name !== calendar.id) calId = calendar.id;

    await this.updateInstallerLocation(calId);
    this.setState({ showCalendar: false });
    alert("Calendar updated.");
    this.props.onSwitch(this.props.typeId);
  };

  handleRequestimateSelect = async (requestimate) => {
 //console.log("Requestimate selected:", requestimate);

  // Drafts aren't live jobs — skip the detail API fan-out and swap the right
  // column to the DraftActionPanel (Continue editing / Delete).
  if (requestimate.currentState === 'draft') {
    const shouldHideList = this.state.fromToday || window.innerWidth < 992;
    this.setState({
      selectedDraft: requestimate,
      selectedDraftPayload: null,
      selectedRequestimate: {},
      hiddenList: shouldHideList,
      loading: false,
    });
    // A draft has no joined vehicle/customer rows yet — the entered detail lives in
    // the snapshot. Pull it so the panel can show the vehicle and customer.
    getDraft(requestimate.requestId)
      .then((d) => {
        const payload = d && (typeof d.draft_payload === 'string'
          ? JSON.parse(d.draft_payload)
          : d.draft_payload);
        // Ignore if the selection changed while this was in flight.
        if (this.state.selectedDraft && this.state.selectedDraft.requestId === requestimate.requestId) {
          this.setState({ selectedDraftPayload: payload || null });
        }
      })
      .catch((e) => console.warn('Could not load draft detail:', e));
    return;
  }

  // Prevent re-selection of the same request
  if (this.state.selectedRequestimate?.requestId === requestimate.requestId) {
   //console.log("Same request already selected, skipping");
    return;
  }

  // Detect if we should hide the list (mobile/tablet or narrow window)
  // Use screen width check instead of user agent for more reliable detection
  // Bootstrap lg breakpoint is 992px - hide list below that
  const shouldHideList = this.state.fromToday || window.innerWidth < 992;

  // Set loading state immediately for better UX, and hide list on smaller screens or when from Today.
  // Clear any selected draft so the normal detail panel returns.
  this.setState({
    loading: true,
    hiddenList: shouldHideList,
    selectedDraft: null,
    selectedDraftPayload: null
  });
  
  try {
    // Set the upstream request
    await this.props.selectRequest(requestimate.requestId);

    // Prepare core API calls that we'll handle manually
    const coreApiPromises = [];
    const promiseTypes = [];

    // Services API call
    coreApiPromises.push(
      API.get(`/requestService/${requestimate.requestId}`).then(({ data: services }) => {
        // Process services like the original method
        for (let i = 0; i < services.length; i++) {
          if (services[i].custom_description) {
            services[i].Description = services[i].custom_description;
          }
        }
        return services;
      })
    );
    promiseTypes.push('services');

    // Request states API call
    coreApiPromises.push(
      API.get(`/requeststate/${requestimate.requestId}`).then(({ data: history }) => {
        let selectHistory = history.filter(
          (item) => item.requestId === requestimate.requestId
        );
        return selectHistory;
      })
    );
    promiseTypes.push('states');

    // Notes API call
    coreApiPromises.push(
      API.get(`/requestnotes/${requestimate.requestId}`).then(({ data: notes }) => notes)
    );
    promiseTypes.push('notes');

    // Offers API call
    coreApiPromises.push(
      API.get(`/requestoffered/request/${requestimate.requestId}`).then(({ data: offers }) => offers)
    );
    promiseTypes.push('offers');

        // NEW: Referral check API call
    coreApiPromises.push(
      console.log('Fetching referral for request:', requestimate.requestId) ||
      API.get(`/requestreferral/${requestimate.requestId}`)
        .then(({ data: referralData }) => {
          // Return referral info or null if no referral found
          return referralData && referralData.length > 0 ? referralData[0] : null;
        })
        .catch((error) => {
          // Silent failure - many requests won't have referrals
          console.log('No referral found for request:', requestimate.requestId);
          return null;
        })
    );
    promiseTypes.push('referral');

    // NEW: Calendar data for this specific request (for both dealers and installers)
    if (['scheduled', 'received', 'started', 'finished'].includes(requestimate.currentState)) {
      coreApiPromises.push(
        API.get(`/installerCalendarRequest/${requestimate.requestId}`)
          .then(({ data: requestCalendarDays }) => requestCalendarDays)
      );
      promiseTypes.push('requestCalendar');
    }

    // Vehicle images from check-in AND completion - fetch all photos in one call
    // Also extracts odometer_reading, plate, and carfax_opt_out for deferred CarFax data collection
    coreApiPromises.push(
      API.get(`/requests/${requestimate.requestId}/checkin/status`)
        .then(({ data: checkinData }) => {
          let allPhotoKeys = [];

          // Extract CarFax-relevant fields from checkin data
          console.log('[Requestimates] checkin/status raw data:', JSON.stringify(checkinData?.data, null, 2));
          const odometerReading = checkinData?.data?.odometer_reading || null;
          const plate = checkinData?.data?.plate_state || null;
          const carfaxOptOut = !!checkinData?.data?.carfax_opt_out;

          // Extract condition_photos from the nested data object
          if (checkinData?.data?.condition_photos && Array.isArray(checkinData.data.condition_photos)) {
            const conditionPhotos = checkinData.data.condition_photos.map((photo, index) => ({
              s3_key: photo.s3_key,
              id: photo.id,
              sequence: photo.photo_sequence,
              uploaded_at: photo.uploaded_at,
              caption: photo.photo_type === 'completion'
                ? `Completion - Photo ${index + 1}`
                : `Check-In - Condition Photo ${index + 1}`,
              type: photo.photo_type || 'checkin'
            }));
            allPhotoKeys = [...allPhotoKeys, ...conditionPhotos];
          }

          // Add odometer photo if it exists
          if (checkinData?.data?.odometer_photo_s3_key) {
            allPhotoKeys.push({
              s3_key: checkinData.data.odometer_photo_s3_key,
              id: 'odometer',
              sequence: 998,
              caption: 'Check-In - Odometer Reading',
              type: 'odometer'
            });
          }

          return { allPhotoKeys, odometerReading, plate, carfaxOptOut };
        })
        .catch((error) => {
          console.error('Error fetching photos:', error);
          return { allPhotoKeys: [], odometerReading: null, plate: null, carfaxOptOut: false };
        })
        .then(async ({ allPhotoKeys, odometerReading, plate, carfaxOptOut }) => {
          // Fetch signed URLs for all photos
          let photos = [];
          if (allPhotoKeys.length > 0) {
            const urlPromises = allPhotoKeys.map(async (photo) => {
              try {
                const response = await API.get(`/checkin/photo/signed-url?s3Key=${encodeURIComponent(photo.s3_key)}`);
                return {
                  url: response.data.signedUrl || response.data.url,
                  photo_url: response.data.signedUrl || response.data.url,
                  caption: photo.caption,
                  sequence: photo.sequence,
                  id: photo.id,
                  type: photo.type
                };
              } catch (error) {
                console.error('Error fetching signed URL for photo:', photo.s3_key, error);
                return null;
              }
            });

            photos = (await Promise.all(urlPromises)).filter(p => p !== null);

            // Sort by sequence to maintain order: checkin photos first, then completion
            photos.sort((a, b) => a.sequence - b.sequence);
          }

          return { photos, odometerReading, plate, carfaxOptOut };
        })
    );
    promiseTypes.push('vehicleImages');

    // Conditional API calls
    // For finished jobs (installer or dealer), check for a draft first before
    // fetching the Stripe invoice. Both retail and dealer follow the deferred
    // draft → materialize lifecycle.
    if (
      requestimate.currentState === 'finished' &&
      this.state.userType === 'installer'
    ) {
      coreApiPromises.push(
        API.get(`/invoices/draft/${requestimate.requestId}`)
          .then(({ data: draftData }) => {
            if (draftData && draftData.draft === true) {
              // Pending draft — return as draft marker, skip Stripe fetch
              return { _isDraft: true, paymentId: draftData.paymentId, amount: draftData.amount, paymentToken: draftData.paymentToken };
            }
            // Settled offline — cash/check taken while Stripe was unreachable, so the
            // row is paid with no invoice. Must be caught BEFORE the auto-create below:
            // this shape carries neither `draft` nor `invoiceId`, so falling through
            // would mint a fresh draft and re-offer Check Out on money already taken.
            // The server materializes the invoice later on a reconcile pass (spec §2).
            if (draftData && draftData.settledOffline === true) {
              return { _settledOffline: true, settlement: draftData };
            }
            // Already materialized or no draft — fetch Stripe invoice if available
            const invoiceId = draftData?.invoiceId || requestimate.invoiceId;
            if (invoiceId) {
              return API.get(`/invoices/${invoiceId}`).then(({ data: invoice }) => invoice);
            }
            // No draft and no invoice — auto-create a fresh draft (e.g. after edit)
            return API.post('/invoices/', {
              invoiceId: requestimate.requestId,
              invoiceType: requestimate.requestType,
            }).then(({ data: newDraft }) => {
              if (newDraft && newDraft.draft === true) {
                return { _isDraft: true, paymentId: newDraft.paymentId, amount: newDraft.amount, paymentToken: newDraft.paymentToken };
              }
              // Server created a real invoice instead of draft
              if (newDraft.invoiceId) {
                return API.get(`/invoices/${newDraft.invoiceId}`).then(({ data: invoice }) => invoice);
              }
              return {};
            }).catch(() => ({}));
          })
          .catch(() => {
            // Draft endpoint 404'd (no draft exists yet — a normal state, not an
            // error). Fall back to an existing invoice, else auto-create a draft
            // so checkout can materialize (mirrors the 200/no-draft path above).
            if (requestimate.invoiceId) {
              return API.get(`/invoices/${requestimate.invoiceId}`).then(({ data: invoice }) => invoice);
            }
            return API.post('/invoices/', {
              invoiceId: requestimate.requestId,
              invoiceType: requestimate.requestType,
            }).then(({ data: newDraft }) => {
              if (newDraft && newDraft.draft === true) {
                return { _isDraft: true, paymentId: newDraft.paymentId, amount: newDraft.amount, paymentToken: newDraft.paymentToken };
              }
              if (newDraft && newDraft.invoiceId) {
                return API.get(`/invoices/${newDraft.invoiceId}`).then(({ data: invoice }) => invoice);
              }
              return {};
            }).catch(() => ({}));
          })
      );
      promiseTypes.push('invoice');
    } else if (requestimate.invoiceId) {
      coreApiPromises.push(
        API.get(`/invoices/${requestimate.invoiceId}`).then(({ data: invoice }) => invoice)
      );
      promiseTypes.push('invoice');
    }

    if (this.state.userType === "dealer" && requestimate.assignedTo) {
      coreApiPromises.push(
        API.get(`/installerLocations/${requestimate.assignedTo}`).then(({ data: locations }) => {
          // For dealers, use the job's location_id to find the correct installer location
          const jobLocId = requestimate.location_id || requestimate.locationId;
          const match = jobLocId
            ? locations.find(l => String(l.location_id || l.Location_id) === String(jobLocId))
            : null;
          return match || locations[0];
        })
      );
      promiseTypes.push('installer');
    }

    // Execute all API calls in parallel
    const results = await Promise.allSettled(coreApiPromises);

    // Process results and build state update object
    const stateUpdate = this.processParallelResults(results, promiseTypes, requestimate);

    // Calculate initial date state ONCE without triggering onStartDateChange
    // Priority: offer startDate > request availableDate > dueDate
    let initialStartDate = requestimate.availableDate || requestimate.dueDate;
    if (stateUpdate.selectedOffers && stateUpdate.selectedOffers.length === 1) {
      initialStartDate = stateUpdate.selectedOffers[0].startDate;
    }
    
    // Add the calculated start date to state update
    stateUpdate.startDate = initialStartDate;

    // Only fetch availability for installer booking scenarios, and only if needed
    if (this.state.userType === "installer") {
      const needsAvailability = (
        requestimate.currentState === "new" ||        // All booking scenarios
        requestimate.currentState === "scheduled"     // Rescheduling scenarios
      );
      
      if (needsAvailability) {
        try {
          const dateParam = moment(initialStartDate).format('YYYY-MM-DD');
          // Use the request's own location, not the nav selector
          const reqLocId = requestimate.location_id || requestimate.locationId;
          const selLocParam = reqLocId && reqLocId !== 0 && reqLocId !== '0'
            ? `&locationId=${reqLocId}` : '';
          const { data: availability } = await API.get(
            `/availability/${this.state.typeId}/${requestimate.requestId}?checkDate=${dateParam}${selLocParam}`
          );
          stateUpdate.availability = availability;

          // Only override startDate with availability suggestion if the request's
          // available date is in the past — otherwise respect the customer's requested date
          if (availability && availability.nextStart) {
            const requestedDate = moment(initialStartDate);
            if (requestedDate.isBefore(moment().startOf('day'))) {
              const nextStartDateOnly = availability.nextStart.substring(0, 10) + 'T12:00:00';
              stateUpdate.startDate = new Date(nextStartDateOnly);
            }
          }
        } catch (availabilityError) {
         //console.log('Availability fetch failed, using fallback:', availabilityError.message);
          stateUpdate.availability = null;
        }
      }
    }

    // Reset dealer-invoice readiness for this request load; fetch if applicable.
    stateUpdate.invoiceReadiness = null;
    stateUpdate.readyLocations = null;

    // Single state update with all data - NO onStartDateChange call
    this.setState(stateUpdate, () => {
      // After state is set, load payment history if eligible for split payments
      if (this.shouldLoadPaymentData()) {
        this.loadPaymentHistory();
      }
      // Fetch service items for services that have them
      this.loadServiceItems(stateUpdate.services || []);
      // Dealer job w/ no invoice + installer viewer → fetch Stripe readiness
      if (
        this.state.userType === 'installer' &&
        requestimate.requestType === 'dealer' &&
        !requestimate.invoiceId
      ) {
        this.fetchInvoiceReadiness(requestimate.requestId);
      }
    });

  } catch (error) {
    console.error('Error loading requestimate details:', error);
    // Show error state or fallback - maintain existing structure
    this.setState({
      selectedRequestimate: requestimate,
      services: [],
      requestStates: [],
      requestNotes: [],
      requestOffers: [],
      selectedOffers: [],
      invoice: {},
      finalInvoiceId: null,
      availability: null,
      selectedService: 0,
      activePage: 1,
      vinGood: !isUncollectedVin(requestimate.vin),
      startDate: requestimate.dueDate,
      requestCalendarDays: [], // NEW: Add empty calendar data on error
      loading: false,
      referralData: null, // NEW: Initialize referral data on error
    });
  } finally {
    // Ensure loading state is cleared
    this.setState({ loading: false });
  }
};

// FIND the processParallelResults method in requestimates.jsx (around line 2000-2100)
// REPLACE it with this updated version that handles referral data

processParallelResults = (results, promiseTypes, requestimate) => {
  // Create a working copy of the requestimate
  let updatedRequestimate = { ...requestimate };
  
  const stateUpdate = {
    selectedRequestimate: updatedRequestimate,
    selectedService: 0,
    activePage: 1,
    vinGood: !isUncollectedVin(requestimate.vin),
    services: [],
    requestStates: [],
    requestNotes: [],
    requestOffers: [],
    selectedOffers: [],
    invoice: {},
    finalInvoiceId: null, // Initialize for split payment feature
    draftPayment: null, // Reset draft state for new record
    offlineSettlement: null, // Reset settled-offline payload for new record
    installer: this.state.installer, // Keep existing installer unless updated
    availability: null,
    startDate: requestimate.availableDate || requestimate.dueDate,
    requestCalendarDays: [],
    referralData: null // NEW: Initialize referral data
  };

  // Process each result based on its type
  results.forEach((result, index) => {
    const type = promiseTypes[index];

    if (result.status === 'fulfilled') {
      switch (type) {
        case 'services':
          stateUpdate.services = result.value || [];
          break;

        case 'states':
          stateUpdate.requestStates = result.value || [];
          break;

        case 'notes':
          stateUpdate.requestNotes = result.value || [];
          break;

        case 'offers':
          stateUpdate.requestOffers = result.value || [];
          break;

        case 'invoice':
          const invoice = result.value || {};

          // Draft marker from draft-first check
          if (invoice._isDraft) {
            stateUpdate.invoice = {};
            stateUpdate.draftPayment = {
              paymentId: invoice.paymentId,
              amount: invoice.amount,
              paymentToken: invoice.paymentToken,
            };
          } else if (invoice._settledOffline) {
            // Paid offline, invoice not yet materialized. No Stripe invoice and no
            // draft — leaving draftPayment null keeps Check Out from re-collecting,
            // and offlineSettlement is what unlocks Deliver (src/util/deliverGate.js).
            stateUpdate.invoice = {};
            stateUpdate.offlineSettlement = invoice.settlement;
          } else {
            stateUpdate.invoice = invoice;

            // Set finalInvoiceId for split payment feature
            stateUpdate.finalInvoiceId = invoice.id || null;

            // Add invoice number to requestimate if available
            if (invoice && invoice.number) {
              updatedRequestimate.customer_facing_invoice = invoice.number;
              stateUpdate.selectedRequestimate = updatedRequestimate;
            }
          }

          break;

        case 'installer':
          stateUpdate.installer = result.value || this.state.installer;
          break;

        case 'availability':
          stateUpdate.availability = result.value || null;
          break;

        // Handle request calendar data with field mapping
        case 'requestCalendar':
          const rawCalendarData = result.value || [];
          // Map snake_case API response to camelCase for utility functions
          const mappedCalendarData = rawCalendarData.map(entry => ({
            ...entry,
            workDate: entry.work_date,     // Map work_date -> workDate
            workStatus: entry.work_status, // Map work_status -> workStatus
            requestId: entry.request_id,    // Map request_id -> requestId (if needed)
            duration: entry.daily_work  // Map daily work for other calculation
          }));
          stateUpdate.requestCalendarDays = mappedCalendarData;
          console.log('Request calendar data loaded and mapped:', mappedCalendarData);
          break;

        // NEW: Handle referral data
        case 'referral':
          const referralData = result.value;
          stateUpdate.referralData = referralData;

          // Add referral_id to the selectedRequestimate for easy access during state transitions
          if (referralData && referralData.referral_id) {
            updatedRequestimate.referral_id = referralData.referral_id;
            updatedRequestimate.referral_status = referralData.status;
            stateUpdate.selectedRequestimate = updatedRequestimate;
            console.log('Referral data loaded for request:', referralData.referral_id);
          } else {
            console.log('No referral found for this request');
          }
          break;

        // Handle vehicle images and CarFax data from check-in
        case 'vehicleImages': {
          const checkinResult = result.value || {};
          stateUpdate.vehicleImages = checkinResult.photos || [];
          stateUpdate.checkinOdometerReading = checkinResult.odometerReading || null;
          stateUpdate.checkinPlate = checkinResult.plate || null;
          // Respect server's explicit value if present (user made a choice at check-in).
          // If missing (no check-in yet), default retail to opt-out so the validation
          // warning doesn't fire on every retail vehicle before check-in.
          if (
            checkinResult.carfaxOptOut === true ||
            checkinResult.carfaxOptOut === false
          ) {
            stateUpdate.checkinCarfaxOptOut = checkinResult.carfaxOptOut;
          } else {
            stateUpdate.checkinCarfaxOptOut =
              requestimate.requestType === 'installer';
          }
          console.log('Setting vehicleImages in state:', stateUpdate.vehicleImages);
          if (stateUpdate.vehicleImages.length > 0) {
            console.log(`Loaded ${stateUpdate.vehicleImages.length} vehicle images for request`);
          } else {
            console.log('No vehicle images to display');
          }
          break;
        }

        default:
          console.warn(`Unknown promise type: ${type}`);
      }
    } else {
      // Handle failed promises gracefully
      console.error(`Failed to load ${type}:`, result.reason);
      
      // Set default values for failed requests
      switch (type) {
        case 'services':
          stateUpdate.services = [];
          break;
        case 'states':
          stateUpdate.requestStates = [];
          break;
        case 'notes':
          stateUpdate.requestNotes = [];
          break;
        case 'offers':
          stateUpdate.requestOffers = [];
          break;
        case 'invoice':
          stateUpdate.invoice = {};
          break;
        case 'installer':
          stateUpdate.installer = this.state.installer;
          break;
        case 'availability':
          stateUpdate.availability = null;
          break;
        case 'requestCalendar':
          stateUpdate.requestCalendarDays = [];
          break;
        case 'referral':
          stateUpdate.referralData = null;
          // Don't add referral_id to requestimate if the call failed
          break;
        case 'vehicleImages':
          stateUpdate.vehicleImages = [];
          stateUpdate.checkinOdometerReading = null;
          stateUpdate.checkinPlate = null;
          // Same default as the success path — retail defaults to opt-out.
          stateUpdate.checkinCarfaxOptOut =
            requestimate.requestType === 'installer';
          break;
        default:
          break;
      }
    }
  });

  // Process selected offers based on user type (this logic was in the original)
  let selectedOffers = [];
  if (stateUpdate.requestOffers && stateUpdate.requestOffers.length > 0) {
    selectedOffers = stateUpdate.requestOffers.filter(
      (offer) => offer.requestId === requestimate.requestId
    );
    
    if (this.state.userType === "installer") {
      selectedOffers = selectedOffers.filter(
        (offer) => offer.installerId === parseInt(this.state.typeId)
      );
    }
  }
  stateUpdate.selectedOffers = selectedOffers;

  // Determine start date - prefer customer's available date over due date
  let startDate = requestimate.availableDate || requestimate.dueDate;
  if (selectedOffers.length === 1) {
    startDate = selectedOffers[0].startDate;
  }
  stateUpdate.startDate = startDate;

  return stateUpdate;
};

// Helper method to process all API results
processApiResults = (results, promiseTypes, requestimate) => {
  const stateUpdate = {
    selectedRequestimate: { ...requestimate },
    selectedService: 0,
    activePage: 1,
    vinGood: !isUncollectedVin(requestimate.vin)
  };

  // Process each result based on its type
  results.forEach((result, index) => {
    const type = promiseTypes[index];
    
    if (result.status === 'fulfilled') {
      switch (type) {
        case 'services':
          // Process services data (add custom descriptions if needed)
          const services = result.value || [];
          services.forEach(service => {
            if (service.custom_description) {
              service.Description = service.custom_description;
            }
          });
          stateUpdate.services = services;
          break;

        case 'states':
          // Process states data (add created date)
          const history = result.value || [];
          let selectHistory = history.filter(
            (item) => item.requestId === requestimate.requestId
          );
          stateUpdate.requestStates = selectHistory;
          break;

        case 'notes':
          stateUpdate.requestNotes = result.value || [];
          break;

        case 'offers':
          stateUpdate.requestOffers = result.value || [];
          break;

        case 'invoice':
          const invoice = result.value || {};
          stateUpdate.invoice = invoice;
          
          // Add invoice number to requestimate if available
          if (invoice && invoice.number) {
            stateUpdate.selectedRequestimate.customer_facing_invoice = invoice.number;
          }
          break;

        case 'installer':
          // This sets this.state.installer via the readInstaller method
          // No additional processing needed here as readInstaller handles setState
          break;

        case 'availability':
          stateUpdate.availability = result.value || null;
          break;

        default:
          console.warn(`Unknown promise type: ${type}`);
      }
    } else {
      // Handle failed promises gracefully
      console.error(`Failed to load ${type}:`, result.reason);
      
      // Set default values for failed requests
      switch (type) {
        case 'services':
          stateUpdate.services = [];
          break;
        case 'states':
          stateUpdate.requestStates = [];
          break;
        case 'notes':
          stateUpdate.requestNotes = [];
          break;
        case 'offers':
          stateUpdate.requestOffers = [];
          break;
        case 'invoice':
          stateUpdate.invoice = {};
          break;
        case 'availability':
          stateUpdate.availability = null;
          break;
        default:
          break;
      }
    }
  });

  // Process selected offers based on user type
  let selectedOffers = [];
  if (stateUpdate.requestOffers) {
    selectedOffers = stateUpdate.requestOffers.filter(
      (offer) => offer.requestId === requestimate.requestId
    );

    if (this.state.userType === "installer") {
      selectedOffers = selectedOffers.filter(
        (offer) => offer.installerId === parseInt(this.state.typeId)
      );
    }
  }
  stateUpdate.selectedOffers = selectedOffers;

  // Determine start date - prefer customer's available date over due date
  let startDate = requestimate.availableDate || requestimate.dueDate;
  if (selectedOffers.length === 1) {
    startDate = selectedOffers[0].startDate;
  }
  stateUpdate.startDate = startDate;

  return stateUpdate;
};

  clearRequestimate = async () => {
    await this.props.selectRequest("");
    this.setState({ selectedRequestimate: "", availability : null });
  };

  handleEdit = async () => {
    window.location = "/editJob/" + this.props.selectedRequest;
  };

  // =========================================================================

  loadFavorites = async () => {
    try {
      const userId = this.props.user?.User_id;
      if (!userId) return;
      const allItems = this.state.requestimates || [];
      const entityIds = allItems.map(item => item.requestId).filter(Boolean);
      const favIds = await FavoritesAPI.check(userId, 'request', entityIds);
      this.setState({ favoriteIds: new Set(favIds) });
    } catch (err) {
      console.error('Failed to load favorites', err);
    }
  };

  toggleFavorite = async (e, requestId) => {
    e.stopPropagation(); // Don't trigger row select
    const userId = this.props.user?.User_id;
    if (!userId) return;

    // Optimistic update
    const prev = new Set(this.state.favoriteIds);
    const next = new Set(prev);
    if (next.has(requestId)) {
      next.delete(requestId);
    } else {
      next.add(requestId);
    }
    this.setState({ favoriteIds: next });

    try {
      const result = await FavoritesAPI.toggle(userId, 'request', requestId);
      // Reconcile with server response
      const reconciled = new Set(this.state.favoriteIds);
      if (result.favorited) {
        reconciled.add(requestId);
      } else {
        reconciled.delete(requestId);
      }
      this.setState({ favoriteIds: reconciled });
    } catch (err) {
      // Roll back on failure
      this.setState({ favoriteIds: prev });
      console.error('Failed to toggle favorite', err);
    }
  };

  applyListFilter = (list) => {
    const { listFilter } = this.state;
    if (!listFilter) return list;

    const [type, ...valueParts] = listFilter.split(':');
    const value = valueParts.join(':');

    switch (type) {
      case 'channel':
        return list.filter(item => item.requestType === value);
      case 'customer':
        return list.filter(item => item.dealerName === value);
      case 'specialist':
        return list.filter(item => item.installerName === value);
      case 'dealership':
        return list.filter(item => item.dealerName === value);
      case 'favorites':
        return list.filter(item => this.state.favoriteIds.has(item.requestId));
      default:
        return list;
    }
  }

  renderRequestimateFilterDropdown = (requestimateList) => {
    const { listFilter, showFilterDropdown } = this.state;
    const { userType, mode } = this.props;

    // Determine which tabs get a filter
    const noFilterTabs = userType === 'dealer'
      ? ['reviews']
      : [];
    if (noFilterTabs.includes(mode)) return null;

    const isActive = listFilter !== '';

    // Build filter options based on user type
    let sections = [];

    // Favorites filter (all user types)
    const favCount = requestimateList.filter(r => this.state.favoriteIds.has(r.requestId)).length;
    if (favCount > 0) {
      sections.push({
        header: null,
        options: [{
          key: 'favorites:all',
          label: 'Favorites',
          count: favCount,
          icon: 'fa-sharp fa-solid fa-star'
        }]
      });
    }

    if (userType === 'installer') {
      // Channel section
      const channels = [...new Set(requestimateList.map(r => r.requestType).filter(Boolean))].sort();
      if (channels.length > 0) {
        const channelLabels = { dealer: 'Dealer', installer: 'Retail' };
        sections.push({
          header: 'Channel',
          options: channels.map(ch => ({
            key: `channel:${ch}`,
            label: channelLabels[ch] || ch,
            count: requestimateList.filter(r => r.requestType === ch).length,
            icon: ch === 'dealer'
              ? 'fa-sharp fa-solid fa-handshake'
              : 'fa-sharp fa-solid fa-user'
          }))
        });
      }

      // Customer section
      const customers = [...new Set(requestimateList.map(r => r.dealerName).filter(Boolean))].sort();
      if (customers.length > 1) {
        sections.push({
          header: 'Customer',
          options: customers.map(name => ({
            key: `customer:${name}`,
            label: name,
            count: requestimateList.filter(r => r.dealerName === name).length
          }))
        });
      }
    } else if (userType === 'dealer') {
      // Specialist section
      const specialists = [...new Set(requestimateList.map(r => r.installerName).filter(Boolean))].sort();
      if (specialists.length > 1) {
        sections.push({
          header: 'Specialist',
          options: specialists.map(name => ({
            key: `specialist:${name}`,
            label: name,
            count: requestimateList.filter(r => r.installerName === name).length
          }))
        });
      }

      // Dealer group: dealership section (when viewing all dealerships)
      if (ScopeService.isDealerGroupUser() && isAllDealerships(this.props.selectedDealerId)) {
        const dealerNames = [...new Set(requestimateList.map(r => r.dealerName).filter(Boolean))].sort();
        if (dealerNames.length > 1) {
          sections.push({
            header: 'Dealership',
            options: dealerNames.map(name => ({
              key: `dealership:${name}`,
              label: name,
              count: requestimateList.filter(r => r.dealerName === name).length
            }))
          });
        }
      }
    }

    // Nothing to filter
    if (sections.length === 0) return null;

    const filteredCount = this.applyListFilter(requestimateList).length;

    return (
      <div style={{ position: 'relative' }}>
        <button
          className={`btn btn-sm btn-header-icon${isActive ? ' filter-active' : ''}`}
          onClick={() => this.setState({ showFilterDropdown: !showFilterDropdown })}
          title="Filter list"
        >
          <i className={`fa-sharp ${isActive ? 'fa-solid' : 'fa-regular'} fa-filter`}></i>
          {isActive && (
            <span style={{
              position: 'absolute', top: '-2px', right: '-2px',
              background: '#fff', color: '#5196d3', borderRadius: '50%',
              fontSize: '9px', fontWeight: 700, width: '14px', height: '14px',
              display: 'flex', alignItems: 'center', justifyContent: 'center'
            }}>
              {filteredCount}
            </span>
          )}
        </button>
        {showFilterDropdown && (
          <>
            <div style={{ position: 'fixed', inset: 0, zIndex: 1049 }}
              onClick={() => this.setState({ showFilterDropdown: false })} />
            <div className="filter-dropdown-menu">
              <div
                className={`filter-item${listFilter === '' ? ' active' : ''}`}
                onClick={() => this.setState({ listFilter: '', showFilterDropdown: false })}
              >
                All ({requestimateList.length})
              </div>
              {sections.map((section, si) => (
                <React.Fragment key={si}>
                  <div className="filter-divider" />
                  {section.header && (
                    <div className="filter-section-header">{section.header}</div>
                  )}
                  {section.options.map(opt => (
                    <div
                      key={opt.key}
                      className={`filter-item${listFilter === opt.key ? ' active' : ''}`}
                      onClick={() => this.setState({ listFilter: opt.key, showFilterDropdown: false })}
                    >
                      {opt.icon && <i className={opt.icon} style={{ width: '16px', textAlign: 'center' }}></i>}
                      <span>{opt.label} ({opt.count})</span>
                    </div>
                  ))}
                </React.Fragment>
              ))}
            </div>
          </>
        )}
      </div>
    );
  }

  // render logic to display the list, detail and various states
  render() {
    // =================================================

    //console.log("Here are the requests :", this.state.requestimates)

    const { typeId, mode } = this.props;
    const { userType, showHelpVideo } = this.state;
    ReactGA.initialize(process.env.REACT_APP_GA);

  //   //console.log('Requestimates : Company', this.props.company);
    // //console.log('typeId', typeId)
    // //console.log('mode', mode)
    // //console.log('Requestimates : this.props.selectedRequest', this.props.selectedRequest)

    // first let's make sure that if there is a google calendar integrated that we
    // have the right one

    // filter the list of returned information based on the mode
    let requestimateList = [];
    const isDealerView = userType === "dealer";

    if (isDealerView && mode === "requests") {
      ReactGA.send({ hitType: "pageview", page: "/dealerRequests" });
      requestimateList = this.state.requestimates.filter(
        (req) =>
          req.currentState === "new" ||
          req.currentState === "answered" ||
          req.currentState === "draft" // resumable in-progress requestimates (own company)
      );
      // //console.log(requestimateList)
    }

    if (isDealerView && mode === "jobs") {
      // Parse filter from URL query params (e.g., /jobs?filter=scheduled)
      const searchParams = new URLSearchParams(this.props.location?.search || '');
      const jobFilter = searchParams.get('filter');

      if (jobFilter === 'scheduled') {
        ReactGA.send({ hitType: "pageview", page: "/dealerJobs/scheduled" });
        requestimateList = this.state.requestimates.filter(
          (req) => req.currentState === "scheduled"
        );
      } else if (jobFilter === 'inprogress') {
        ReactGA.send({ hitType: "pageview", page: "/dealerJobs/inprogress" });
        requestimateList = this.state.requestimates.filter(
          (req) =>
            req.currentState === "received" ||
            req.currentState === "started"
        );
      } else {
        // Default: show all jobs (backwards compatibility)
        ReactGA.send({ hitType: "pageview", page: "/dealerJobs" });
        requestimateList = this.state.requestimates.filter(
          (req) =>
            req.currentState === "scheduled" ||
            req.currentState === "started" ||
            req.currentState === "received"
        );
      }
    }

    if (isDealerView && mode === "pickups") {
      ReactGA.send({ hitType: "pageview", page: "/dealerPickups" });
      requestimateList = this.state.requestimates.filter(
        (req) => req.currentState === "finished"
      );
    }

    if (isDealerView && mode === "reviews") {
      ReactGA.send({ hitType: "pageview", page: "/dealerReviews" });
      requestimateList = this.state.requestimates.filter(
        (req) => req.currentState === "collected"
      );
    }

    if (userType === "installer" && mode === "requests") {
      ReactGA.send({ hitType: "pageview", page: "/installerRequests" });
      requestimateList = this.state.requestimates.filter(
        (req) =>
          (req.currentState === "new" && req.offerState === "offered") ||
          req.currentState === "draft" // resumable in-progress requestimates (own company)
      );
    }

    if (userType === "installer" && mode === "jobs") {
      // Parse filter from URL query params (e.g., /jobs?filter=scheduled)
      const searchParams = new URLSearchParams(this.props.location?.search || '');
      const jobFilter = searchParams.get('filter');

      if (jobFilter === 'scheduled') {
        ReactGA.send({ hitType: "pageview", page: "/installerJobs/scheduled" });
        requestimateList = this.state.requestimates.filter(
          (req) => req.currentState === "scheduled"
        );
      } else if (jobFilter === 'inprogress') {
        ReactGA.send({ hitType: "pageview", page: "/installerJobs/inprogress" });
        requestimateList = this.state.requestimates.filter(
          (req) =>
            req.currentState === "received" ||
            req.currentState === "started"
        );
      } else {
        // Default: show all jobs (backwards compatibility)
        ReactGA.send({ hitType: "pageview", page: "/installerJobs" });
        requestimateList = this.state.requestimates.filter(
          (req) =>
            req.currentState === "scheduled" ||
            req.currentState === "received" ||
            req.currentState === "started"
        );
      }
      // Sort jobs by scheduled workDate from calendar
      requestimateList = this.sortByCalendarDate(requestimateList);
    }

    if (userType === "installer" && mode === "pickups") {
      ReactGA.send({ hitType: "pageview", page: "/installerPickups" });

      requestimateList = this.state.requestimates.filter(
        (req) =>
          req.currentState === "finished" ||
          req.currentState === "paid" ||
          // Dealer job was delivered but never got an invoice — keep it
          // visible on Pickups until the recovery flow creates one.
          (req.currentState === "collected" &&
            req.requestType === "dealer" &&
            !req.invoiceId)
      );
      // Sort pickups by scheduled workDate from calendar
      requestimateList = this.sortByCalendarDate(requestimateList);
    }
    let namePage = userType === "dealer" ? "Requests" : "Requestimates";
    if (mode === "jobs") {
      // Check for filter to show specific page name
      const searchParams = new URLSearchParams(this.props.location?.search || '');
      const jobFilter = searchParams.get('filter');
      if (jobFilter === 'scheduled') {
        namePage = "Scheduled";
      } else if (jobFilter === 'inprogress') {
        namePage = "In Progress";
      } else {
        namePage = "Jobs";
      }
    }
    if (mode === "pickups") namePage = "Pickups";
    if (mode === "reviews") namePage = "Reviews";

    // Location filter: specific location view shows own + unclaimed requests (installer only)
    // Dealer group uses dealership filtering via API params, not location_id
    // NB: no multiLoc gate here — a user PINNED to one location of a multi-location
    // installer has locations.length === 1 but still needs filtering (fetches pull
    // ALL the installer's records). selectedLocationId alone encodes the need.
    // multiLoc remains for display-only concerns (location badges) below.
    const multiLoc = isMultiLocation(this.props.locations);
    const allLocView = isAllLocations(this.props.selectedLocationId);
    if (!ScopeService.isDealerGroupUser() && !allLocView) {
      requestimateList = requestimateList.filter(item =>
        isUnclaimed(item) || String(item.location_id || item.locationId) === String(this.props.selectedLocationId)
      );
    }

    // Save unfiltered list for filter dropdown counts, then apply user filter
    const unfilteredList = requestimateList;
    requestimateList = this.applyListFilter(requestimateList);

    // Helper function to get source type class for list items (installer view only)
    const getSourceClass = (item) => {
      if (userType !== "installer") return "";
      return item.requestType === "dealer" ? "source-dealer" : "source-retail";
    };

    function isEmpty(obj) {
      for (var key in obj) {
        if (obj.hasOwnProperty(key)) return false;
      }
      return true;
    }

 // Add this debug line
 //console.log("Requestimates company prop:", this.props.company);
 

    return (
      <React.Fragment>
        {(() => {
          //console.log("Portal check at top - showHelpVideo:", showHelpVideo);
          if (showHelpVideo) {
            //console.log("About to render portal at top!");
            return ReactDOM.createPortal(
              <div style={{ 
                position: 'fixed', 
                top: 0, 
                left: 0, 
                right: 0, 
                bottom: 0, 
                backgroundColor: 'rgba(0,0,0,0.8)', 
                zIndex: 999999,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}>
                <div style={{ 
                  backgroundColor: 'white', 
                  padding: '20px', 
                  borderRadius: '8px',
                  width: '90%',
                  maxWidth: '1000px',
                  height: '90%',
                  maxHeight: '700px',
                  position: 'relative',
                  display: 'flex',
                  flexDirection: 'column'
                }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px' }}>
                    <h3 style={{ margin: 0 }}>How to Create {userType === "dealer" ? "Requests" : "Estimates"}</h3>
                    <button
                      onClick={this.handleCloseHelpVideo}
                      style={{
                        background: 'none',
                        border: 'none',
                        fontSize: '28px',
                        cursor: 'pointer',
                        lineHeight: 1
                      }}
                    >
                      &times;
                    </button>
                  </div>
                  <div style={{ flex: 1, backgroundColor: '#f0f0f0', borderRadius: '4px' }}>
<iframe
                          src={userType === "dealer"
                            ? "https://scribehow.com/embed/How_To_Submit_A_Request_to_Jobvious__Bl3baC7SRVOWST-ZTrrWUw?as=video"
                            : "https://scribehow.com/embed/Create_a_New_Estimate_for_a_Customer__1NyVekH2QHiwC4qpcUeUiQ?as=video"}
                          width="100%"
                          height="100%"
                          allowFullScreen
                          style={{ border: 0 }}
                          title={userType === "dealer" ? "How to Add a New Request on Jobvious" : "How to Create a New Estimate"}
                                         />
                 
                  </div>
                </div>
              </div>,
              document.body
            );
          }
          return null;
        })()}
        
        <div className={`d-flex align-items-center justify-content-between p-2 list-header ${this.state.fromToday ? 'd-none' : 'd-lg-none d-sm-block'}`}>
          <div className="d-flex align-items-center" style={{ gap: '4px' }}>
            {this.renderRequestimateFilterDropdown(unfilteredList)}
            <button
              className="btn btn-sm btn-header-icon"
              onClick={this.handleRefresh}
              disabled={this.state.refreshing}
              title="Refresh list"
            >
              <i className={`fa-sharp fa-regular fa-refresh ${this.state.refreshing ? 'fa-spin' : ''}`}></i>
            </button>
          </div>
          <h3 className="page-name mb-0">{namePage}</h3>
          {!isEmpty(this.state.selectedRequestimate) ? (
            <button
              type="button"
              className="btn btn-sm btn-header-icon"
              onClick={() => this.handleCancel()}
            >
              <i className="fa-sharp fa-regular fa-times"></i>
            </button>
          ) : (
            <span style={{ width: '32px' }}></span>
          )}
        </div>

        <div className="row">
          <div className={`col-lg-4 text-center ${this.state.fromToday ? 'd-none' : 'd-none d-lg-block'}`}>
            {
              <div className="d-flex align-items-center justify-content-between p-3 mb-0 corners list-header">
                <span style={{ width: '32px' }}></span>
                <h5 className="page-name mb-0">{namePage}</h5>
                <div className="d-flex align-items-center" style={{ gap: '4px' }}>
                  {this.renderRequestimateFilterDropdown(unfilteredList)}
                  <button
                    className="btn btn-sm btn-header-icon"
                    onClick={this.handleRefresh}
                    disabled={this.state.refreshing}
                    title="Refresh list"
                  >
                    <i className={`fa-sharp fa-regular fa-refresh ${this.state.refreshing ? 'fa-spin' : ''}`}></i>
                  </button>
                </div>
              </div>
            }
            <ul className="list-group-fluid p-0 list-group-flush shadow bg-white corners">
              {(mode === "requests" || mode === "jobs" || mode === "pickups") &&
                userType === "dealer" &&
                this.props.user.access !== "ASSIST" && (
                  <li className="list-group-item d-flex justify-content-center align-items-center corners">
                    <Link
                      to="/newrequestimates/"
                      className="jv-btn jv-btn-primary mt-2 mb-2"
                    >
                      <i className="fa-sharp fa-regular fa-plus" /> New Request
                    </Link>
                    {userType === "dealer" && (
                      <button
                        type="button"
                        onClick={this.handleShowHelpVideo}
                        className="btn btn-link p-1 ml-2"
                        title="Click for help video"
                        style={{ fontSize: '16px', color: '#6c757d' }}
                      >
                        <i className="fa-sharp fa-solid fa-circle-question"></i>
                      </button>
                    )}
                  </li>
                )}
              {(mode === "requests" || mode === "jobs" || mode === "pickups") &&
                userType === "installer" &&
                this.props.user.access !== "ASSIST" &&
                !isAllLocations(this.props.selectedLocationId) && (
                  <li className="list-group-item d-flex justify-content-center align-items-center corners">
                    <Link
                      to="/newestimate/"
                      className="jv-btn jv-btn-primary mt-2 mb-2"
                    >
                      <i className="fa-sharp fa-regular fa-plus" /> New Estimate
                    </Link>
                    <button
                      type="button"
                      onClick={this.handleShowHelpVideo}
                      className="btn btn-link p-1 ml-2"
                      title="Click for help video"
                      style={{ fontSize: '16px', color: '#6c757d' }}
                    >
                      <i className="fa-sharp fa-solid fa-circle-question"></i>
                    </button>
                  </li>
                )}
              {requestimateList.map((item) => (
                <li
                  onClick={() => this.handleRequestimateSelect(item)}
                  key={item.requestId}
                  className={
                    item.requestId === this.state.selectedRequestimate.requestId
                      ? `list-group-item active ${getSourceClass(item)}`
                      : `list-group-item ${getSourceClass(item)}`
                  }
                >
                  <small>
                    <div className="row">
                      <div className="col-1 d-flex align-items-center justify-content-center p-0">
                        <i
                          className={`fa-star favorite-star ${this.state.favoriteIds.has(item.requestId) ? 'fa-sharp fa-solid favorited' : 'fa-sharp fa-regular'}`}
                          onClick={(e) => this.toggleFavorite(e, item.requestId)}
                          title={this.state.favoriteIds.has(item.requestId) ? 'Remove from favorites' : 'Add to favorites'}
                        />
                      </div>
                      <div className="col-2 p-0">
                        <b className={this.getDisplayDate(item, mode)?.isSame(moment(), 'day') ? 'date-today' : ''}>
                          {this.getDisplayDate(item, mode)?.format("ddd MMM D") || "—"}
                        </b>
                      </div>
                      <div className="col-7">
                        <div className="row">
                          <div className="col">
                            <div style={{ fontWeight: 'var(--font-weight-semibold)' }}>{item.serviceRequested}</div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col">
                            <div>
                              {item.vehicleColor && `${item.vehicleColor} `}{item.vehicleYear} {item.vehicleMake}{" "}
                              {item.vehicleModel}
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col text-muted" style={{ fontSize: '0.85em' }}>
                            {userType === "installer" && (
                              <div>{item.dealerName}</div>
                            )}
                            {(userType === "dealer") && (
                              <div>{item.installerName}</div>
                            )}
                            {ScopeService.isDealerGroupUser() && isMultiDealership(this.state.dealerships) && isAllDealerships(this.props.selectedDealerId) && item.dealerName && (
                              <span
                                className="badge mt-1"
                                style={{
                                  backgroundColor: getDealershipBadgeColor(item.dealerId || item.dealer_id, this.state.dealerships),
                                  color: '#fff',
                                  fontSize: '0.65rem'
                                }}
                              >
                                {item.dealerName}
                              </span>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="col-2 text-center">
                        {this.iconState(item.currentState, userType)}
                        {canUseJobMessaging(ScopeService.getUserRole(), userType, item.requestType) && formatBadgeCount(item.unread_count) ? (
                          <div className="mt-1">
                            <Badge pill variant="danger" title="Unread messages">
                              <i className="fa-sharp fa-solid fa-comment-dots mr-1" />
                              {formatBadgeCount(item.unread_count)}
                            </Badge>
                          </div>
                        ) : null}
                        {multiLoc && (
                          isUnclaimed(item) ? (
                            <div className="mt-1">
                              <span className="badge" style={{ backgroundColor: '#6c757d', color: '#fff', fontSize: '0.65rem' }}>
                                Unclaimed
                              </span>
                            </div>
                          ) : allLocView && (
                            <div className="mt-1">
                              <span
                                className="badge"
                                style={{
                                  backgroundColor: getLocationBadgeColor(item.location_id || item.locationId, this.props.locations),
                                  color: '#fff',
                                  fontSize: '0.65rem'
                                }}
                              >
                                {item.locationName || item.location_name || getLocationName((this.props.locations || []).find(l => String(l.location_id) === String(item.location_id || item.locationId)))}
                              </span>
                            </div>
                          )
                        )}
                      </div>
                    </div>
                  </small>
                </li>
              ))}
            </ul>
          </div>

          {this.state.hiddenList === false && (
            <div className="col-lg-4 text-center d-lg-none d-sm-block">
              <ul className="list-group-fluid p-0 list-group-flush shadow bg-white">
                {(mode === "requests" ||
                  mode === "jobs" ||
                  mode === "pickups") &&
                  userType === "dealer" &&
                  this.props.user.access !== "ASSIST" && (
                    <li className="list-group-item d-flex justify-content-center align-items-center">
                      <Link
                        to="/newrequestimates/"
                        className="jv-btn jv-btn-primary mt-2 mb-2"
                      >
                        <i className="fa-sharp fa-regular fa-plus" /> New Request
                      </Link>
                      {userType === "dealer" && (
                        <button
                          type="button"
                          onClick={this.handleShowHelpVideo}
                          className="btn btn-link p-1 ml-2"
                          title="Click for help video"
                          style={{ fontSize: '18px', color: '#6c757d' }}
                        >
                          <i className="fa-sharp fa-solid fa-circle-question"></i>
                        </button>
                      )}
                    </li>
                  )}
                {(mode === "requests" ||
                  mode === "jobs" ||
                  mode === "pickups") &&
                  userType === "installer" &&
                  this.props.user.access !== "ASSIST" &&
                  !isAllLocations(this.props.selectedLocationId) && (
                    <li className="list-group-item d-flex justify-content-center align-items-center">
                      <Link
                        to="/newestimate/"
                        className="jv-btn jv-btn-primary mt-2 mb-2"
                      >
                        <i className="fa-sharp fa-regular fa-plus" /> New Estimate
                      </Link>
                      <button
                        type="button"
                        onClick={this.handleShowHelpVideo}
                        className="btn btn-link p-1 ml-2"
                        title="Click for help video"
                        style={{ fontSize: '18px', color: '#6c757d' }}
                      >
                        <i className="fa-sharp fa-solid fa-circle-question"></i>
                      </button>
                    </li>
                  )}

                {requestimateList.map((item) => (
                  <li
                    onClick={() => this.handleRequestimateSelect(item, true)}
                    key={item.requestId}
                    className={
                      item.requestId ===
                      this.state.selectedRequestimate.requestId
                        ? `list-group-item active ${getSourceClass(item)}`
                        : `list-group-item ${getSourceClass(item)}`
                    }
                  >
                    <small>
                      <div className="row">
                        <div className="col-1 d-flex align-items-center justify-content-center p-0">
                          <i
                            className={`fa-star favorite-star ${this.state.favoriteIds.has(item.requestId) ? 'fa-sharp fa-solid favorited' : 'fa-sharp fa-regular'}`}
                            onClick={(e) => this.toggleFavorite(e, item.requestId)}
                            title={this.state.favoriteIds.has(item.requestId) ? 'Remove from favorites' : 'Add to favorites'}
                          />
                        </div>
                        <div className="col-2 p-0">
                          <b className={this.getDisplayDate(item, mode)?.isSame(moment(), 'day') ? 'date-today' : ''}>
                            {this.getDisplayDate(item, mode)?.format("ddd MMM D") || "—"}
                          </b>
                        </div>
                        <div className="col-7">
                          <div className="row">
                            <div className="col">
                              <div>{item.serviceRequested}</div>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col">
                              <div>
                                {item.vehicleColor && `${item.vehicleColor} `}{item.vehicleYear} {item.vehicleMake}{" "}
                                {item.vehicleModel}
                              </div>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col">
                              {userType === "installer" && (
                                <div>{item.dealerName}</div>
                              )}
                              {(userType === "dealer") && (
                                <div>{item.installerName}</div>
                              )}
                              {ScopeService.isDealerGroupUser() && isMultiDealership(this.state.dealerships) && isAllDealerships(this.props.selectedDealerId) && item.dealerName && (
                                <span
                                  className="badge mt-1"
                                  style={{
                                    backgroundColor: getDealershipBadgeColor(item.dealerId || item.dealer_id, this.state.dealerships),
                                    color: '#fff',
                                    fontSize: '0.65rem'
                                  }}
                                >
                                  {item.dealerName}
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="col-2 text-center">
                          {this.iconState(item.currentState, userType)}
                          {multiLoc && (
                            isUnclaimed(item) ? (
                              <div className="mt-1">
                                <span className="badge" style={{ backgroundColor: '#6c757d', color: '#fff', fontSize: '0.65rem' }}>
                                  Unclaimed
                                </span>
                              </div>
                            ) : allLocView && (
                              <div className="mt-1">
                                <span
                                  className="badge"
                                  style={{
                                    backgroundColor: getLocationBadgeColor(item.location_id || item.locationId, this.props.locations),
                                    color: '#fff',
                                    fontSize: '0.65rem'
                                  }}
                                >
                                  {item.locationName || item.location_name || getLocationName((this.props.locations || []).find(l => String(l.location_id) === String(item.location_id || item.locationId)))}
                                </span>
                              </div>
                            )
                          )}
                        </div>
                      </div>
                    </small>
                  </li>
                ))}
              </ul>
            </div>
          )}

          {/* Mobile: only show when selected. Desktop: always show */}
          <div className={(this.state.selectedDraft || !isEmpty(this.state.selectedRequestimate)) ? (this.state.fromToday ? "col-lg-12" : "col-lg-8") : "col-lg-8 d-none d-lg-block"}>
            {/* Draft selected — offer Continue editing / Delete instead of the detail panel */}
            {this.state.selectedDraft && (
              <React.Fragment>
                <button
                  type="button"
                  className="btn btn-outline-secondary btn-sm mb-2 d-lg-none"
                  onClick={() => this.handleCancel()}
                >
                  <i className="fa-sharp fa-regular fa-arrow-left mr-2"></i>
                  Back to List
                </button>
                <DraftActionPanel
                  draft={this.state.selectedDraft}
                  payload={this.state.selectedDraftPayload}
                  currentUserId={this.props.user.User_id}
                  onContinue={this.handleContinueDraft}
                  onDelete={this.handleDeleteDraft}
                  deleting={this.state.deletingDraft}
                />
              </React.Fragment>
            )}

            {/* When nothing selected, just show the message */}
            {!this.state.selectedDraft && isEmpty(this.state.selectedRequestimate) && (
              <Requestimate
                selectedRequestimate={this.state.selectedRequestimate}
                calendarDays={(this.state.requestCalendarDays && this.state.requestCalendarDays.length > 0) ? this.state.requestCalendarDays : this.state.calendarDays}
                displayedList={requestimateList}
                offers={this.state.requestOffers}
                services={this.state.services}
                notes={this.state.requestNotes}
                installer={this.state.installer}
                invoice={this.state.invoice}
                mode={mode}
                userType={userType}
                typeId={typeId}
                onCancel={this.handleCancel}
                vehicleImages={this.state.vehicleImages}
                history={this.state.requestStates}
                locations={this.props.locations}
              />
            )}

            {/* When something is selected, show full detail panels */}
            {!isEmpty(this.state.selectedRequestimate) && (
              <React.Fragment>
                <div className="shadow-sm p-2 corners detail-panel-selected">
                  {/* Back button - shows on mobile always, on desktop when from Today */}
                  {this.state.fromToday ? (
                    <button
                      type="button"
                      className="btn btn-outline-secondary btn-sm mb-2"
                      onClick={() => this.handleCancel()}
                    >
                      <i className="fa-sharp fa-regular fa-arrow-left mr-2"></i>
                      Back to Today
                    </button>
                  ) : (
                    <>
                      <button
                        type="button"
                        className="btn btn-outline-secondary btn-sm mb-2 d-lg-none"
                        onClick={() => this.handleCancel()}
                      >
                        <i className="fa-sharp fa-regular fa-arrow-left mr-2"></i>
                        Back to List
                      </button>
                      <button type="button" className="close d-none d-lg-block" onClick={() => this.handleCancel()} aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </>
                  )}
                  <br />
                  <Requestimate
                    selectedRequestimate={this.state.selectedRequestimate}
                    calendarDays={(this.state.requestCalendarDays && this.state.requestCalendarDays.length > 0) ? this.state.requestCalendarDays : this.state.calendarDays}
                    displayedList={requestimateList}
                    offers={this.state.requestOffers}
                    services={this.state.services}
                    notes={this.state.requestNotes}
                    installer={this.state.installer}
                    invoice={this.state.invoice}
                    mode={mode}
                    userType={userType}
                    typeId={typeId}
                    onCancel={this.handleCancel}
                    vehicleImages={this.state.vehicleImages}
                    history={this.state.requestStates}
                    onConversationRead={this.handleConversationRead}
                  />
                </div>
                <div className="shadow-sm p-3 corners bg-white">
                  {/* Location badge — Unclaimed always in multi-loc; location name only in All Locations view */}
                  {multiLoc && (
                    isUnclaimed(this.state.selectedRequestimate) ? (
                      <span className="badge mb-2" style={{ backgroundColor: '#6c757d', color: '#fff', fontSize: '0.8rem' }}>
                        <i className="fa-sharp fa-regular fa-location-dot mr-1"></i>
                        Unclaimed
                      </span>
                    ) : allLocView && this.state.selectedRequestimate?.location_id ? (
                      <span
                        className="badge mb-2"
                        style={{
                          backgroundColor: getLocationBadgeColor(this.state.selectedRequestimate.location_id, this.props.locations),
                          color: '#fff',
                          fontSize: '0.8rem'
                        }}
                      >
                        <i className="fa-sharp fa-regular fa-location-dot mr-1"></i>
                        {this.state.selectedRequestimate.location_name || getLocationName(
                          (this.props.locations || []).find(l => String(l.location_id) === String(this.state.selectedRequestimate.location_id))
                        )}
                      </span>
                    ) : null
                  )}
                  {this.state.isMobileViewport && userType === 'installer' && isTechnician(this.props.user) ? (
                    <TechRequestPanel
                      request={this.state.selectedRequestimate}
                      services={this.state.services}
                      currentLocation={this.props.currentLocation}
                      user={this.props.user}
                      onRefresh={() => this.handleRequestimateSelect(this.state.selectedRequestimate)}
                    />
                  ) : (
                  <RequestimateState
                  userType={userType}
                  typeId={typeId}
                  userAccess={this.props.user.access}
                  userRole={this.props.user.role}
                  installer={this.state.installer}
                  request={this.state.selectedRequestimate}
                  services={this.state.services}
                  notes={this.state.requestNotes}
                  displayedList={requestimateList}
                  offers={this.state.requestOffers}
                  history={this.state.requestStates}
                  routerHistory={this.props.history}
                  invoice={this.state.invoice}
                  calendarDays={this.state.requestCalendarDays}
                  excludeDays={this.state.excludeDays}
                  startDate={this.state.startDate}
                  paymentIntentId={this.state.paymentIntentId}
                  onStartDateChange={this.handlePickStartDate}
                  template={this.state.template}
                  onTemplateChange={this.handleTemplateChange}
                  materials={this.state.materials}
                  onMaterialsChange={this.handleMaterialsChange}
                  name={this.state.customerName}
                  email={this.state.customerEmail}
                  phone={this.state.customerPhone}
                  onNameChange={this.handleNameChange}
                  onEmailChange={this.handleEmailChange}
                  onPhoneChange={this.handlePhoneChange}
                  reviewScore={this.state.reviewScore}
                  selectedPay={this.state.selectedPay}
                  checkNumber={this.state.checkNumber}
                  onReviewScoreChange={this.handleReviewChange}
                  onPaymentChange={this.handlePaymentChange}
                  onCheckNumberChange={this.handleCheckNumberChange}
                  activePage={this.state.activePage}
                  onPageChange={this.handlePageChange}
                  onDelete={this.handleDelete}
                  onAccept={this.handleAccept}
                  onAcceptEstimate={this.handleAcceptEstimate}
                  onCompleteEstimate={this.handleCompleteEstimate}
                  onReject={this.handleReject}
                  onReschedule={this.handleReschedule}
                  onDealerReschedule={this.handleDealerReschedule}
                  canDealerReschedule={this.canDealerReschedule}
                  onSelectOffer={this.handleSelect}
                  onSelectService={this.handleSelectService}
                  onSelectInstaller={this.handleSelectInstaller}
                  selectedInstaller={this.state.selectedInstaller}
                  selectedService={this.state.selectedService}
                  rowSelected={this.state.rowSelected}
                  onAssign={this.handleAssign}
                  onReceive={this.handleReceive}
                  onVINChange={this.handleVINChange}
                  vin={this.state.vin}
                  vehicleEntered={this.state.vehicleEntered}
                  vinGood={this.state.vinGood}
                  onStart={this.handleStart}
                  onFinish={this.handleFinish}
                  onComplete={this.handleComplete}
                  submitting={this.state.submitting}
                  onReopen={this.handleShowReopenModal}
                  onReview={this.handleReview}
                  onFinalize={this.handleFinalize}
                  onPayment={this.handlePayment}
                  onCollect={this.handleCollect}
                  onAddProductLine={this.handleAddProductLine}
                  onRemoveProductLine={this.handleRemoveProductLine}
                  onUpdateProductQty={this.handleUpdateProductQty}
                  addingProductId={this.state.addingProductId}
                  onSettle={this.handleSettle}
                  onDeliver={this.handleDeliver}
                  onSendDealerInvoice={this.handleSendDealerInvoice}
                  onCancel={this.handleCancel}
                  showSwipe={this.state.showSwipe}
                  closeSwipe={this.handleCloseSwipe}
                  paymentState={this.state.paymentState}
                  paymentError={this.state.paymentError}
                  onRetryPayment={this.handleRetryPayment}
                  onCancelTerminal={this.handleCancelTerminal}
                  showPO={this.state.showPO}
                  closePO={this.handleClosePO}
                  onAddPO={this.handlePurchaseOrder}
                  onPO={this.handleAddPO}
                  onEdit={this.handleEdit}
                  loading={this.state.loading}
                  availability={this.state.availability}
                  showDepositModal={this.state.showDepositModal}
                  onShowDepositModal={this.handleShowDepositModal}
                  onHideDepositModal={this.handleHideDepositModal}
                  onSaveDeposit={this.handleSaveDeposit}
                  onCreateDepositInvoice={this.handleCreateDepositInvoice}
                  onResendDepositInvoice={this.handleResendDepositInvoice}
                  onOpenDepositInvoice={this.handleOpenDepositInvoice}
                  company={this.props.company}
                  onTransferLocation={this.handleTransferLocation}

                  draftPayment={this.state.draftPayment}
                  offlineSettlement={this.state.offlineSettlement}
                  isMaterializing={this.state.isMaterializing}
                  onResendDraftEmail={this.handleResendDraftEmail}
                  onVoidInvoice={this.handleVoidAndEdit}

                  isSplitPayment={this.state.isSplitPayment}
                  collectedPayments={this.state.collectedPayments}
                  splitPaymentAmount={this.state.splitPaymentAmount}
                  selectedSplitMethod={this.state.selectedSplitMethod}
                  splitCheckNumber={this.state.splitCheckNumber}
                  finalInvoiceId={this.state.finalInvoiceId}
                  isProcessingSplitPayment={this.state.isProcessingSplitPayment}
                  isConfirmingSplitPayment={this.state.isConfirmingSplitPayment}
                  splitPaymentError={this.state.splitPaymentError}
                  remainingBalance={this.getRemainingBalance()}
                  canUseSplitPayment={this.shouldLoadPaymentData()}
                  onToggleSplitPayment={this.handleToggleSplitPayment}
                  onCollectSplitPayment={this.handleCollectSplitPayment}
                  onSplitMethodChange={(method) => this.setState({ selectedSplitMethod: method })}
                  onSplitAmountChange={(amount) => this.setState({ splitPaymentAmount: amount })}
                  onSplitCheckNumberChange={(num) => this.setState({ splitCheckNumber: num })}
                  showInvoiceLinkModal={this.state.showInvoiceLinkModal}
                  currentInvoiceLink={this.state.currentInvoiceLink}
                  onCloseInvoiceLinkModal={this.handleCloseInvoiceLinkModal}
                  onSendQuote={this.handleSendQuote}
                  onDownloadQuotePdf={this.handleDownloadQuotePdf}

                  technicians={this.state.technicians}
                  onAssignTechnician={this.handleAssignTechnician}
                  onSplitAssignment={this.handleSplitAssignment}
                  onSaveInstructions={this.handleSaveInstructions}
                  savingInstructions={this.state.savingInstructions}

                  categoryHasProducts={this.state.categoryHasProducts}
                  onSelectProduct={this.handleSelectProduct}
                  locations={this.props.locations}
                  selectedLocationId={this.props.selectedLocationId}
                  currentLocation={this.props.currentLocation}

                  checkinOdometerReading={this.state.checkinOdometerReading}
                  checkinPlate={this.state.checkinPlate}
                  checkinCarfaxOptOut={this.state.checkinCarfaxOptOut}
                  onCarfaxOptOut={this.handleCarfaxOptOut}
                />
                  )}
                </div>
              </React.Fragment>
            )}
          </div>
        </div>
        <SelectCalendar
          calendars={this.state.userCalendars}
          showList={this.state.showCalendar}
          onHide={this.handleCloseSwipe}
          onSelectCalendar={this.handleSelectCalendar}
        />
        <DeleteOrLossModal
          show={this.state.showDeleteOrLossModal}
          request={this.state.requestToDelete}
          mode="delete"
          onHide={() => this.setState({ showDeleteOrLossModal: false, requestToDelete: null })}
          onConfirm={this.handleDeleteConfirm}
        />
        <DepositRefundModal
          show={this.state.showDepositRefundModal}
          request={this.state.requestToDelete}
          depositPayment={this.state.depositRefundPayment}
          onHide={this.handleRefundCancel}
          onRefundDecision={this.handleRefundDecision}
        />
        <DeleteOrLossModal
          show={this.state.showRejectModal}
          request={this.state.requestToReject}
          mode="reject"
          onHide={() => this.setState({ showRejectModal: false, requestToReject: null })}
          onConfirm={this.handleRejectConfirm}
        />
        {/* Per-Item Material Capture Modal */}
        {this.state.showItemCaptureModal && this.state.itemCaptureService && (
          <ItemMaterialCaptureModal
            show={this.state.showItemCaptureModal}
            onHide={() => this.setState({
              showItemCaptureModal: false,
              itemCaptureService: null,
              itemCaptureItems: [],
              itemCaptureRequest: null,
              itemCaptureJob: null,
              itemCaptureMode: null
            })}
            service={this.state.itemCaptureService}
            items={this.state.itemCaptureItems}
            categoryConfig={this.state.categoryConfigs[this.state.itemCaptureService.service_category]}
            installerId={this.state.typeId}
            locationId={this.props.selectedLocationId}
            onComplete={this.handleItemCaptureComplete}
          />
        )}

        {/* Service Items Modal (cube button) */}
        {this.state.showServiceItemsModal && this.state.serviceItemsModalService && (
          <ServiceItemsModal
            show={this.state.showServiceItemsModal}
            onHide={() => this.setState({ showServiceItemsModal: false, serviceItemsModalService: null })}
            service={this.state.serviceItemsModalService}
            installerId={this.state.typeId}
            locationId={this.props.selectedLocationId}
            onItemsChanged={this.handleItemsChanged}
            readOnly={
              this.state.serviceItemsModalService?.service_state === 'finished' ||
              this.state.serviceItemsModalService?.service_state === 'completed'
            }
          />
        )}

        {/* Step Assignment Modal — opened from "Split between techs…" entry */}
        {this.state.showStepAssignmentModal && this.state.stepAssignmentService && (
          <StepAssignmentModal
            show={this.state.showStepAssignmentModal}
            onHide={() => this.setState({ showStepAssignmentModal: false, stepAssignmentService: null })}
            service={this.state.stepAssignmentService}
            technicians={this.getLocationTechnicians()}
            onTechAssignmentChanged={this.handleTechAssignmentChanged}
          />
        )}

        {/* Item Completion Guard Modal */}
        {this.state.showItemGuardModal && this.state.itemGuardData && (
          <ItemCompletionGuardModal
            show={this.state.showItemGuardModal}
            onHide={() => this.setState({ showItemGuardModal: false, itemGuardData: null })}
            serviceName={this.state.itemGuardData.serviceName}
            taskStatus={this.state.itemGuardData.taskStatus}
            onForceComplete={this.state.itemGuardData.retryCallback}
          />
        )}

        {/* VIN Required Modal */}
        {this.state.showVINRequiredModal && this.state.vinRequiredRequest && (
          <VINRequiredModal
            show={this.state.showVINRequiredModal}
            onHide={() => this.setState({ showVINRequiredModal: false, vinRequiredRequest: null, vinRequiredStartDate: null })}
            requestId={this.state.vinRequiredRequest.requestId}
            request={this.state.vinRequiredRequest}
            onVINVerified={this.handleVINVerifiedForComplete}
            onSkip={this.handleVINSkipForComplete}
          />
        )}

        {/* CarFax Data Modal */}
        {this.state.showCarFaxDataModal && this.state.carfaxDataRequest && (
          <CarFaxDataModal
            show={this.state.showCarFaxDataModal}
            requestId={this.state.carfaxDataRequest.requestId}
            request={this.state.carfaxDataRequest}
            company={this.props.company}
            existingOdometer={this.state.checkinOdometerReading}
            existingPlate={this.state.checkinPlate}
            onComplete={this.handleCarFaxDataComplete}
            onOptOut={this.handleCarfaxOptOut}
          />
        )}

        {/* Completion Confirmation Modal */}
        {this.state.showCompletionConfirmModal && this.state.completionConfirmData && (
          <Modal show={true} onHide={this.handleCompletionCancelled} centered>
            <Modal.Header closeButton>
              <Modal.Title>Confirm Job Completion</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="alert alert-warning">
                <strong>{this.state.completionConfirmData.unfinishedServices.length} of {this.state.completionConfirmData.servicesArray.length}</strong> services have not been individually finished.
              </div>
              <ul className="list-group">
                {this.state.completionConfirmData.servicesArray.map((svc, idx) => (
                  <li key={idx} className="list-group-item d-flex justify-content-between align-items-center">
                    {svc.serviceRequested || svc.service_name || svc.serviceName || 'Service'}
                    <span className={`badge badge-${svc.service_state === 'finished' ? 'success' : 'warning'} badge-pill`}>
                      {svc.service_state || 'pending'}
                    </span>
                  </li>
                ))}
              </ul>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={this.handleCompletionCancelled}>
                Cancel
              </Button>
              <Button variant="warning" onClick={this.handleCompletionConfirmed}>
                Yes, Complete Job
              </Button>
            </Modal.Footer>
          </Modal>
        )}

        <DuplicateVinModal
          show={this.state.showInvoiceDupModal}
          title="Another job for this VIN was already invoiced"
          intro="Another request for this vehicle has already been finished or invoiced. Invoice this one too?"
          confirmLabel="Invoice this one too"
          onConfirm={this.handleInvoiceDupConfirm}
          onCancel={this.handleInvoiceDupCancel}
        />

        {/* Reopen Job Modal */}
        <ReopenJobModal
          show={this.state.showReopenModal}
          request={this.state.reopenRequest}
          onHide={this.handleHideReopenModal}
          onConfirm={this.handleReopenJob}
        />

        {/* Stripe Recovery Modal — opens when dealer materialize fails */}
        <StripeRecoveryModal
          show={this.state.stripeRecoveryModal.open}
          onHide={this.closeStripeRecoveryModal}
          request={this.state.stripeRecoveryModal.request}
          reason={this.state.stripeRecoveryModal.reason}
          locationName={this.state.stripeRecoveryModal.locationName}
          detail={this.state.stripeRecoveryModal.detail}
          readyLocations={this.state.readyLocations}
          loadingReadyLocations={this.state.loadingReadyLocations}
          onFetchReadyLocations={this.fetchReadyLocations}
          onTransferAndInvoice={this.handleTransferAndInvoice}
          onOpenStripeDashboard={this.handleOpenStripeDashboard}
          onRecheckReadiness={this.handleRecheckReadiness}
        />

        {/* Assign / Transfer Location Modal */}
        {multiLoc && (() => {
          const req = this.state.assignLocationRequest;
          const isTransfer = req && !isUnclaimed(req);
          const currentLocId = req ? String(req.location_id || req.locationId || '') : '';
          const availableLocations = isTransfer
            ? (this.props.locations || []).filter(loc => String(loc.location_id) !== currentLocId)
            : (this.props.locations || []);

          return (
            <Modal
              show={this.state.showAssignLocationModal}
              onHide={() => this.setState({ showAssignLocationModal: false, assignLocationRequest: null, assignLocationCallback: null, modalSelectedLocationId: '' })}
              centered
            >
              <Modal.Header closeButton>
                <Modal.Title>{isTransfer ? 'Transfer to Location' : 'Assign Location'}</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <p>{isTransfer
                  ? 'Select the location to transfer this request to.'
                  : 'This request must be assigned to a location before you can proceed.'
                }</p>
                <Form.Group>
                  <Form.Label>Select a location</Form.Label>
                  <Form.Control
                    as="select"
                    value={this.state.modalSelectedLocationId || ''}
                    onChange={(e) => this.setState({ modalSelectedLocationId: e.target.value })}
                  >
                    <option value="" disabled>Choose location...</option>
                    {availableLocations.map(loc => (
                      <option key={loc.location_id} value={loc.location_id}>
                        {getLocationName(loc)}
                      </option>
                    ))}
                  </Form.Control>
                </Form.Group>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  variant="secondary"
                  onClick={() => this.setState({ showAssignLocationModal: false, assignLocationRequest: null, assignLocationCallback: null, modalSelectedLocationId: '' })}
                >
                  Cancel
                </Button>
                <Button
                  variant="success"
                  disabled={!this.state.modalSelectedLocationId}
                  onClick={async () => {
                    const locId = Number(this.state.modalSelectedLocationId);
                    const { assignLocationRequest, assignLocationCallback } = this.state;
                    if (!locId || !assignLocationRequest) return;
                    await this.handleAssignLocation(assignLocationRequest, locId);
                    this.setState({ showAssignLocationModal: false, assignLocationRequest: null, assignLocationCallback: null, modalSelectedLocationId: '' });
                    if (assignLocationCallback) assignLocationCallback();
                  }}
                >
                  {isTransfer ? 'TRANSFER' : 'ASSIGN & CONTINUE'}
                </Button>
              </Modal.Footer>
            </Modal>
          );
        })()}
      </React.Fragment>
    );
  }
}
export default withRouter(Requestimates);